import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  printStackTrace18lnx7a39cni as printStackTrace,
  Unit_instanceat14thlj150z as Unit_instance,
  CancellationException3b36o9qz53rgr as CancellationException,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  toSet2orjxp16sotqu as toSet,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  addAll21mdhg523wnoa as addAll_0,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz629330ogi7dvp as Duration__hashCode_impl_u4exz6,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toHexString5bhtjxqec7ow as toHexString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  sorted354mfsiv4s7x5 as sorted,
  toString30pk9tzaqopn as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  RuntimeException1r3t0zl97011n as RuntimeException,
  captureStack1fzi4aczwc4hg as captureStack,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  Enum3alwj03lh1n41 as Enum,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  numberToLong1a4cndvg6c52s as numberToLong,
  toDurationba1nlt78o6vu as toDuration_0,
  mapOf1xd03cq9cnmy8 as mapOf,
  toInt2q8uldh7sc951 as toInt,
  getOrNullef5jbxih7r4f as getOrNull,
  _UByteArray___init__impl__ip4y9n3sp5zyufbcv0v as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hv1encpe8trq9zx as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qr1jhbnu489etgz as _UByte___get_data__impl__jof9qr,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr3elpl3cwdan58 as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  copyOf39s58md6y6rn6 as copyOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  println2shhhgwwt4c61 as println,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toShort36kaw0zjdq3ex as toShort,
  _UByte___init__impl__g9hnc43i8t7wecfr79w as _UByte___init__impl__g9hnc4,
  UBytep4j7r1t64gz1 as UByte,
  UByte__hashCode_impl_mmczcb2bk1orv63vhkp as UByte__hashCode_impl_mmczcb,
  createThis2j2avj17cvnv2 as createThis,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  fill3lmv1pckd4inv as fill,
  fill34ox8qmmmh3u3 as fill_0,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  _UInt___init__impl__l7qpdl2x2ja0qtrydmg as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw1wfqgh301wggv as _UInt___get_data__impl__f0vqqw,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getOrNull1d60i0672n7ns as getOrNull_0,
  get_lastIndexx0qsydpfv3mu as get_lastIndex,
  compareTo3ankvs086tmwq as compareTo,
  boxApply1qmzdb3dh90hg as boxApply,
  KProperty1ca4yb4wlo496 as KProperty1,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
} from './kotlin-kotlin-stdlib.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  get_milliseconds20vru1dkca6bq as get_milliseconds,
  get_secondsjblpw5qd4dzj as get_seconds,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_0,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  get_niceStr3crhxydmlnaoj as get_niceStr,
  extract2vhru1ihy4ogl as extract,
  hasFlagsibfubl68mj8u as hasFlags,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  delay1blitpytzu6gr as delay,
  yield17af0dtgvr9x7 as yield_0,
  delay1f60wyf8ua1gc as delay_0,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import {
  readBytesUpTo2jsx0o5buj2sw as readBytesUpTo,
  readStream3f0dxaq1c55fg as readStream,
  toSyncOrNull2d7etdx5kh7ns as toSyncOrNull,
  readBytesUpTo1px2t44z4b9v7 as readBytesUpTo_0,
  openSync2m3qn99fqytu0 as openSync,
  readString20u8kjncp0xlx as readString,
  readString3h14fm47a2tde as readString_0,
  readBytesExact305h8zdeltghk as readBytesExact,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  readS16LE3rt2utyxlgw3g as readS16LE,
  readS32LE2r371m40u4y6y as readS32LE,
  readU32LE31t9li7x6s60w as readU32LE,
  MemorySyncStreamw5bwb9yy0cam as MemorySyncStream,
  toAsyncc87ncfb6nti7 as toAsync,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  binarySearch1lxbagta5e4q4 as binarySearch,
  _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2 as _BSearchResult___get_nearIndex__impl__s8nq43,
  ByteArrayDeque2dezgzzyyl6zm as ByteArrayDeque,
  ShortArrayDeque13dn2tr6asm80 as ShortArrayDeque,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  _UByteArrayInt___init__impl__xif7bu3la1vncefaitd as _UByteArrayInt___init__impl__xif7bu,
  _UByteArrayInt___get_bytes__impl__pj0ilcub6wlvph43r as _UByteArrayInt___get_bytes__impl__pj0ilc,
  UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2 as UByteArrayInt__get_impl_px6q8a,
  getU83agrw8yj0shar as getU8,
  indexOf1wbggs5i7ilsw as indexOf,
  _UByteArrayInt___init__impl__xif7bu29rfv0s29knch as _UByteArrayInt___init__impl__xif7bu_0,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk as _UByteArrayInt___init__impl__xif7bu_1,
  UByteArrayInt__set_impl_gn45323mc9aqt29pp9p as UByteArrayInt__set_impl_gn4532,
  arraycopy52dxe7vhzf14 as arraycopy,
  arraycopy3n78tfzvkl4kg as arraycopy_0,
  UByteArrayInt__set_impl_gn45321v79kdhd4y5qt as UByteArrayInt__set_impl_gn4532_0,
  UByteArrayInt__fill$default_impl_mdydxi1wz00ttbtxw3z as UByteArrayInt__fill$default_impl_mdydxi,
  getS16LE39jsuv9u9gi4y as getS16LE,
  getS24LE1b229asvs5i3l as getS24LE,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  Charsets_instance2e55bmt8joybi as Charsets_instance,
  readStringzinkjpjt71hyo as readStringz,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  _AudioSampleArray___init__impl__qpxoq02y04g82w4ty79 as _AudioSampleArray___init__impl__qpxoq0,
  _AudioSample___init__impl__s54gd52xugxuumb5p5l as _AudioSample___init__impl__s54gd5,
  AudioSampleArray__set_impl_tqgfwk2e4yme6xw91vg as AudioSampleArray__set_impl_tqgfwk,
  _AudioSample___get_short__impl__uk8ygu25qxorykipf8f as _AudioSample___get_short__impl__uk8ygu,
  AudioSampleArray__asShortArray_impl_iyd0md153iqk9vsos7c as AudioSampleArray__asShortArray_impl_iyd0md,
  AudioSampleArray__get_impl_w0l0xc3ifihtwr00dm3 as AudioSampleArray__get_impl_w0l0xc,
  _AudioSampleArray___get_size__impl__8l8tm8x01vap0727wl as _AudioSampleArray___get_size__impl__8l8tm8,
  AudioSampleArray262uyoodhuuvf as AudioSampleArray,
  AudioSamples3pmkh9en9mrjs as AudioSamples,
  AudioData3ewbxcbopprh8 as AudioData,
  ReadonlySoundProps270enpa6r4amt as ReadonlySoundProps,
  SoundProps3stqh6vq4ra4p as SoundProps,
  get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider,
  Companion_getInstance2wrvcuzneq6bn as Companion_getInstance_1,
  AudioSampleArray__fill$default_impl_gh9lh0607zwvqcotvv as AudioSampleArray__fill$default_impl_gh9lh0,
  Companion_instance1o81m7d7a4ex as Companion_instance,
} from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getUnderlyingUnscapedFilej1r5tpfxb7a7 as getUnderlyingUnscapedFile,
  get_baseName2yf63efofm8te as get_baseName,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { Companion_getInstance1yq7a1f60lp2k as Companion_getInstance_2 } from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  onCancel134048q5p9j85 as onCancel,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  e5v(formats) {
    return (new AudioFormats()).i5v(formats.slice());
  }
}
class AudioFormat {
  constructor(exts) {
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.AudioFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.h(tmp$ret$3);
    }
    tmp.j5v_1 = toSet(destination);
  }
  o5v() {
    return this.j5v_1;
  }
  k5v(data, props, $completion) {
    return null;
  }
  p5v(data, props, $completion) {
    return null;
  }
  n5v(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStream__ydjika.bind(VOID, this, data, props), $completion);
  }
  q5v(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamOrError__s0emn1.bind(VOID, this, data, props), $completion);
  }
  s3() {
    return 'AudioFormat';
  }
  toString() {
    return this.s3() + '(' + toString(sorted(this.o5v())) + ')';
  }
}
class AudioFormats extends AudioFormat {
  constructor() {
    super([]);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.g5v_1 = ArrayList.j1();
    this.h5v_1 = null;
  }
  o5v() {
    if (this.h5v_1 == null) {
      var tmp = this;
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.g5v_1;
      var destination = ArrayList.j1();
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.audio.format.AudioFormats.<get-extensions>.<anonymous>' call
        var list = element.o5v();
        addAll(destination, list);
      }
      tmp.h5v_1 = toSet(destination);
    }
    return ensureNotNull(this.h5v_1);
  }
  i5v(formats) {
    // Inline function 'kotlin.apply' call
    var this_0 = invalidate(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.AudioFormats.register.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this_0.g5v_1;
    addAll_0(this_1, formats);
    return this_0;
  }
  k5v(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh.bind(VOID, this, data, props), $completion);
  }
  p5v(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamInternal__hls877.bind(VOID, this, data, props), $completion);
  }
}
class Info {
  constructor(duration, channels, decodingTime) {
    var tmp;
    if (duration === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = duration;
    }
    duration = tmp;
    channels = channels === VOID ? 2 : channels;
    decodingTime = decodingTime === VOID ? null : decodingTime;
    this.r5v_1 = new Mixin();
    this.s5v_1 = duration;
    this.t5v_1 = channels;
    this.u5v_1 = decodingTime;
  }
  yz(_set____db54di) {
    this.r5v_1.yz(_set____db54di);
  }
  zz() {
    return this.r5v_1.zz();
  }
  v5v() {
    var tmp0_elvis_lhs = this.s5v_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'Info(duration=' + get_niceStr(get_milliseconds(this.v5v())) + 'ms, channels=' + this.t5v_1 + ')';
  }
  hashCode() {
    var tmp;
    var tmp_0 = this.s5v_1;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      tmp = 0;
    } else {
      tmp = Duration__hashCode_impl_u4exz6(this.s5v_1);
    }
    var result = tmp;
    result = imul(result, 31) + this.t5v_1 | 0;
    var tmp_1 = imul(result, 31);
    var tmp_2;
    var tmp_3 = this.u5v_1;
    if ((tmp_3 == null ? null : new Duration(tmp_3)) == null) {
      tmp_2 = 0;
    } else {
      tmp_2 = Duration__hashCode_impl_u4exz6(this.u5v_1);
    }
    result = tmp_1 + tmp_2 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    var tmp = this.s5v_1;
    var tmp_0 = tmp == null ? null : new Duration(tmp);
    var tmp_1 = tmp0_other_with_cast.s5v_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Duration(tmp_1)))
      return false;
    if (!(this.t5v_1 === tmp0_other_with_cast.t5v_1))
      return false;
    var tmp_2 = this.u5v_1;
    var tmp_3 = tmp_2 == null ? null : new Duration(tmp_2);
    var tmp_4 = tmp0_other_with_cast.u5v_1;
    if (!equals(tmp_3, tmp_4 == null ? null : new Duration(tmp_4)))
      return false;
    return true;
  }
}
class AudioFormat$decodeStream$slambda {
  constructor(this$0, $data, $props) {
    this.c5w_1 = this$0;
    this.d5w_1 = $data;
    this.e5w_1 = $props;
  }
  k1q($this$withContext, $completion) {
    return this.c5w_1.p5v(this.d5w_1, this.e5w_1, $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.l5v_1 = new AudioDecodingProps();
    this.m5v_1 = new AudioDecodingProps(false, false);
  }
}
class AudioDecodingProps {
  constructor(exactTimings, readInMemory, formats, maxSamples, dispatcher) {
    Companion_getInstance_4();
    exactTimings = exactTimings === VOID ? null : exactTimings;
    readInMemory = readInMemory === VOID ? true : readInMemory;
    formats = formats === VOID ? null : formats;
    maxSamples = maxSamples === VOID ? 39690000 : maxSamples;
    dispatcher = dispatcher === VOID ? null : dispatcher;
    this.w5v_1 = new Mixin();
    this.x5v_1 = exactTimings;
    this.y5v_1 = readInMemory;
    this.z5v_1 = formats;
    this.a5w_1 = maxSamples;
    this.b5w_1 = dispatcher;
  }
  yz(_set____db54di) {
    this.w5v_1.yz(_set____db54di);
  }
  zz() {
    return this.w5v_1.zz();
  }
  toString() {
    return 'AudioDecodingProps(exactTimings=' + this.x5v_1 + ', readInMemory=' + this.y5v_1 + ', formats=' + toString_0(this.z5v_1) + ', maxSamples=' + this.a5w_1 + ', dispatcher=' + toString_0(this.b5w_1) + ')';
  }
  hashCode() {
    var result = this.x5v_1 == null ? 0 : getBooleanHashCode(this.x5v_1);
    result = imul(result, 31) + getBooleanHashCode(this.y5v_1) | 0;
    result = imul(result, 31) + (this.z5v_1 == null ? 0 : hashCode(this.z5v_1)) | 0;
    result = imul(result, 31) + this.a5w_1 | 0;
    result = imul(result, 31) + (this.b5w_1 == null ? 0 : hashCode(this.b5w_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AudioDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof AudioDecodingProps ? other : THROW_CCE();
    if (!(this.x5v_1 == tmp0_other_with_cast.x5v_1))
      return false;
    if (!(this.y5v_1 === tmp0_other_with_cast.y5v_1))
      return false;
    if (!equals(this.z5v_1, tmp0_other_with_cast.z5v_1))
      return false;
    if (!(this.a5w_1 === tmp0_other_with_cast.a5w_1))
      return false;
    if (!equals(this.b5w_1, tmp0_other_with_cast.b5w_1))
      return false;
    return true;
  }
}
class InvalidAudioFormatException extends RuntimeException {
  static i5w(message) {
    var $this = this.wa(message);
    captureStack($this, $this.h5w_1);
    return $this;
  }
}
class MP3Base extends AudioFormat {
  constructor() {
    super(['mp3']);
  }
  k5v(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh_0.bind(VOID, this, data, props), $completion);
  }
}
class MP3 extends MP3Base {
  constructor() {
    Companion_getInstance_5();
    super();
  }
}
class Companion_1 extends MP3 {
  constructor() {
    Companion_instance_2 = null;
    super();
    Companion_instance_2 = this;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = to(item.m5w_1, item);
      destination.h(tmp$ret$0);
    }
    tmp.o5w_1 = toMap(destination);
  }
}
class ChannelMode extends Enum {
  constructor(name, ordinal, id, channels) {
    super(name, ordinal);
    this.m5w_1 = id;
    this.n5w_1 = channels;
  }
}
class Mp3Info {
  constructor(version, layer, bitrate, samplingRate, channelMode, frameSize, samples) {
    this.p5w_1 = version;
    this.q5w_1 = layer;
    this.r5w_1 = bitrate;
    this.s5w_1 = samplingRate;
    this.t5w_1 = channelMode;
    this.u5w_1 = frameSize;
    this.v5w_1 = samples;
  }
  toString() {
    return 'Mp3Info(version=' + this.p5w_1 + ', layer=' + this.q5w_1 + ', bitrate=' + this.r5w_1 + ', samplingRate=' + this.s5w_1 + ', channelMode=' + this.t5w_1.toString() + ', frameSize=' + this.u5w_1 + ', samples=' + this.v5w_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.p5w_1);
    result = imul(result, 31) + this.q5w_1 | 0;
    result = imul(result, 31) + this.r5w_1 | 0;
    result = imul(result, 31) + this.s5w_1 | 0;
    result = imul(result, 31) + this.t5w_1.hashCode() | 0;
    result = imul(result, 31) + this.u5w_1 | 0;
    result = imul(result, 31) + this.v5w_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Mp3Info))
      return false;
    var tmp0_other_with_cast = other instanceof Mp3Info ? other : THROW_CCE();
    if (!(this.p5w_1 === tmp0_other_with_cast.p5w_1))
      return false;
    if (!(this.q5w_1 === tmp0_other_with_cast.q5w_1))
      return false;
    if (!(this.r5w_1 === tmp0_other_with_cast.r5w_1))
      return false;
    if (!(this.s5w_1 === tmp0_other_with_cast.s5w_1))
      return false;
    if (!this.t5w_1.equals(tmp0_other_with_cast.t5w_1))
      return false;
    if (!(this.u5w_1 === tmp0_other_with_cast.u5w_1))
      return false;
    if (!(this.v5w_1 === tmp0_other_with_cast.v5w_1))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z5w_1 = ['2.5', 'x', '2', '1'];
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.a5x_1 = new Int32Array([-1, 3, 2, 1]);
    var tmp_1 = this;
    var tmp_2 = this.f5x(1, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$4 = new Int32Array([0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448]);
    var tmp_3 = to(tmp_2, tmp$ret$4);
    var tmp_4 = this.f5x(1, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$5 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384]);
    var tmp_5 = to(tmp_4, tmp$ret$5);
    var tmp_6 = this.f5x(1, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$6 = new Int32Array([0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320]);
    var tmp_7 = to(tmp_6, tmp$ret$6);
    var tmp_8 = this.f5x(2, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$7 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256]);
    var tmp_9 = to(tmp_8, tmp$ret$7);
    var tmp_10 = this.f5x(2, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$8 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    var tmp_11 = to(tmp_10, tmp$ret$8);
    var tmp_12 = this.f5x(2, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$9 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    tmp_1.b5x_1 = mapOf([tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, to(tmp_12, tmp$ret$9)]);
    var tmp_13 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$10 = new Int32Array([44100, 48000, 32000]);
    var tmp_14 = to('1', tmp$ret$10);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$11 = new Int32Array([22050, 24000, 16000]);
    var tmp_15 = to('2', tmp$ret$11);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$12 = new Int32Array([11025, 12000, 8000]);
    tmp_13.c5x_1 = mapOf([tmp_14, tmp_15, to('2.5', tmp$ret$12)]);
    this.d5x_1 = mapOf([to(1, mapOf([to(1, 384), to(2, 1152), to(3, 1152)])), to(2, mapOf([to(1, 384), to(2, 1152), to(3, 576)]))]);
  }
  f5x(version, layer) {
    return imul(version, 10) + layer | 0;
  }
  e5x(f4) {
    var b0 = UByteArrayInt__get_impl_px6q8a(f4, 0);
    var b1 = UByteArrayInt__get_impl_px6q8a(f4, 1);
    var b2 = UByteArrayInt__get_impl_px6q8a(f4, 2);
    var b3 = UByteArrayInt__get_impl_px6q8a(f4, 3);
    if (!(b0 === 255)) {
      get_invalidOp();
    }
    var version = this.z5w_1[extract(b1, 3, 2)];
    var simple_version = version === '2.5' ? 2 : toInt(version);
    var layer = this.a5x_1[extract(b1, 1, 2)];
    var protection_bit = extract(b1, 0, 1);
    var bitrate_key = this.f5x(simple_version, layer);
    var bitrate_idx = extract(b2, 4, 4);
    var tmp6_safe_receiver = this.b5x_1.f3(bitrate_key);
    var tmp0_elvis_lhs = tmp6_safe_receiver == null ? null : getOrNull(tmp6_safe_receiver, bitrate_idx);
    var bitrate = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp7_safe_receiver = this.c5x_1.f3(version);
    var tmp1_elvis_lhs = tmp7_safe_receiver == null ? null : getOrNull(tmp7_safe_receiver, extract(b2, 2, 2));
    var sample_rate = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var padding_bit = extract(b2, 1, 1);
    var private_bit = extract(b2, 0, 1);
    var channelMode = ensureNotNull(Companion_getInstance_6().o5w_1.f3(extract(b3, 6, 2)));
    var mode_extension_bits = extract(b3, 4, 2);
    var copyright_bit = extract(b3, 3, 1);
    var original_bit = extract(b3, 2, 1);
    var emphasis = extract(b3, 0, 2);
    var tmp = framesize(this, layer, bitrate, sample_rate, padding_bit);
    var tmp8_safe_receiver = this.d5x_1.f3(simple_version);
    var tmp2_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.f3(layer);
    return new Mp3Info(version, layer, bitrate, sample_rate, channelMode, tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
  }
}
class SeekingTable {
  constructor(microseconds, filePositions) {
    this.i5x_1 = microseconds;
    this.j5x_1 = filePositions;
  }
  k5x() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = this.i5x_1.e1(this.i5x_1.f1() - 1 | 0);
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  l5x(rate) {
    return numberToLong(get_seconds(this.k5x()) * rate);
  }
  m5x(time) {
    // Inline function 'korlibs.time.microseconds' call
    var searchMicro = _Duration___get_inWholeNanoseconds__impl__r5x4mr(time).n4() / 1000.0;
    var result = binarySearch(this.i5x_1, searchMicro);
    return numberToLong(this.j5x_1.e1(_BSearchResult___get_nearIndex__impl__s8nq43(result)));
  }
}
class Parser {
  constructor(data, dataLength) {
    Companion_getInstance_7();
    this.w5w_1 = data;
    this.x5w_1 = dataLength;
    this.y5w_1 = null;
  }
  h5x($completion) {
    return _getDuration$default(this, true, VOID, $completion);
  }
  g5x($completion) {
    return _getDuration$default(this, false, VOID, $completion);
  }
  n5x($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getSeekingTable__ywx4sa.bind(VOID, this), $completion);
  }
}
class MP3Decoder extends AudioFormat {
  constructor() {
    Companion_getInstance_8();
    super(['mp3']);
    this.p5x_1 = Minimp3AudioFormat_getInstance();
  }
  k5v(data, props, $completion) {
    return this.p5x_1.k5v(data, props, $completion);
  }
  p5v(data, props, $completion) {
    return this.p5x_1.n5v(data, props, $completion);
  }
  toString() {
    return 'NativeMp3DecoderFormat';
  }
}
class Companion_4 extends MP3Decoder {
  constructor() {
    Companion_instance_5 = null;
    super();
    Companion_instance_5 = this;
  }
}
class MiniMp3Program {
  constructor() {
    Companion_getInstance_10();
    this.j5y_1 = new Int32Array(3);
    this.k5y_1 = new Float32Array(9);
    this.l5y_1 = new Float32Array(9);
    this.m5y_1 = new Float32Array(4);
    this.n5y_1 = new Float32Array(4);
    this.o5y_1 = Mp3Scratch.n64();
    this.p5y_1 = new Bs();
  }
  p5z(dst, src, size) {
    arraycopy(src.v64_1, src.w64_1, dst.v64_1, dst.w64_1, size);
  }
  q5z(dst, src, size) {
    arraycopy_0(src.r64_1, src.s64_1, dst.r64_1, dst.s64_1, size);
  }
  r5z(bs, data, bytes) {
    bs.c64_1 = data;
    bs.d64_1 = 0;
    bs.e64_1 = imul(bytes, 8);
  }
  s5z(bs, n) {
    var cache = 0;
    var s = bs.d64_1 & 7;
    var shl = n + s | 0;
    var p = bs.c64_1.q64(bs.d64_1 >>> 3 | 0);
    bs.d64_1 = bs.d64_1 + n | 0;
    if (bs.d64_1 > bs.e64_1)
      return 0;
    var next = p.s1() & (255 >>> s | 0);
    p = p.c4();
    $l$loop: while (true) {
      shl = shl - 8 | 0;
      if (shl <= 0)
        break $l$loop;
      cache = cache | next << shl;
      next = p.s1();
      p = p.c4();
    }
    return cache | (next >>> (-shl | 0) | 0);
  }
  t5z(h) {
    var h0 = h.e1(0);
    var h1 = h.e1(1);
    var h2 = h.e1(2);
    return h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226) && !((h1 >> 1 & 3) === 0) && !(h2 >> 4 === 15) && !((h2 >> 2 & 3) === 3);
  }
  u5z(h1, h2) {
    return toInt_0(this.t5z(h2) && ((h1.e1(1) ^ h2.e1(1)) & 254) === 0 && ((h1.e1(2) ^ h2.e1(2)) & 12) === 0 && (toInt_0((h1.e1(2) & 240) === 0, this) ^ toInt_0((h2.e1(2) & 240) === 0, this)) === 0, this);
  }
  v5z(h) {
    return imul(2, UByteArrayInt__get_impl_px6q8a(Companion_getInstance_10().f63_1[toInt_0(!((h.e1(1) & 8) === 0), this)][(h.e1(1) >> 1 & 3) - 1 | 0].g14_1, h.e1(2) >> 4));
  }
  w5z(h) {
    var g_hz = Companion_getInstance_10().e63_1;
    return g_hz[h.e1(2) >> 2 & 3] >> toInt_0((h.e1(1) & 8) === 0, this) >> toInt_0((h.e1(1) & 16) === 0, this);
  }
  x5z(h) {
    return (h.e1(1) & 6) === 6 ? 384 : 1152 >> toInt_0((h.e1(1) & 14) === 2, this);
  }
  y5z(h, free_format_size) {
    var frame_bytes = imul(imul(this.x5z(h), this.v5z(h)), 125) / this.w5z(h) | 0;
    if ((h.e1(1) & 6) === 6) {
      frame_bytes = frame_bytes & -4;
    }
    return !(frame_bytes === 0) ? frame_bytes : free_format_size;
  }
  z5z(h) {
    return !((h.e1(2) & 2) === 0) ? (h.e1(1) & 6) === 6 ? 4 : 1 : 0;
  }
  a60(hdr, sci) {
    var alloc = Companion_getInstance_10().t63_1;
    var mode = hdr.e1(3) >> 6 & 3;
    var nbands;
    var stereo_bands;
    switch (mode) {
      case 3:
        stereo_bands = 0;
        break;
      case 1:
        stereo_bands = ((hdr.e1(3) >> 4 & 3) << 2) + 4 | 0;
        break;
      default:
        stereo_bands = 32;
        break;
    }
    if ((hdr.e1(1) & 6) === 6) {
      alloc = Companion_getInstance_10().t63_1;
      nbands = 32;
    } else if ((hdr.e1(1) & 8) === 0) {
      alloc = Companion_getInstance_10().u63_1;
      nbands = 30;
    } else {
      var sample_rate_idx = hdr.e1(2) >> 2 & 3;
      var kbps = this.v5z(hdr) >> toInt_0(!(mode === 3), this);
      if (kbps === 0)
        kbps = 192;
      alloc = Companion_getInstance_10().v63_1;
      nbands = 27;
      if (kbps < 56) {
        alloc = Companion_getInstance_10().w63_1;
        nbands = sample_rate_idx === 2 ? 12 : 8;
      } else if (kbps >= 96 && !(sample_rate_idx === 1)) {
        nbands = 30;
      }
    }
    sci.v65_1 = nbands;
    sci.w65_1 = stereo_bands > nbands ? nbands : stereo_bands;
    return alloc;
  }
  b60(bs, pba, scfcod, bands, scf) {
    var scfOffset = 0;
    var g_deq_L12 = Companion_getInstance_10().d63_1;
    var inductionVariable = 0;
    if (inductionVariable < bands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var s = 0.0;
        var ba = UByteArrayInt__get_impl_px6q8a(pba, i);
        var mask = !(ba === 0) ? 4 + (19 >> UByteArrayInt__get_impl_px6q8a(scfcod, i) & 3) | 0 : 0;
        var m = 4;
        while (!(m === 0)) {
          if (!((mask & m) === 0)) {
            var b = this.s5z(bs, 6);
            s = g_deq_L12[(imul(ba, 3) - 6 | 0) + (b % 3 | 0) | 0] * (2097152 >> (b / 3 | 0));
          }
          scf.y64(scfOffset, s);
          m = m >> 1;
          scfOffset = scfOffset + 1 | 0;
        }
      }
       while (inductionVariable < bands);
  }
  c60(hdr, bs, sci) {
    var g_bitalloc_code_tab = new UByteArrayIntPtr(Companion_getInstance_10().o63_1);
    var subband_alloc = this.a60(hdr, sci);
    var subband_alloc_n = 0;
    var k = 0;
    var ba_bits = 0;
    var ba_code_tab = g_bitalloc_code_tab;
    var inductionVariable = 0;
    var last = sci.v65_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ba = 0;
        if (i === k) {
          var tmp = k;
          // Inline function 'kotlin.UByte.toInt' call
          var this_0 = subband_alloc[subband_alloc_n].a64_1;
          k = tmp + (_UByte___get_data__impl__jof9qr(this_0) & 255) | 0;
          // Inline function 'kotlin.UByte.toInt' call
          var this_1 = subband_alloc[subband_alloc_n].z63_1;
          ba_bits = _UByte___get_data__impl__jof9qr(this_1) & 255;
          // Inline function 'kotlin.UByte.toInt' call
          var this_2 = subband_alloc[subband_alloc_n].y63_1;
          var tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
          ba_code_tab = g_bitalloc_code_tab.q64(tmp$ret$2);
          subband_alloc_n = subband_alloc_n + 1 | 0;
        }
        ba = ba_code_tab.e1(this.s5z(bs, ba_bits));
        UByteArrayInt__set_impl_gn4532(sci.x65_1, imul(2, i), ba);
        if (i < sci.w65_1) {
          ba = ba_code_tab.e1(this.s5z(bs, ba_bits));
        }
        UByteArrayInt__set_impl_gn4532(sci.x65_1, imul(2, i) + 1 | 0, !(sci.w65_1 === 0) ? ba : 0);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = imul(2, sci.v65_1);
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.y65_1, i_0, !(UByteArrayInt__get_impl_px6q8a(sci.x65_1, i_0) === 0) ? (hdr.e1(1) & 6) === 6 ? 2 : this.s5z(bs, 2) : 6);
      }
       while (inductionVariable_0 < last_0);
    this.b60(bs, sci.x65_1, sci.y65_1, imul(sci.v65_1, 2), new FloatArrayPtr(sci.u65_1));
    var inductionVariable_1 = sci.w65_1;
    var last_1 = sci.v65_1;
    if (inductionVariable_1 < last_1)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.x65_1, imul(2, i_1) + 1 | 0, 0);
      }
       while (inductionVariable_1 < last_1);
  }
  d60(grbuf, bs, sci, group_size) {
    var choff = 576;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dst = grbuf.q64(imul(group_size, j));
        var inductionVariable_0 = 0;
        var last = imul(2, sci.v65_1);
        if (inductionVariable_0 < last)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ba = UByteArrayInt__get_impl_px6q8a(sci.x65_1, i);
            if (!(ba === 0)) {
              if (ba < 17) {
                var half = (1 << (ba - 1 | 0)) - 1 | 0;
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < group_size)
                  do {
                    var k = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    dst.y64(k, this.s5z(bs, ba) - half | 0);
                  }
                   while (inductionVariable_1 < group_size);
              } else {
                var mod = (2 << (ba - 17 | 0)) + 1 | 0;
                var code = this.s5z(bs, (mod + 2 | 0) - (mod >> 3) | 0);
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < group_size)
                  do {
                    var k_0 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    dst.y64(k_0, (code % mod | 0) - (mod / 2 | 0) | 0);
                    code = code / mod | 0;
                  }
                   while (inductionVariable_2 < group_size);
              }
            }
            dst = dst.q64(choff);
            choff = 18 - choff | 0;
          }
           while (inductionVariable_0 < last);
      }
       while (inductionVariable < 4);
    return imul(group_size, 4);
  }
  e60(sci, scf, dst) {
    var scf_0 = scf;
    var dst_0 = dst;
    this.p5z(dst_0.q64(576).q64(imul(sci.w65_1, 18)), dst_0.q64(imul(sci.w65_1, 18)), imul(sci.v65_1 - sci.w65_1 | 0, 18));
    var inductionVariable = 0;
    var last = sci.v65_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 12)
          do {
            var k = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            dst_0.y64(k + 0 | 0, dst_0.e1(k + 0 | 0) * scf_0.e1(0));
            dst_0.y64(k + 576 | 0, dst_0.e1(k + 576 | 0) * scf_0.e1(3));
          }
           while (inductionVariable_0 < 12);
        dst_0 = dst_0.q64(18);
        scf_0 = scf_0.q64(6);
      }
       while (inductionVariable < last);
  }
  f60(bs, gr, hdr) {
    var gr_0 = gr;
    var g_scf_long = Companion_getInstance_10().p63_1;
    var g_scf_short = Companion_getInstance_10().q63_1;
    var g_scf_mixed = Companion_getInstance_10().r63_1;
    var tables;
    var scfsi = 0;
    var main_data_begin;
    var part_23_sum = 0;
    var sr_idx = (hdr.e1(2) >> 2 & 3) + imul((hdr.e1(1) >> 3 & 1) + (hdr.e1(1) >> 4 & 1) | 0, 3) | 0;
    sr_idx = sr_idx - toInt_0(!(sr_idx === 0), this) | 0;
    var gr_count = (hdr.e1(3) & 192) === 192 ? 1 : 2;
    if (!((hdr.e1(1) & 8) === 0)) {
      gr_count = imul(gr_count, 2);
      main_data_begin = this.s5z(bs, 9);
      scfsi = this.s5z(bs, 7 + gr_count | 0);
    } else {
      main_data_begin = this.s5z(bs, 8 + gr_count | 0) >> gr_count;
    }
    $l$1: do {
      $l$0: do {
        if ((hdr.e1(3) & 192) === 192) {
          scfsi = scfsi << 4;
        }
        gr_0.s1().f65_1 = this.s5z(bs, 12);
        part_23_sum = part_23_sum + gr_0.s1().f65_1 | 0;
        gr_0.s1().g65_1 = this.s5z(bs, 9);
        if (gr_0.s1().g65_1 > 288)
          return -1;
        gr_0.s1().i65_1 = this.s5z(bs, 8);
        gr_0.s1().h65_1 = this.s5z(bs, !((hdr.e1(1) & 8) === 0) ? 4 : 9);
        gr_0.s1().e65_1 = new UByteArrayIntPtr(g_scf_long[sr_idx].g14_1);
        gr_0.s1().l65_1 = 22;
        gr_0.s1().m65_1 = 0;
        if (!(this.s5z(bs, 1) === 0)) {
          gr_0.s1().j65_1 = this.s5z(bs, 2);
          if (gr_0.s1().j65_1 === 0)
            return -1;
          gr_0.s1().k65_1 = this.s5z(bs, 1);
          UByteArrayInt__set_impl_gn4532_0(gr_0.s1().o65_1, 0, _UByte___init__impl__g9hnc4(7));
          UByteArrayInt__set_impl_gn4532(gr_0.s1().o65_1, 1, 255);
          if (gr_0.s1().j65_1 === 2) {
            scfsi = scfsi & 3855;
            if (gr_0.s1().k65_1 === 0) {
              UByteArrayInt__set_impl_gn4532(gr_0.s1().o65_1, 0, 8);
              gr_0.s1().e65_1 = new UByteArrayIntPtr(g_scf_short[sr_idx].g14_1);
              gr_0.s1().l65_1 = 0;
              gr_0.s1().m65_1 = 39;
            } else {
              gr_0.s1().e65_1 = new UByteArrayIntPtr(g_scf_mixed[sr_idx].g14_1);
              gr_0.s1().l65_1 = !((hdr.e1(1) & 8) === 0) ? 8 : 6;
              gr_0.s1().m65_1 = 30;
            }
          }
          tables = this.s5z(bs, 10);
          tables = tables << 5;
          UByteArrayInt__set_impl_gn4532(gr_0.s1().p65_1, 0, this.s5z(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.s1().p65_1, 1, this.s5z(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.s1().p65_1, 2, this.s5z(bs, 3));
        } else {
          gr_0.s1().j65_1 = 0;
          gr_0.s1().k65_1 = 0;
          tables = this.s5z(bs, 15);
          UByteArrayInt__set_impl_gn4532(gr_0.s1().o65_1, 0, this.s5z(bs, 4));
          UByteArrayInt__set_impl_gn4532(gr_0.s1().o65_1, 1, this.s5z(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.s1().o65_1, 2, 255);
        }
        UByteArrayInt__set_impl_gn4532(gr_0.s1().n65_1, 0, tables >> 10);
        UByteArrayInt__set_impl_gn4532(gr_0.s1().n65_1, 1, tables >> 5 & 31);
        UByteArrayInt__set_impl_gn4532(gr_0.s1().n65_1, 2, tables & 31);
        gr_0.s1().q65_1 = !((hdr.e1(1) & 8) === 0) ? this.s5z(bs, 1) : toInt_0(gr_0.s1().h65_1 >= 500, this);
        gr_0.s1().r65_1 = this.s5z(bs, 1);
        gr_0.s1().s65_1 = this.s5z(bs, 1);
        gr_0.s1().t65_1 = scfsi >> 12 & 15;
        scfsi = scfsi << 4;
        gr_0 = gr_0.c4();
      }
       while (false);
      gr_count = gr_count - 1 | 0;
    }
     while (!(gr_count === 0));
    if ((part_23_sum + bs.d64_1 | 0) > (bs.e64_1 + imul(main_data_begin, 8) | 0))
      return -1;
    return main_data_begin;
  }
  g60(scf, ist_pos, scf_size, scf_count, bitbuf, scfsi) {
    var scf_0 = scf;
    var ist_pos_0 = new UByteArrayIntPtr(ist_pos);
    var scfsi_0 = scfsi;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (scf_count.e1(i) === 0)
          break $l$loop;
        var cnt = scf_count.e1(i);
        if (!((scfsi_0 & 8) === 0)) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < cnt)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              scf_0.x2o(n, ist_pos_0.e1(n));
            }
             while (inductionVariable_0 < cnt);
        } else {
          var bits = UByteArrayInt__get_impl_px6q8a(scf_size, i);
          if (bits === 0) {
            scf_0.u64(_UByte___init__impl__g9hnc4(0), 0, cnt);
            ist_pos_0.u64(_UByte___init__impl__g9hnc4(0), 0, cnt);
          } else {
            var max_scf = (scfsi_0 < 0 ? toLong((1 << bits) - 1 | 0) : new Long(-1, -1)).j2();
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < cnt)
              do {
                var k = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var s = this.s5z(bitbuf, bits);
                ist_pos_0.x2o(k, (s === max_scf ? new Long(-1, -1) : toLong(s)).j2());
                scf_0.x2o(k, s);
              }
               while (inductionVariable_1 < cnt);
          }
        }
        ist_pos_0 = ist_pos_0.q64(cnt);
        scf_0 = scf_0.q64(cnt);
        scfsi_0 = imul(scfsi_0, 2);
      }
       while (inductionVariable < 4);
    scf_0.x2o(0, 0);
    scf_0.x2o(1, 0);
    scf_0.x2o(2, 0);
  }
  h60(y, exp_q2) {
    var y_0 = y;
    var exp_q2_0 = exp_q2;
    var g_expfrac = Companion_getInstance_10().c63_1;
    do {
      var e = 120 > exp_q2_0 ? exp_q2_0 : 120;
      y_0 = y_0 * (g_expfrac[e & 3] * (1073741824 >> (e >> 2)));
      exp_q2_0 = exp_q2_0 - e | 0;
    }
     while (exp_q2_0 > 0);
    return y_0;
  }
  i60(hdr, ist_pos, bs, gr, scf, ch) {
    var g_scf_partitions = Companion_getInstance_10().s63_1;
    var scf_partition = new UByteArrayIntPtr(g_scf_partitions[toInt_0(!(gr.s1().m65_1 === 0), this) + toInt_0(gr.s1().l65_1 === 0, this) | 0].g14_1);
    var scf_size = _UByteArrayInt___init__impl__xif7bu_1(4);
    var iscf = _UByteArrayInt___init__impl__xif7bu_1(40);
    var scf_shift = gr.s1().r65_1 + 1 | 0;
    var scfsi = gr.s1().t65_1;
    if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
      var g_scfc_decode = Companion_getInstance_10().g63_1;
      var part = UByteArrayInt__get_impl_px6q8a(g_scfc_decode, gr.s1().h65_1);
      UByteArrayInt__set_impl_gn4532(scf_size, 0, part >> 2);
      UByteArrayInt__set_impl_gn4532(scf_size, 1, UByteArrayInt__get_impl_px6q8a(scf_size, 0));
      UByteArrayInt__set_impl_gn4532(scf_size, 2, part & 3);
      UByteArrayInt__set_impl_gn4532(scf_size, 3, UByteArrayInt__get_impl_px6q8a(scf_size, 2));
    } else {
      var g_mod = Companion_getInstance_10().h63_1;
      var ist = toInt_0(!((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 16) === 0) && !(ch === 0), this);
      var sfc = gr.s1().h65_1 >> ist;
      var k = imul(imul(ist, 3), 4);
      while (sfc >= 0) {
        var modprod = 1;
        var inductionVariable = 3;
        if (0 <= inductionVariable)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            UByteArrayInt__set_impl_gn4532(scf_size, i, (sfc / modprod | 0) % UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0) | 0);
            modprod = imul(modprod, UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0));
          }
           while (0 <= inductionVariable);
        sfc = sfc - modprod | 0;
        k = k + 4 | 0;
      }
      scf_partition = scf_partition.q64(k);
      scfsi = -16;
    }
    this.g60(new UByteArrayIntPtr(iscf), ist_pos, scf_size, scf_partition, bs, scfsi);
    if (!(gr.s1().m65_1 === 0)) {
      var sh = 3 - scf_shift | 0;
      var progression = step(until(0, gr.s1().m65_1), 3);
      var inductionVariable_0 = progression.b2_1;
      var last = progression.c2_1;
      var step_0 = progression.d2_1;
      if (step_0 > 0 && inductionVariable_0 <= last || (step_0 < 0 && last <= inductionVariable_0))
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          UByteArrayInt__set_impl_gn4532(iscf, (gr.s1().l65_1 + i_0 | 0) + 0 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.s1().l65_1 + i_0 | 0) + 0 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.s1().p65_1, 0) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.s1().l65_1 + i_0 | 0) + 1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.s1().l65_1 + i_0 | 0) + 1 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.s1().p65_1, 1) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.s1().l65_1 + i_0 | 0) + 2 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.s1().l65_1 + i_0 | 0) + 2 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.s1().p65_1, 2) << sh) | 0);
        }
         while (!(i_0 === last));
    } else {
      if (!(gr.s1().q65_1 === 0)) {
        var g_preamp = Companion_getInstance_10().i63_1;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 10)
          do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(iscf, 11 + i_1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, 11 + i_1 | 0) + UByteArrayInt__get_impl_px6q8a(g_preamp, i_1) | 0);
          }
           while (inductionVariable_1 < 10);
      }
    }
    var gain_exp = (numberToLong(gr.s1().i65_1).y3(new Long(-4, -1)).j2() - 210 | 0) - ((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 224) === 96 ? 2 : 0) | 0;
    var gain = this.h60(2048, (new Long(44, 0)).y1(toLong(gain_exp)).j2());
    var inductionVariable_2 = 0;
    var last_0 = gr.s1().l65_1 + gr.s1().m65_1 | 0;
    if (inductionVariable_2 < last_0)
      do {
        var i_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        scf.y64(i_2, this.h60(gain, UByteArrayInt__get_impl_px6q8a(iscf, i_2) << scf_shift));
      }
       while (inductionVariable_2 < last_0);
  }
  j60(x) {
    var x_0 = x;
    var mult = 256;
    if (x_0 < 129)
      return Companion_getInstance_10().x63_1[16 + x_0 | 0];
    if (x_0 < 1024) {
      mult = 16;
      x_0 = x_0 << 3;
    }
    var sign = imul(2, x_0) & 64;
    var frac = ((x_0 & 63) - sign | 0) / ((x_0 & -64) + sign | 0);
    return Companion_getInstance_10().x63_1[16 + ((x_0 + sign | 0) >> 6) | 0] * (1.0 + frac * (4.0 / 3.0 + frac * (2.0 / 9.0))) * mult;
  }
  k60(dst, bs, gr_info, scf, layer3gr_limit) {
    var dst_0 = dst;
    var scf_0 = scf;
    var tabs = Companion_getInstance_10().j63_1;
    var tab32 = Companion_getInstance_10().k63_1;
    var tab33 = Companion_getInstance_10().l63_1;
    var tabindex = Companion_getInstance_10().m63_1;
    var g_linbits = Companion_getInstance_10().n63_1;
    var one = 0.0;
    var ireg = 0;
    var big_val_cnt = gr_info.s1().g65_1;
    var sfb = gr_info.s1().e65_1;
    var bs_next_ptr = bs.c64_1.q64(bs.d64_1 / 8 | 0);
    // Inline function 'kotlin.toUInt' call
    var this_0 = (imul(imul(imul(bs_next_ptr.e1(0), 256) + bs_next_ptr.e1(1) | 0, 256) + bs_next_ptr.e1(2) | 0, 256) + bs_next_ptr.e1(3) | 0) << (bs.d64_1 & 7);
    var bs_cache = _UInt___init__impl__l7qpdl(this_0);
    var pairs_to_decode = 0;
    var np = 0;
    var bs_sh = (bs.d64_1 & 7) - 8 | 0;
    bs_next_ptr = bs_next_ptr.q64(4);
    while (big_val_cnt > 0) {
      var tab_num = UByteArrayInt__get_impl_px6q8a(gr_info.s1().n65_1, ireg);
      var tmp = gr_info.s1().o65_1;
      var _unary__edvuaz = ireg;
      ireg = _unary__edvuaz + 1 | 0;
      var sfb_cnt = UByteArrayInt__get_impl_px6q8a(tmp, _unary__edvuaz);
      var codebook = tabindex[tab_num];
      var linbits = UByteArrayInt__get_impl_px6q8a(g_linbits, tab_num);
      if (!(linbits === 0)) {
        $l$3: do {
          $l$2: do {
            np = sfb.s1() / 2 | 0;
            sfb = sfb.c4();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_0 = scf_0;
            scf_0 = _unary__edvuaz_0.c4();
            one = _unary__edvuaz_0.s1();
            $l$1: do {
              $l$0: do {
                var w = 5;
                // Inline function 'kotlin.UInt.toInt' call
                // Inline function 'kotlin.UInt.shr' call
                var this_1 = bs_cache;
                var bitCount = 32 - w | 0;
                var this_2 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) >>> bitCount | 0);
                var leaf = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_2) | 0];
                while (leaf < 0) {
                  // Inline function 'kotlin.UInt.shl' call
                  var this_3 = bs_cache;
                  var bitCount_0 = w;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_3) << bitCount_0);
                  bs_sh = bs_sh + w | 0;
                  w = leaf & 7;
                  // Inline function 'kotlin.UInt.toInt' call
                  // Inline function 'kotlin.UInt.shr' call
                  var this_4 = bs_cache;
                  var bitCount_1 = 32 - w | 0;
                  var this_5 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_4) >>> bitCount_1 | 0);
                  leaf = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_5) | 0) - (leaf >> 3) | 0];
                }
                // Inline function 'kotlin.UInt.shl' call
                var this_6 = bs_cache;
                var bitCount_2 = leaf >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_6) << bitCount_2);
                bs_sh = bs_sh + (leaf >> 8) | 0;
                var inductionVariable = 0;
                if (inductionVariable < 2)
                  do {
                    var j = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var lsb = leaf & 15;
                    if (lsb === 15) {
                      var tmp_0 = lsb;
                      // Inline function 'kotlin.UInt.toInt' call
                      // Inline function 'kotlin.UInt.shr' call
                      var this_7 = bs_cache;
                      var bitCount_3 = 32 - linbits | 0;
                      var this_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_7) >>> bitCount_3 | 0);
                      lsb = tmp_0 + _UInt___get_data__impl__f0vqqw(this_8) | 0;
                      // Inline function 'kotlin.UInt.shl' call
                      var this_9 = bs_cache;
                      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_9) << linbits);
                      bs_sh = bs_sh + linbits | 0;
                      while (bs_sh >= 0) {
                        // Inline function 'kotlin.UInt.or' call
                        var this_10 = bs_cache;
                        // Inline function 'kotlin.toUInt' call
                        var this_11 = bs_next_ptr.s1() << bs_sh;
                        var other = _UInt___init__impl__l7qpdl(this_11);
                        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_10) | _UInt___get_data__impl__f0vqqw(other));
                        bs_next_ptr = bs_next_ptr.c4();
                        bs_sh = bs_sh - 8 | 0;
                      }
                      var tmp_1 = dst_0;
                      var tmp_2 = one * this.j60(lsb);
                      var tmp_3;
                      // Inline function 'kotlin.UInt.toInt' call
                      var this_12 = bs_cache;
                      if (_UInt___get_data__impl__f0vqqw(this_12) < 0) {
                        tmp_3 = new Long(-1, -1);
                      } else {
                        tmp_3 = new Long(1, 0);
                      }
                      tmp_1.x64(tmp_2 * tmp_3.m4());
                    } else {
                      var tmp_4 = dst_0;
                      var tmp_5 = Companion_getInstance_10().x63_1;
                      var tmp_6 = 16 + lsb | 0;
                      // Inline function 'kotlin.UInt.toInt' call
                      // Inline function 'kotlin.UInt.shr' call
                      var this_13 = bs_cache;
                      var this_14 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_13) >>> 31 | 0);
                      var tmp$ret$14 = _UInt___get_data__impl__f0vqqw(this_14);
                      tmp_4.x64(tmp_5[tmp_6 - imul(16, tmp$ret$14) | 0] * one);
                    }
                    // Inline function 'kotlin.UInt.shl' call
                    var this_15 = bs_cache;
                    var bitCount_4 = !(lsb === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_15) << bitCount_4);
                    bs_sh = bs_sh + (!(lsb === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.c4();
                    leaf = leaf >> 4;
                  }
                   while (inductionVariable < 2);
                while (bs_sh >= 0) {
                  // Inline function 'kotlin.UInt.or' call
                  var this_16 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_17 = bs_next_ptr.s1() << bs_sh;
                  var other_0 = _UInt___init__impl__l7qpdl(this_17);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_16) | _UInt___get_data__impl__f0vqqw(other_0));
                  bs_next_ptr = bs_next_ptr.c4();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_7;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_7 = sfb_cnt >= 0;
          } else {
            tmp_7 = false;
          }
        }
         while (tmp_7);
      } else {
        $l$7: do {
          $l$6: do {
            np = sfb.s1() / 2 | 0;
            sfb = sfb.c4();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_1 = scf_0;
            scf_0 = _unary__edvuaz_1.c4();
            one = _unary__edvuaz_1.s1();
            $l$5: do {
              $l$4: do {
                var w_0 = 5;
                // Inline function 'kotlin.UInt.toInt' call
                // Inline function 'kotlin.UInt.shr' call
                var this_18 = bs_cache;
                var bitCount_5 = 32 - w_0 | 0;
                var this_19 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_18) >>> bitCount_5 | 0);
                var leaf_0 = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_19) | 0];
                while (leaf_0 < 0) {
                  // Inline function 'kotlin.UInt.shl' call
                  var this_20 = bs_cache;
                  var bitCount_6 = w_0;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_20) << bitCount_6);
                  bs_sh = bs_sh + w_0 | 0;
                  w_0 = leaf_0 & 7;
                  // Inline function 'kotlin.UInt.toInt' call
                  // Inline function 'kotlin.UInt.shr' call
                  var this_21 = bs_cache;
                  var bitCount_7 = 32 - w_0 | 0;
                  var this_22 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_21) >>> bitCount_7 | 0);
                  leaf_0 = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_22) | 0) - (leaf_0 >> 3) | 0];
                }
                // Inline function 'kotlin.UInt.shl' call
                var this_23 = bs_cache;
                var bitCount_8 = leaf_0 >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_23) << bitCount_8);
                bs_sh = bs_sh + (leaf_0 >> 8) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < 2)
                  do {
                    var j_0 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var lsb_0 = leaf_0 & 15;
                    var tmp_8 = dst_0;
                    var tmp_9 = Companion_getInstance_10().x63_1;
                    var tmp_10 = 16 + lsb_0 | 0;
                    // Inline function 'kotlin.UInt.toInt' call
                    // Inline function 'kotlin.UInt.shr' call
                    var this_24 = bs_cache;
                    var this_25 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_24) >>> 31 | 0);
                    var tmp$ret$25 = _UInt___get_data__impl__f0vqqw(this_25);
                    tmp_8.x64(tmp_9[tmp_10 - imul(16, tmp$ret$25) | 0] * one);
                    // Inline function 'kotlin.UInt.shl' call
                    var this_26 = bs_cache;
                    var bitCount_9 = !(lsb_0 === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_26) << bitCount_9);
                    bs_sh = bs_sh + (!(lsb_0 === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.c4();
                    leaf_0 = leaf_0 >> 4;
                  }
                   while (inductionVariable_0 < 2);
                while (bs_sh >= 0) {
                  // Inline function 'kotlin.UInt.or' call
                  var this_27 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_28 = bs_next_ptr.s1() << bs_sh;
                  var other_1 = _UInt___init__impl__l7qpdl(this_28);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_27) | _UInt___get_data__impl__f0vqqw(other_1));
                  bs_next_ptr = bs_next_ptr.c4();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_11;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_11 = sfb_cnt >= 0;
          } else {
            tmp_11 = false;
          }
        }
         while (tmp_11);
      }
    }
    np = 1 - big_val_cnt | 0;
    $l$loop_1: while (true) {
      var codebook_count1 = !(gr_info.s1().s65_1 === 0) ? tab33 : tab32;
      // Inline function 'kotlin.UInt.toInt' call
      // Inline function 'kotlin.UInt.shr' call
      var this_29 = bs_cache;
      var this_30 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_29) >>> 28 | 0);
      var tmp$ret$30 = _UInt___get_data__impl__f0vqqw(this_30);
      var leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp$ret$30);
      if ((leaf_1 & 8) === 0) {
        var tmp_12 = leaf_1 >> 3;
        // Inline function 'kotlin.UInt.toInt' call
        // Inline function 'kotlin.UInt.shr' call
        // Inline function 'kotlin.UInt.shl' call
        var this_31 = bs_cache;
        var this_32 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_31) << 4);
        var bitCount_10 = 32 - (leaf_1 & 3) | 0;
        var this_33 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_32) >>> bitCount_10 | 0);
        var tmp$ret$33 = _UInt___get_data__impl__f0vqqw(this_33);
        leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp_12 + tmp$ret$33 | 0);
      }
      // Inline function 'kotlin.UInt.shl' call
      var this_34 = bs_cache;
      var bitCount_11 = leaf_1 & 7;
      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_34) << bitCount_11);
      bs_sh = bs_sh + (leaf_1 & 7) | 0;
      if (((imul(bs_next_ptr.t64(bs.c64_1), 8) - 24 | 0) + bs_sh | 0) > layer3gr_limit) {
        break $l$loop_1;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.s1() / 2 | 0;
        sfb = sfb.c4();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_2 = scf_0;
        scf_0 = _unary__edvuaz_2.c4();
        one = _unary__edvuaz_2.s1();
      }
      if (!((leaf_1 & 128) === 0)) {
        var tmp_13 = dst_0;
        var tmp_14;
        // Inline function 'kotlin.UInt.toInt' call
        var this_35 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_35) < 0) {
          tmp_14 = -one;
        } else {
          tmp_14 = one;
        }
        tmp_13.y64(0, tmp_14);
        // Inline function 'kotlin.UInt.shl' call
        var this_36 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_36) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 64) === 0)) {
        var tmp_15 = dst_0;
        var tmp_16;
        // Inline function 'kotlin.UInt.toInt' call
        var this_37 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_37) < 0) {
          tmp_16 = -one;
        } else {
          tmp_16 = one;
        }
        tmp_15.y64(1, tmp_16);
        // Inline function 'kotlin.UInt.shl' call
        var this_38 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_38) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.s1() / 2 | 0;
        sfb = sfb.c4();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_3 = scf_0;
        scf_0 = _unary__edvuaz_3.c4();
        one = _unary__edvuaz_3.s1();
      }
      if (!((leaf_1 & 32) === 0)) {
        var tmp_17 = dst_0;
        var tmp_18;
        // Inline function 'kotlin.UInt.toInt' call
        var this_39 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_39) < 0) {
          tmp_18 = -one;
        } else {
          tmp_18 = one;
        }
        tmp_17.y64(2, tmp_18);
        // Inline function 'kotlin.UInt.shl' call
        var this_40 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_40) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 16) === 0)) {
        var tmp_19 = dst_0;
        var tmp_20;
        // Inline function 'kotlin.UInt.toInt' call
        var this_41 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_41) < 0) {
          tmp_20 = -one;
        } else {
          tmp_20 = one;
        }
        tmp_19.y64(3, tmp_20);
        // Inline function 'kotlin.UInt.shl' call
        var this_42 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_42) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      while (bs_sh >= 0) {
        // Inline function 'kotlin.UInt.or' call
        var this_43 = bs_cache;
        // Inline function 'kotlin.toUInt' call
        var this_44 = bs_next_ptr.s1() << bs_sh;
        var other_2 = _UInt___init__impl__l7qpdl(this_44);
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_43) | _UInt___get_data__impl__f0vqqw(other_2));
        bs_next_ptr = bs_next_ptr.c4();
        bs_sh = bs_sh - 8 | 0;
      }
      dst_0 = dst_0.q64(4);
    }
    bs.d64_1 = layer3gr_limit;
  }
  l60(left, n) {
    var right = left.q64(576);
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a = left.e1(i);
        var b = right.e1(i);
        left.y64(i, a + b);
        right.y64(i, a - b);
      }
       while (inductionVariable < n);
  }
  m60(left, n, kl, kr) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        left.y64(i + 576 | 0, left.e1(i) * kr);
        left.y64(i, left.e1(i) * kl);
      }
       while (inductionVariable < n);
  }
  n60(right, sfb, nbands, max_band) {
    var right_0 = right;
    max_band[0] = -1;
    max_band[1] = -1;
    max_band[2] = -1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = 0;
        $l$loop: while (k < sfb.e1(i)) {
          if (!(right_0.e1(k) === 0.0) || !(right_0.e1(k + 1 | 0) === 0.0)) {
            max_band[i % 3 | 0] = i;
            break $l$loop;
          }
          k = k + 2 | 0;
        }
        right_0 = right_0.q64(sfb.e1(i));
      }
       while (inductionVariable < nbands);
  }
  o60(left, ist_pos, sfb, hdr, max_band, mpeg2_sh) {
    var left_0 = left;
    var g_pan = Companion_getInstance_10().y62_1;
    var max_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 7 : 64;
    var i = 0;
    while (!(sfb.e1(i) === 0)) {
      var ipos = UByteArrayInt__get_impl_px6q8a(ist_pos, i);
      if (i > max_band[i % 3 | 0] && ipos < max_pos) {
        var kl;
        var kr;
        var s = !((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0) ? 1.4142135 : 1.0;
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
          kl = g_pan[imul(2, ipos) + 0 | 0];
          kr = g_pan[imul(2, ipos) + 1 | 0];
        } else {
          kl = 1.0;
          kr = this.h60(1.0, (ipos + 1 | 0) >> 1 << mpeg2_sh);
          if (!((ipos & 1) === 0)) {
            kl = kr;
            kr = 1.0;
          }
        }
        this.m60(left_0, sfb.e1(i), kl * s, kr * s);
      } else {
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0)) {
          this.l60(left_0, sfb.e1(i));
        }
      }
      left_0 = left_0.q64(sfb.e1(i));
      i = i + 1 | 0;
    }
  }
  p60(left, ist_pos, gr, hdr) {
    var max_band = this.j5y_1;
    var n_sfb = gr.s1().l65_1 + gr.s1().m65_1 | 0;
    var max_blocks = !(gr.s1().m65_1 === 0) ? 3 : 1;
    this.n60(left.q64(576), gr.s1().e65_1, n_sfb, max_band);
    if (!(gr.s1().l65_1 === 0)) {
      // Inline function 'kotlin.math.max' call
      // Inline function 'kotlin.math.max' call
      var a = max_band[0];
      var b = max_band[1];
      var a_0 = Math.max(a, b);
      var b_0 = max_band[2];
      var v = Math.max(a_0, b_0);
      max_band[0] = v;
      max_band[1] = v;
      max_band[2] = v;
    }
    var inductionVariable = 0;
    if (inductionVariable < max_blocks)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var default_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 3 : 0;
        var itop = (n_sfb - max_blocks | 0) + i | 0;
        var prev = itop - max_blocks | 0;
        UByteArrayInt__set_impl_gn4532(ist_pos, itop, max_band[i] >= prev ? default_pos : UByteArrayInt__get_impl_px6q8a(ist_pos, prev));
      }
       while (inductionVariable < max_blocks);
    this.o60(left, ist_pos, gr.s1().e65_1, hdr, max_band, gr.e1(1).h65_1 & 1);
  }
  q60(grbuf, scratch, sfb) {
    var sfb_0 = sfb;
    var i = 0;
    var len = 0;
    var src = grbuf;
    var dst = scratch;
    $l$loop: while (true) {
      len = sfb_0.s1();
      if (len === 0)
        break $l$loop;
      i = 0;
      while (i < len) {
        var _unary__edvuaz = dst;
        dst = _unary__edvuaz.c4();
        _unary__edvuaz.x64(src.e1(imul(0, len)));
        var _unary__edvuaz_0 = dst;
        dst = _unary__edvuaz_0.c4();
        _unary__edvuaz_0.x64(src.e1(imul(1, len)));
        var _unary__edvuaz_1 = dst;
        dst = _unary__edvuaz_1.c4();
        _unary__edvuaz_1.x64(src.e1(imul(2, len)));
        i = i + 1 | 0;
        src = src.c4();
      }
      sfb_0 = sfb_0.q64(3);
      src = src.q64(imul(2, len));
    }
    this.p5z(grbuf, scratch, dst.z64(scratch));
  }
  r60(grbuf, nbands) {
    var grbuf_0 = grbuf;
    var nbands_0 = nbands;
    var g_aa = Companion_getInstance_10().a63_1;
    while (nbands_0 > 0) {
      var inductionVariable = 0;
      if (inductionVariable < 8)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var u = grbuf_0.e1(18 + i | 0);
          var d = grbuf_0.e1(17 - i | 0);
          grbuf_0.y64(18 + i | 0, u * g_aa[0][i] - d * g_aa[1][i]);
          grbuf_0.y64(17 - i | 0, u * g_aa[1][i] + d * g_aa[0][i]);
        }
         while (inductionVariable < 8);
      nbands_0 = nbands_0 - 1 | 0;
      grbuf_0 = grbuf_0.q64(18);
    }
  }
  s60(y) {
    var s0 = y[0];
    var s2 = y[2];
    var s4 = y[4];
    var s6 = y[6];
    var s8 = y[8];
    var t0 = s0 + s6 * 0.5;
    s0 = s0 - s6;
    var t4 = (s4 + s2) * 0.9396926;
    var t2 = (s8 + s2) * 0.76604444;
    s6 = (s4 - s8) * 0.17364818;
    s4 = s4 + (s8 - s2);
    s2 = s0 - s4 * 0.5;
    y[4] = s4 + s0;
    s8 = t0 - t2 + s6;
    s0 = t0 - t4 + t2;
    s4 = t0 + t4 - s6;
    var s1 = y[1];
    var s3 = y[3];
    var s5 = y[5];
    var s7 = y[7];
    s3 = s3 * 0.8660254;
    t0 = (s5 + s1) * 0.9848077;
    t4 = (s5 - s7) * 0.34202015;
    t2 = (s1 + s7) * 0.64278764;
    s1 = (s1 - s5 - s7) * 0.8660254;
    s5 = t0 - s3 - t2;
    s7 = t4 - s3 - t0;
    s3 = t4 + s3 - t2;
    y[0] = s4 - s7;
    y[1] = s2 + s1;
    y[2] = s0 - s3;
    y[3] = s8 + s5;
    y[5] = s8 - s5;
    y[6] = s0 + s3;
    y[7] = s2 - s1;
    y[8] = s4 + s7;
  }
  t60(grbuf, overlap, window_0, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_twid9 = Companion_getInstance_10().v62_1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var co = this.k5y_1;
        var si = this.l5y_1;
        co[0] = -grbuf_0.e1(0);
        si[0] = grbuf_0.e1(17);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            si[8 - imul(2, i) | 0] = grbuf_0.e1(imul(4, i) + 1 | 0) - grbuf_0.e1(imul(4, i) + 2 | 0);
            co[1 + imul(2, i) | 0] = grbuf_0.e1(imul(4, i) + 1 | 0) + grbuf_0.e1(imul(4, i) + 2 | 0);
            si[7 - imul(2, i) | 0] = grbuf_0.e1(imul(4, i) + 4 | 0) - grbuf_0.e1(imul(4, i) + 3 | 0);
            co[2 + imul(2, i) | 0] = -(grbuf_0.e1(imul(4, i) + 3 | 0) + grbuf_0.e1(imul(4, i) + 4 | 0));
          }
           while (inductionVariable_0 < 4);
        this.s60(co);
        this.s60(si);
        si[1] = -si[1];
        si[3] = -si[3];
        si[5] = -si[5];
        si[7] = -si[7];
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 9)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var ovl = overlap_0.e1(i_0);
            var sum = co[i_0] * g_twid9[9 + i_0 | 0] + si[i_0] * g_twid9[0 + i_0 | 0];
            overlap_0.y64(i_0, co[i_0] * g_twid9[0 + i_0 | 0] - si[i_0] * g_twid9[9 + i_0 | 0]);
            grbuf_0.y64(i_0, ovl * window_0[0 + i_0 | 0] - sum * window_0[9 + i_0 | 0]);
            grbuf_0.y64(17 - i_0 | 0, ovl * window_0[9 + i_0 | 0] + sum * window_0[0 + i_0 | 0]);
          }
           while (inductionVariable_1 < 9);
        grbuf_0 = grbuf_0.q64(18);
        overlap_0 = overlap_0.q64(9);
      }
       while (inductionVariable < nbands);
  }
  u60(x0, x1, x2, dst) {
    var m1 = x1 * 0.8660254;
    var a1 = x0 - x2 * 0.5;
    dst[1] = x0 + x2;
    dst[0] = a1 + m1;
    dst[2] = a1 - m1;
  }
  v60(x, dst, overlap) {
    var g_twid3 = Companion_getInstance_10().w62_1;
    var co = this.m5y_1;
    var si = this.n5y_1;
    this.u60(-x.e1(0), x.e1(6) + x.e1(3), x.e1(12) + x.e1(9), co);
    this.u60(x.e1(15), x.e1(12) - x.e1(9), x.e1(6) - x.e1(3), si);
    si[1] = -si[1];
    var inductionVariable = 0;
    if (inductionVariable < 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ovl = overlap.e1(i);
        var sum = co[i] * g_twid3[3 + i | 0] + si[i] * g_twid3[0 + i | 0];
        overlap.y64(i, co[i] * g_twid3[0 + i | 0] - si[i] * g_twid3[3 + i | 0]);
        dst.y64(i, ovl * g_twid3[2 - i | 0] - sum * g_twid3[5 - i | 0]);
        dst.y64(5 - i | 0, ovl * g_twid3[5 - i | 0] + sum * g_twid3[2 - i | 0]);
      }
       while (inductionVariable < 3);
  }
  w60(grbuf, overlap, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var nbands_0 = nbands;
    while (nbands_0 > 0) {
      var tmp = new FloatArrayPtr(new Float32Array(18));
      this.p5z(tmp, grbuf_0, 18);
      this.p5z(grbuf_0, overlap_0, 6);
      this.v60(tmp, grbuf_0.q64(6), overlap_0.q64(6));
      this.v60(tmp.q64(1), grbuf_0.q64(12), overlap_0.q64(6));
      this.v60(tmp.q64(2), overlap_0, overlap_0.q64(6));
      nbands_0 = nbands_0 - 1 | 0;
      overlap_0 = overlap_0.q64(9);
      grbuf_0 = grbuf_0.q64(18);
    }
  }
  x60(grbuf) {
    var p = 18;
    var progression = step(until(0, 32), 2);
    var inductionVariable = progression.b2_1;
    var last = progression.c2_1;
    var step_0 = progression.d2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var b = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var progression_0 = step(until(1, 18), 2);
        var inductionVariable_0 = progression_0.b2_1;
        var last_0 = progression_0.c2_1;
        var step_1 = progression_0.d2_1;
        if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            var index = p + i | 0;
            grbuf.y64(index, -grbuf.e1(index));
          }
           while (!(i === last_0));
        p = p + 36 | 0;
      }
       while (!(b === last));
  }
  y60(grbuf, overlap, block_type, n_long_bands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_mdct_window = Companion_getInstance_10().b63_1;
    if (!(n_long_bands === 0)) {
      this.t60(grbuf_0, overlap_0, g_mdct_window[0], n_long_bands);
      grbuf_0 = grbuf_0.q64(imul(18, n_long_bands));
      overlap_0 = overlap_0.q64(imul(9, n_long_bands));
    }
    if (block_type === 2) {
      this.w60(grbuf_0, overlap_0, 32 - n_long_bands | 0);
    } else {
      this.t60(grbuf_0, overlap_0, g_mdct_window[toInt_0(block_type === 3, this)], 32 - n_long_bands | 0);
    }
  }
  z60(h, s) {
    var pos = (s.f64_1.d64_1 + 7 | 0) / 8 | 0;
    var remains = (s.f64_1.e64_1 / 8 | 0) - pos | 0;
    if (remains > 511) {
      pos = pos + (remains - 511 | 0) | 0;
      remains = 511;
    }
    if (remains > 0) {
      this.q5z(new UByteArrayIntPtr(h.h5y_1), s.g64_1.q64(pos), remains);
    }
    h.e5y_1 = remains;
  }
  a61(h, bs, s, main_data_begin) {
    var frame_bytes = (bs.e64_1 - bs.d64_1 | 0) / 8 | 0;
    var bytes_have = h.e5y_1 > main_data_begin ? main_data_begin : h.e5y_1;
    this.q5z(s.g64_1, (new UByteArrayIntPtr(h.h5y_1)).q64(0 < (h.e5y_1 - main_data_begin | 0) ? h.e5y_1 - main_data_begin | 0 : 0), h.e5y_1 > main_data_begin ? main_data_begin : h.e5y_1);
    this.q5z(s.g64_1.q64(bytes_have), bs.c64_1.q64(bs.d64_1 / 8 | 0), frame_bytes);
    this.r5z(s.f64_1, s.g64_1, bytes_have + frame_bytes | 0);
    return toInt_0(h.e5y_1 >= main_data_begin, this);
  }
  b61(h, s, gr_info, nch) {
    var gr_info_0 = gr_info;
    var inductionVariable = 0;
    if (inductionVariable < nch)
      do {
        var ch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var layer3gr_limit = s.f64_1.d64_1 + gr_info_0.e1(ch).f65_1 | 0;
        this.i60(h.g5y_1, s.l64_1[ch].g14_1, s.f64_1, gr_info_0.q64(ch), s.j64_1, ch);
        this.k60(s.i64_1[ch], s.f64_1, gr_info_0.q64(ch), s.j64_1, layer3gr_limit);
      }
       while (inductionVariable < nch);
    if (!((UByteArrayInt__get_impl_px6q8a(h.g5y_1, 3) & 16) === 0)) {
      this.p60(s.i64_1[0], s.l64_1[1].g14_1, gr_info_0, h.g5y_1);
    } else if ((UByteArrayInt__get_impl_px6q8a(h.g5y_1, 3) & 224) === 96) {
      this.l60(s.i64_1[0], 576);
    }
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < nch)
      do {
        var ch_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var aa_bands = 31;
        var n_long_bands = (!(gr_info_0.s1().k65_1 === 0) ? 2 : 0) << toInt_0(((UByteArrayInt__get_impl_px6q8a(h.g5y_1, 2) >> 2 & 3) + imul((UByteArrayInt__get_impl_px6q8a(h.g5y_1, 1) >> 3 & 1) + (UByteArrayInt__get_impl_px6q8a(h.g5y_1, 1) >> 4 & 1) | 0, 3) | 0) === 2, this);
        if (!(gr_info_0.s1().m65_1 === 0)) {
          aa_bands = n_long_bands - 1 | 0;
          this.q60(s.i64_1[ch_0].q64(imul(n_long_bands, 18)), s.k64_1[0], gr_info_0.s1().e65_1.q64(gr_info_0.s1().l65_1));
        }
        this.r60(s.i64_1[ch_0], aa_bands);
        this.y60(s.i64_1[ch_0], new FloatArrayPtr(h.c5y_1[ch_0]), gr_info_0.s1().j65_1, n_long_bands);
        this.x60(s.i64_1[ch_0]);
        gr_info_0 = gr_info_0.q64(1);
      }
       while (inductionVariable_0 < nch);
  }
  c61(grbuf, n) {
    var g_sec = Companion_getInstance_10().x62_1;
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(4), null);
    while (tmp < 4) {
      tmp_0[tmp] = new Float32Array(8);
      tmp = tmp + 1 | 0;
    }
    var t = tmp_0;
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = grbuf.q64(k);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 8)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var x0 = y.e1(imul(i, 18));
            var x1 = y.e1(imul(15 - i | 0, 18));
            var x2 = y.e1(imul(16 + i | 0, 18));
            var x3 = y.e1(imul(31 - i | 0, 18));
            var t0 = x0 + x3;
            var t1 = x1 + x2;
            var t2 = (x1 - x2) * g_sec[imul(3, i) + 0 | 0];
            var t3 = (x0 - x3) * g_sec[imul(3, i) + 1 | 0];
            t[0][i] = t0 + t1;
            t[1][i] = (t0 - t1) * g_sec[imul(3, i) + 2 | 0];
            t[2][i] = t3 + t2;
            t[3][i] = (t3 - t2) * g_sec[imul(3, i) + 2 | 0];
          }
           while (inductionVariable_0 < 8);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 4)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var x = t[i_0];
            var x0_0 = x[0];
            var x1_0 = x[1];
            var x2_0 = x[2];
            var x3_0 = x[3];
            var x4 = x[4];
            var x5 = x[5];
            var x6 = x[6];
            var x7 = x[7];
            var xt = x0_0 - x7;
            x0_0 = x0_0 + x7;
            x7 = x1_0 - x6;
            x1_0 = x1_0 + x6;
            x6 = x2_0 - x5;
            x2_0 = x2_0 + x5;
            x5 = x3_0 - x4;
            x3_0 = x3_0 + x4;
            x4 = x0_0 - x3_0;
            x0_0 = x0_0 + x3_0;
            x3_0 = x1_0 - x2_0;
            x1_0 = x1_0 + x2_0;
            x[0] = x0_0 + x1_0;
            x[4] = (x0_0 - x1_0) * 0.70710677;
            x5 = x5 + x6;
            x6 = (x6 + x7) * 0.70710677;
            x7 = x7 + xt;
            x3_0 = (x3_0 + x4) * 0.70710677;
            x5 = x5 - x7 * 0.19891237;
            x7 = x7 + x5 * 0.38268343;
            x5 = x5 - x7 * 0.19891237;
            x0_0 = xt - x6;
            xt = xt + x6;
            x[1] = (xt + x7) * 0.5097956;
            x[2] = (x4 + x3_0) * 0.5411961;
            x[3] = (x0_0 - x5) * 0.6013449;
            x[5] = (x0_0 + x5) * 0.8999762;
            x[6] = (x4 - x3_0) * 1.306563;
            x[7] = (xt - x7) * 2.5629156;
          }
           while (inductionVariable_1 < 4);
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < 7)
          do {
            var i_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            y.y64(0, t[0][i_1]);
            y.y64(18, t[2][i_1] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y.y64(36, t[1][i_1] + t[1][i_1 + 1 | 0]);
            y.y64(54, t[2][i_1 + 1 | 0] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y = y.q64(72);
          }
           while (inductionVariable_2 < 7);
        y.y64(0, t[0][7]);
        y.y64(18, t[2][7] + t[3][7]);
        y.y64(36, t[1][7]);
        y.y64(54, t[3][7]);
      }
       while (inductionVariable < n);
  }
  d61(sample) {
    if (sample >= 32766.5)
      return 32767;
    if (sample <= -32767.5)
      return -32768;
    var s = toShort(numberToInt(sample + 0.5));
    return toShort(s - toInt_0(s < 0, this) | 0);
  }
  e61(pcm, nch, z) {
    var z_0 = z;
    var a = 0.0;
    a = a + (z_0.e1(896) - z_0.e1(0)) * 29.0;
    a = a + (z_0.e1(64) + z_0.e1(832)) * 213.0;
    a = a + (z_0.e1(768) - z_0.e1(128)) * 459.0;
    a = a + (z_0.e1(192) + z_0.e1(704)) * 2037.0;
    a = a + (z_0.e1(640) - z_0.e1(256)) * 5153.0;
    a = a + (z_0.e1(320) + z_0.e1(576)) * 6574.0;
    a = a + (z_0.e1(512) - z_0.e1(384)) * 37489.0;
    a = a + z_0.e1(448) * 75038.0;
    pcm.d65(0, this.d61(a));
    z_0 = z_0.q64(2);
    a = z_0.e1(896) * 104.0;
    a = a + z_0.e1(768) * 1567.0;
    a = a + z_0.e1(640) * 9727.0;
    a = a + z_0.e1(512) * 64019.0;
    a = a + z_0.e1(384) * -9975.0;
    a = a + z_0.e1(256) * -45.0;
    a = a + z_0.e1(128) * 146.0;
    a = a + z_0.e1(0) * -5.0;
    pcm.d65(imul(16, nch), this.d61(a));
  }
  f61(xl, dstl, nch, lins) {
    var xr = xl.q64(imul(576, nch - 1 | 0));
    var dstr = dstl.q64(nch - 1 | 0);
    var g_win = Companion_getInstance_10().z62_1;
    var zlin = lins.q64(960);
    var w = 0;
    zlin.y64(60, xl.e1(288));
    zlin.y64(61, xr.e1(288));
    zlin.y64(62, xl.e1(0));
    zlin.y64(63, xr.e1(0));
    zlin.y64(124, xl.e1(289));
    zlin.y64(125, xr.e1(289));
    zlin.y64(126, xl.e1(1));
    zlin.y64(127, xr.e1(1));
    this.e61(dstr, nch, lins.q64(60).q64(1));
    this.e61(dstr.q64(imul(32, nch)), nch, lins.q64(60).q64(64).q64(1));
    this.e61(dstl, nch, lins.q64(60));
    this.e61(dstl.q64(imul(32, nch)), nch, lins.q64(60).q64(64));
    var inductionVariable = 14;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var a = this.m5y_1;
        var b = this.n5y_1;
        zlin.y64(imul(4, i), xl.e1(imul(18, 31 - i | 0)));
        zlin.y64(imul(4, i) + 1 | 0, xr.e1(imul(18, 31 - i | 0)));
        zlin.y64(imul(4, i) + 2 | 0, xl.e1(1 + imul(18, 31 - i | 0) | 0));
        zlin.y64(imul(4, i) + 3 | 0, xr.e1(1 + imul(18, 31 - i | 0) | 0));
        zlin.y64(imul(4, i + 16 | 0), xl.e1(1 + imul(18, 1 + i | 0) | 0));
        zlin.y64(imul(4, i + 16 | 0) + 1 | 0, xr.e1(1 + imul(18, 1 + i | 0) | 0));
        zlin.y64(imul(4, i - 16 | 0) + 2 | 0, xl.e1(imul(18, 1 + i | 0)));
        zlin.y64(imul(4, i - 16 | 0) + 3 | 0, xr.e1(imul(18, 1 + i | 0)));
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            b[j] = 0.0;
            a[j] = 0.0;
          }
           while (inductionVariable_0 < 4);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 8)
          do {
            var n = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var _unary__edvuaz = w;
            w = _unary__edvuaz + 1 | 0;
            var w0 = g_win[_unary__edvuaz];
            var _unary__edvuaz_0 = w;
            w = _unary__edvuaz_0 + 1 | 0;
            var w1 = g_win[_unary__edvuaz_0];
            var vz = zlin.q64(imul(4, i) - imul(n, 64) | 0);
            var vy = zlin.q64(imul(4, i) - imul(15 - n | 0, 64) | 0);
            if ((n % 2 | 0) === 0) {
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < 4)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  b[j_0] = b[j_0] + vz.e1(j_0) * w1 + vy.e1(j_0) * w0;
                  a[j_0] = a[j_0] + vz.e1(j_0) * w0 - vy.e1(j_0) * w1;
                }
                 while (inductionVariable_2 < 4);
            } else {
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < 4)
                do {
                  var j_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  b[j_1] = b[j_1] + (vz.e1(j_1) * w1 + vy.e1(j_1) * w0);
                  a[j_1] = a[j_1] + (vy.e1(j_1) * w1 - vz.e1(j_1) * w0);
                }
                 while (inductionVariable_3 < 4);
            }
          }
           while (inductionVariable_1 < 8);
        dstr.d65(imul(15 - i | 0, nch), this.d61(a[1]));
        dstr.d65(imul(17 + i | 0, nch), this.d61(b[1]));
        dstl.d65(imul(15 - i | 0, nch), this.d61(a[0]));
        dstl.d65(imul(17 + i | 0, nch), this.d61(b[0]));
        dstr.d65(imul(47 - i | 0, nch), this.d61(a[3]));
        dstr.d65(imul(49 + i | 0, nch), this.d61(b[3]));
        dstl.d65(imul(47 - i | 0, nch), this.d61(a[2]));
        dstl.d65(imul(49 + i | 0, nch), this.d61(b[2]));
      }
       while (0 <= inductionVariable);
  }
  g61(qmf_state, grbuf, nbands, nch, pcm, lins) {
    var i = 0;
    i = 0;
    while (i < nch) {
      this.c61(grbuf.q64(imul(576, i)), nbands);
      i = i + 1 | 0;
    }
    this.p5z(lins, qmf_state, 960);
    i = 0;
    while (i < nbands) {
      this.f61(grbuf.q64(i), pcm.q64(imul(32, imul(nch, i))), nch, lins.q64(imul(i, 64)));
      i = i + 2 | 0;
    }
    if (nch === 1) {
      i = 0;
      while (i < 960) {
        qmf_state.y64(i, lins.e1(imul(nbands, 64) + i | 0));
        i = i + 2 | 0;
      }
    } else {
      this.p5z(qmf_state, lins.q64(imul(nbands, 64)), 960);
    }
  }
  h61(hdr, mp3_bytes, frame_bytes) {
    var i = 0;
    var inductionVariable = 0;
    if (inductionVariable < 10)
      do {
        var nmatch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        i = i + (this.y5z(hdr.q64(i), frame_bytes) + this.z5z(hdr.q64(i)) | 0) | 0;
        if ((i + 4 | 0) > mp3_bytes)
          return toInt_0(nmatch > 0, this);
        if (this.u5z(hdr, hdr.q64(i)) === 0)
          return 0;
      }
       while (inductionVariable < 10);
    return 1;
  }
  i61(mp3, mp3_bytes, free_format_bytes, ptr_frame_bytes) {
    var mp3_0 = mp3;
    var i = 0;
    var k = 0;
    i = 0;
    while (i < (mp3_bytes - 4 | 0)) {
      if (this.t5z(mp3_0)) {
        var frame_bytes = this.y5z(mp3_0, free_format_bytes[0]);
        var frame_and_padding = frame_bytes + this.z5z(mp3_0) | 0;
        k = 4;
        $l$loop: while (frame_bytes === 0 && k < 2304 && !((i + imul(2, toInt_0(k < (mp3_bytes - 4 | 0), this)) | 0) === 0)) {
          if (!(this.u5z(mp3_0, mp3_0.q64(k)) === 0)) {
            var fb = k - this.z5z(mp3_0) | 0;
            var nextfb = fb + this.z5z(mp3_0.q64(k)) | 0;
            if ((((i + k | 0) + nextfb | 0) + 4 | 0) > mp3_bytes || this.u5z(mp3_0, mp3_0.q64(k).q64(nextfb)) === 0) {
              k = k + 1 | 0;
              continue $l$loop;
            }
            frame_and_padding = k;
            frame_bytes = fb;
            free_format_bytes[0] = fb;
          }
          k = k + 1 | 0;
        }
        if (!(frame_bytes === 0) && !((i + toInt_0(frame_and_padding <= mp3_bytes, this) | 0) === 0) && !(this.h61(mp3_0, mp3_bytes - i | 0, frame_bytes) === 0) || (i === 0 && frame_and_padding === mp3_bytes)) {
          ptr_frame_bytes[0] = frame_and_padding;
          return i;
        }
        free_format_bytes[0] = 0;
      }
      i = i + 1 | 0;
      mp3_0 = mp3_0.q64(1);
    }
    ptr_frame_bytes[0] = 0;
    return mp3_bytes;
  }
  q5y(dec) {
    UByteArrayInt__set_impl_gn4532(dec.g5y_1, 0, 0);
  }
  i5z(dec, mp3, mp3_bytes, pcm, info) {
    var pcm_0 = pcm;
    var i = 0;
    var frame_size = new Int32Array(1);
    var success = 1;
    var bs_frame = this.p5y_1;
    var scratch = this.o5y_1;
    if (mp3_bytes > 4 && UByteArrayInt__get_impl_px6q8a(dec.g5y_1, 0) === 255 && !(this.u5z(new UByteArrayIntPtr(dec.g5y_1), mp3) === 0)) {
      frame_size[0] = this.y5z(mp3, dec.f5y_1[0]) + this.z5z(mp3) | 0;
      if (!(frame_size[0] === mp3_bytes) && ((frame_size[0] + 4 | 0) > mp3_bytes || this.u5z(mp3, mp3.q64(frame_size[0])) === 0)) {
        frame_size[0] = 0;
      }
    }
    if (frame_size[0] === 0) {
      dec.e5y_1 = 0;
      dec.f5y_1[0] = 0;
      UByteArrayInt__fill$default_impl_mdydxi(dec.h5y_1, 0);
      UByteArrayInt__fill$default_impl_mdydxi(dec.g5y_1, 0);
      fill_0(dec.d5y_1, 0.0);
      fill_0(dec.c5y_1[0], 0.0);
      fill_0(dec.c5y_1[1], 0.0);
      i = this.i61(mp3, mp3_bytes, dec.f5y_1, frame_size);
      if (frame_size[0] === 0 || !((i + toInt_0(frame_size[0] > mp3_bytes, this) | 0) === 0)) {
        info.s1().j5z_1 = i;
        return 0;
      }
    }
    var hdr = mp3.q64(i);
    this.q5z(new UByteArrayIntPtr(dec.g5y_1), hdr, 4);
    info.s1().j5z_1 = i + frame_size[0] | 0;
    info.s1().k5z_1 = i;
    info.s1().l5z_1 = (hdr.e1(3) & 192) === 192 ? 1 : 2;
    info.s1().m5z_1 = this.w5z(hdr);
    info.s1().n5z_1 = 4 - (hdr.e1(1) >> 1 & 3) | 0;
    info.s1().o5z_1 = this.v5z(hdr);
    // Inline function 'kotlin.collections.isEmpty' call
    if (pcm_0.b65_1.length === 0) {
      return this.x5z(hdr);
    }
    this.r5z(bs_frame, hdr.q64(4), frame_size[0] - 4 | 0);
    if ((hdr.e1(1) & 1) === 0) {
      this.s5z(bs_frame, 16);
    }
    if (info.s1().n5z_1 === 3) {
      var main_data_begin = this.f60(bs_frame, scratch.h64_1, hdr);
      if (main_data_begin < 0 || bs_frame.d64_1 > bs_frame.e64_1) {
        this.q5y(dec);
        return 0;
      }
      success = this.a61(dec, bs_frame, scratch, main_data_begin);
      if (!(success === 0)) {
        var igr = 0;
        while (igr < (!((hdr.e1(1) & 8) === 0) ? 2 : 1)) {
          scratch.i64_1[0].a65(0.0, 0, 1152);
          this.b61(dec, scratch, scratch.h64_1.q64(imul(igr, info.s1().l5z_1)), info.s1().l5z_1);
          this.g61(new FloatArrayPtr(dec.d5y_1), scratch.i64_1[0], 18, info.s1().l5z_1, pcm_0, scratch.k64_1[0]);
          igr = igr + 1 | 0;
          pcm_0 = pcm_0.q64(imul(576, info.s1().l5z_1));
        }
      }
      this.z60(dec, scratch);
    } else {
      var sci = new ScaleInfo();
      this.c60(hdr, bs_frame, sci);
      scratch.i64_1[0].a65(0.0, 0, 1152);
      i = 0;
      var igr_0 = 0;
      while (igr_0 < 3) {
        i = i + this.d60(scratch.i64_1[0].q64(i), bs_frame, sci, info.s1().n5z_1 | 1) | 0;
        if (12 === i) {
          i = 0;
          this.e60(sci, (new FloatArrayPtr(sci.u65_1)).q64(igr_0), scratch.i64_1[0]);
          this.g61(new FloatArrayPtr(dec.d5y_1), scratch.i64_1[0], 12, info.s1().l5z_1, pcm_0, scratch.k64_1[0]);
          scratch.i64_1[0].a65(0.0, 0, 1152);
          pcm_0 = pcm_0.q64(imul(384, info.s1().l5z_1));
        }
        if (bs_frame.d64_1 > bs_frame.e64_1) {
          this.q5y(dec);
          return 0;
        }
        igr_0 = igr_0 + 1 | 0;
      }
    }
    return imul(success, this.x5z(new UByteArrayIntPtr(dec.g5y_1)));
  }
}
class Minimp3Decoder extends MiniMp3Program {
  constructor() {
    super();
    this.y5x_1 = new Int16Array(9216);
    this.z5x_1 = Mp3Dec.i5y();
    this.a5y_1 = new Mp3FrameInfo();
    this.q5y(this.z5x_1);
    this.b5y_1 = new BaseMp3DecoderInfo();
  }
  r5y() {
    return this.b5y_1;
  }
  s5y(availablePeek) {
    var samples = this.i5z(this.z5x_1, new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu(this.b5y_1.t5y_1)), availablePeek, new ShortArrayPtr(this.y5x_1), this.a5y_1);
    var struct = this.a5y_1;
    this.b5y_1.y5y_1 = struct.l5z_1;
    this.b5y_1.w5y_1 = struct.m5z_1;
    this.b5y_1.x5y_1 = struct.o5z_1;
    this.b5y_1.a5z_1 = struct.j5z_1;
    this.b5y_1.z5y_1 = samples;
    if (this.b5y_1.y5y_1 === 0 || samples <= 0)
      return null;
    return copyOf(this.y5x_1, imul(samples, this.b5y_1.y5y_1));
  }
  n6() {
  }
}
class BaseMinimp3AudioFormat extends AudioFormat {
  constructor() {
    Companion_getInstance_9();
    super(['mp3']);
  }
  k5v(data, props, $completion) {
    return Companion_getInstance_5().k5v(data, props, $completion);
  }
  p5v(data, props, $completion) {
    return createDecoderStream(this, data, props, null, $completion);
  }
}
class Minimp3AudioFormat extends BaseMinimp3AudioFormat {
  constructor() {
    Minimp3AudioFormat_instance = null;
    super();
    Minimp3AudioFormat_instance = this;
  }
  k61() {
    return new Minimp3Decoder();
  }
}
class BaseMp3DecoderInfo {
  constructor() {
    this.t5y_1 = new Int8Array(4608);
    this.u5y_1 = new ByteArrayDeque();
    this.v5y_1 = null;
    this.w5y_1 = 0;
    this.x5y_1 = 0;
    this.y5y_1 = 0;
    this.z5y_1 = 0;
    this.a5z_1 = 0;
    this.b5z_1 = 0;
    this.c5z_1 = 0;
    this.d5z_1 = 0;
    this.e5z_1 = 0;
    this.f5z_1 = 0;
    this.g5z_1 = 0;
    this.h5z_1 = 0;
  }
  p2u() {
    var tmp11_safe_receiver = this.v5y_1;
    if (tmp11_safe_receiver == null)
      null;
    else {
      tmp11_safe_receiver.k3();
    }
    this.u5y_1.k3();
    this.b5z_1 = 0;
    this.c5z_1 = -1;
    this.e5z_1 = 0;
  }
  l62(decoder) {
    var availablePeek = this.u5y_1.l16(this.t5y_1, 0, this.t5y_1.length);
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOf(this.t5y_1, Companion_getInstance_9().m62_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.audio.format.BaseMp3DecoderInfo.step.<anonymous>' call
    if (this_0 >= 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var xingIndex = tmp0_elvis_lhs == null ? this.t5y_1.length : tmp0_elvis_lhs;
    // Inline function 'kotlin.takeIf' call
    var this_1 = indexOf(this.t5y_1, Companion_getInstance_9().n62_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.audio.format.BaseMp3DecoderInfo.step.<anonymous>' call
    if (this_1 >= 0) {
      tmp_0 = this_1;
    } else {
      tmp_0 = null;
    }
    var tmp1_elvis_lhs = tmp_0;
    var infoIndex = tmp1_elvis_lhs == null ? this.t5y_1.length : tmp1_elvis_lhs;
    if (xingIndex < this.t5y_1.length || infoIndex < this.t5y_1.length) {
      try {
        // Inline function 'kotlin.math.min' call
        var index = Math.min(xingIndex, infoIndex);
        var data = new FastByteArrayInputStream(this.t5y_1, index);
        data.zx(7);
        if (data.ox() >= 1) {
          var flags = data.q1s();
          var FRAMES_FLAG = 1;
          var BYTES_FLAG = 2;
          var TOC_FLAG = 4;
          var VBR_SCALE_FLAG = 8;
          if (hasFlags(flags, FRAMES_FLAG) && data.ox() >= 4) {
            this.f5z_1 = data.u1s();
            if (hasFlags(flags, BYTES_FLAG)) {
              data.zx(4);
            }
            if (hasFlags(flags, TOC_FLAG)) {
              data.zx(100);
            }
            if (hasFlags(flags, VBR_SCALE_FLAG)) {
              data.zx(4);
            }
            if (data.ox() >= 1) {
              var info = data.q1s();
              if (!(info === 0)) {
                data.zx(20);
                if (data.ox() >= 3) {
                  var t0 = data.q1s();
                  var t1 = data.q1s();
                  var t2 = data.q1s();
                  this.g5z_1 = (t0 << 4 | (t1 >>> 4 | 0)) + 529 | 0;
                  this.h5z_1 = ((t1 & 15) << 8 | t2) - 529 | 0;
                }
              }
            }
          }
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
    }
    var buf = decoder.s5y(availablePeek);
    if (!(this.y5y_1 === 0) && (!(this.f5z_1 === 0) || !(this.g5z_1 === 0) || !(this.h5z_1 === 0))) {
      var rpadding = imul(this.h5z_1, this.y5y_1);
      var to_skip = imul(this.g5z_1, this.y5y_1);
      var detected_samples = imul(imul(this.z5y_1, this.f5z_1), this.y5y_1);
      if (detected_samples >= to_skip)
        detected_samples = detected_samples - to_skip | 0;
      if (1 <= rpadding ? rpadding <= detected_samples : false)
        detected_samples = detected_samples - rpadding | 0;
      this.b5z_1 = to_skip + imul(this.z5y_1, this.y5y_1) | 0;
      this.c5z_1 = detected_samples;
      this.d5z_1 = detected_samples / this.y5y_1 | 0;
      this.f5z_1 = 0;
      this.g5z_1 = 0;
      this.h5z_1 = 0;
    }
    if (!(this.y5y_1 === 0) && this.v5y_1 == null) {
      this.v5y_1 = new AudioSamplesDeque(this.y5y_1);
    }
    if (this.z5y_1 > 0) {
      var offset = 0;
      var toRead = imul(this.z5y_1, this.y5y_1);
      if (this.b5z_1 > 0) {
        // Inline function 'kotlin.math.min' call
        var a = this.b5z_1;
        var b = toRead;
        var skipNow = Math.min(a, b);
        offset = offset + skipNow | 0;
        toRead = toRead - skipNow | 0;
        this.b5z_1 = this.b5z_1 - skipNow | 0;
      }
      if (this.c5z_1 >= 0) {
        // Inline function 'kotlin.math.min' call
        var a_0 = toRead;
        var b_0 = this.c5z_1;
        toRead = Math.min(a_0, b_0);
        this.c5z_1 = this.c5z_1 - toRead | 0;
      }
      ensureNotNull(this.v5y_1).o62(_AudioSampleArray___init__impl__qpxoq0(ensureNotNull(buf)), offset, toRead);
    }
    this.u5y_1.m16(this.a5z_1);
    if (this.a5z_1 === 0 && this.z5y_1 === 0) {
      return false;
    }
    if (!(this.v5y_1 == null) && ensureNotNull(this.v5y_1).w15() > 0) {
      return true;
    }
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_6 = this;
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.m62_1 = new Int8Array([88, 105, 110, 103]);
    var tmp_0 = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0.n62_1 = new Int8Array([73, 110, 102, 111]);
  }
}
class AudioStream {
  constructor(rate, channels, name, $box) {
    name = name === VOID ? null : name;
    boxApply(this, $box);
    this.b62_1 = rate;
    this.c62_1 = channels;
    this.d62_1 = name;
    this.e62_1 = false;
    this.f62_1 = null;
    this.g62_1 = new Long(0, 0);
  }
  p62() {
    return this.e62_1;
  }
  h62(time) {
    return numberToLong(get_seconds(time) * this.b62_1);
  }
  r62(out, offset, length, $completion) {
    return 0;
  }
  n6() {
    return Unit_instance;
  }
}
class BaseMinimp3AudioFormat$createDecoderStream$2 extends AudioStream {
  constructor($decoder, $mp3SeekingTable, $data, $table, this$0, $dataStartPosition, $props, $box) {
    if ($box === VOID)
      $box = {};
    $box.u61_1 = $decoder;
    $box.v61_1 = $mp3SeekingTable;
    $box.w61_1 = $data;
    $box.x61_1 = $table;
    $box.y61_1 = this$0;
    $box.z61_1 = $dataStartPosition;
    $box.a62_1 = $props;
    super($decoder.r5y().w5y_1, $decoder.r5y().y5y_1, VOID, $box);
    this.r61_1 = false;
    var tmp = this;
    // Inline function 'kotlin.takeIf' call
    var this_0 = toLong($decoder.r5y().d5z_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.audio.format.<no name provided>.totalLengthInSamples.<anonymous>' call
    if (!this_0.equals(new Long(0, 0))) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      var tmp10_safe_receiver = $mp3SeekingTable._v;
      tmp_1 = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.l5x($decoder.r5y().w5y_1);
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    tmp.s61_1 = tmp_1;
    this.t61_1 = new Long(0, 0);
  }
  p62() {
    return this.r61_1;
  }
  q62(position, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_seek__qhx6y8.bind(VOID, this, position), $completion);
  }
  r62(out, offset, length, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, this, out, offset, length), $completion);
  }
  n6() {
    this.u61_1.n6();
  }
  s62($completion) {
    // Inline function 'kotlin.also' call
    var this_0 = this.w61_1.e1w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.<no name provided>.clone.<anonymous>' call
    this_0.g1v_1 = this.z61_1;
    return createDecoderStream(this.y61_1, this_0, this.a62_1, this.x61_1, $completion);
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_7 = this;
    this.t62_1 = 2304;
    this.u62_1 = 511;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.v62_1 = new Float32Array([0.7372773, 0.7933533, 0.8433915, 0.8870108, 0.9238795, 0.95371693, 0.976296, 0.9914449, 0.99904823, 0.6755902, 0.6087614, 0.53729963, 0.4617486, 0.38268343, 0.3007058, 0.2164396, 0.13052619, 0.04361938]);
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.w62_1 = new Float32Array([0.7933533, 0.9238795, 0.9914449, 0.6087614, 0.38268343, 0.13052619]);
    var tmp_1 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_1.x62_1 = new Float32Array([10.190008, 0.500603, 0.5024193, 3.4076085, 0.50547093, 0.5224986, 2.057781, 0.5154473, 0.56694406, 1.4841646, 0.5310426, 0.6468218, 1.1694399, 0.5531039, 0.7881546, 0.9725682, 0.582935, 1.0606776, 0.8393496, 0.6225041, 1.7224472, 0.7445363, 0.6748083, 5.1011486]);
    var tmp_2 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_2.y62_1 = new Float32Array([0.0, 1.0, 0.21132487, 0.7886751, 0.3660254, 0.6339746, 0.5, 0.5, 0.6339746, 0.3660254, 0.7886751, 0.21132487, 1.0, 0.0]);
    var tmp_3 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_3.z62_1 = new Float32Array([-1.0, 26.0, -31.0, 208.0, 218.0, 401.0, -519.0, 2063.0, 2000.0, 4788.0, -5517.0, 7134.0, 5959.0, 35640.0, -39336.0, 74992.0, -1.0, 24.0, -35.0, 202.0, 222.0, 347.0, -581.0, 2080.0, 1952.0, 4425.0, -5879.0, 7640.0, 5288.0, 33791.0, -41176.0, 74856.0, -1.0, 21.0, -38.0, 196.0, 225.0, 294.0, -645.0, 2087.0, 1893.0, 4063.0, -6237.0, 8092.0, 4561.0, 31947.0, -43006.0, 74630.0, -1.0, 19.0, -41.0, 190.0, 227.0, 244.0, -711.0, 2085.0, 1822.0, 3705.0, -6589.0, 8492.0, 3776.0, 30112.0, -44821.0, 74313.0, -1.0, 17.0, -45.0, 183.0, 228.0, 197.0, -779.0, 2075.0, 1739.0, 3351.0, -6935.0, 8840.0, 2935.0, 28289.0, -46617.0, 73908.0, -1.0, 16.0, -49.0, 176.0, 228.0, 153.0, -848.0, 2057.0, 1644.0, 3004.0, -7271.0, 9139.0, 2037.0, 26482.0, -48390.0, 73415.0, -2.0, 14.0, -53.0, 169.0, 227.0, 111.0, -919.0, 2032.0, 1535.0, 2663.0, -7597.0, 9389.0, 1082.0, 24694.0, -50137.0, 72835.0, -2.0, 13.0, -58.0, 161.0, 224.0, 72.0, -991.0, 2001.0, 1414.0, 2330.0, -7910.0, 9592.0, 70.0, 22929.0, -51853.0, 72169.0, -2.0, 11.0, -63.0, 154.0, 221.0, 36.0, -1064.0, 1962.0, 1280.0, 2006.0, -8209.0, 9750.0, -998.0, 21189.0, -53534.0, 71420.0, -2.0, 10.0, -68.0, 147.0, 215.0, 2.0, -1137.0, 1919.0, 1131.0, 1692.0, -8491.0, 9863.0, -2122.0, 19478.0, -55178.0, 70590.0, -3.0, 9.0, -73.0, 139.0, 208.0, -29.0, -1210.0, 1870.0, 970.0, 1388.0, -8755.0, 9935.0, -3300.0, 17799.0, -56778.0, 69679.0, -3.0, 8.0, -79.0, 132.0, 200.0, -57.0, -1283.0, 1817.0, 794.0, 1095.0, -8998.0, 9966.0, -4533.0, 16155.0, -58333.0, 68692.0, -4.0, 7.0, -85.0, 125.0, 189.0, -83.0, -1356.0, 1759.0, 605.0, 814.0, -9219.0, 9959.0, -5818.0, 14548.0, -59838.0, 67629.0, -4.0, 7.0, -91.0, 117.0, 177.0, -106.0, -1428.0, 1698.0, 402.0, 545.0, -9416.0, 9916.0, -7154.0, 12980.0, -61289.0, 66494.0, -5.0, 6.0, -97.0, 111.0, 163.0, -127.0, -1498.0, 1634.0, 185.0, 288.0, -9585.0, 9838.0, -8540.0, 11455.0, -62684.0, 65290.0]);
    var tmp_4 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_5 = new Float32Array([0.8574929, 0.881742, 0.94962865, 0.9833146, 0.9955178, 0.9991606, 0.9998992, 0.99999315]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4.a63_1 = [tmp_5, new Float32Array([0.51449573, 0.47173196, 0.31337744, 0.1819132, 0.09457419, 0.04096558, 0.01419856, 0.00369997])];
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_7 = new Float32Array([0.99904823, 0.9914449, 0.976296, 0.95371693, 0.9238795, 0.8870108, 0.8433915, 0.7933533, 0.7372773, 0.04361938, 0.13052619, 0.2164396, 0.3007058, 0.38268343, 0.4617486, 0.53729963, 0.6087614, 0.6755902]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_6.b63_1 = [tmp_7, new Float32Array([1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.9914449, 0.9238795, 0.7933533, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.13052619, 0.38268343, 0.6087614])];
    var tmp_8 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_8.c63_1 = new Float32Array([9.313226E-10, 7.831458E-10, 6.585445E-10, 5.537677E-10]);
    var tmp_9 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_9.d63_1 = new Float32Array([9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 7.0, 7.569318E-7 / 7.0, 6.007772E-7 / 7.0, 9.536743E-7 / 15.0, 7.569318E-7 / 15.0, 6.007772E-7 / 15.0, 9.536743E-7 / 31.0, 7.569318E-7 / 31.0, 6.007772E-7 / 31.0, 9.536743E-7 / 63.0, 7.569318E-7 / 63.0, 6.007772E-7 / 63.0, 9.536743E-7 / 127.0, 7.569318E-7 / 127.0, 6.007772E-7 / 127.0, 9.536743E-7 / 255.0, 7.569318E-7 / 255.0, 6.007772E-7 / 255.0, 9.536743E-7 / 511.0, 7.569318E-7 / 511.0, 6.007772E-7 / 511.0, 9.536743E-7 / 1023.0, 7.569318E-7 / 1023.0, 6.007772E-7 / 1023.0, 9.536743E-7 / 2047.0, 7.569318E-7 / 2047.0, 6.007772E-7 / 2047.0, 9.536743E-7 / 4095.0, 7.569318E-7 / 4095.0, 6.007772E-7 / 4095.0, 9.536743E-7 / 8191.0, 7.569318E-7 / 8191.0, 6.007772E-7 / 8191.0, 9.536743E-7 / 16383.0, 7.569318E-7 / 16383.0, 6.007772E-7 / 16383.0, 9.536743E-7 / 32767.0, 7.569318E-7 / 32767.0, 6.007772E-7 / 32767.0, 9.536743E-7 / 65535.0, 7.569318E-7 / 65535.0, 6.007772E-7 / 65535.0, 9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 5.0, 7.569318E-7 / 5.0, 6.007772E-7 / 5.0, 9.536743E-7 / 9.0, 7.569318E-7 / 9.0, 6.007772E-7 / 9.0]);
    var tmp_10 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_10.e63_1 = new Int32Array([44100, 48000, 32000]);
    var tmp_11 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_12 = [new UByteArrayInt(arrayOfUByte$default(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x18\x1C (08@HPX`p\x80'))];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_11.f63_1 = [tmp_12, [new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x14\x18\x1C (08@P`p\x80\xA0')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x18\x1C (08@P`p\x80\xA0\xC0')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10 0@P`p\x80\x90\xA0\xB0\xC0\xD0\xE0'))]];
    this.g63_1 = arrayOfUByte$default(this, '\x00\x01\x02\x03\f\x05\x06\x07\t\n\x0B\r\x0E\x0F\x12\x13');
    this.h63_1 = arrayOfUByte$default(this, '\x05\x05\x04\x04\x05\x05\x04\x01\x04\x03\x01\x01\x05\x06\x06\x01\x04\x04\x04\x01\x04\x03\x01\x01');
    this.i63_1 = arrayOfUByte$default(this, '\x01\x01\x01\x01\x02\x02\x03\x03\x03\x02');
    this.j63_1 = arrayOfShort$default(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFF01\u0521\u0512\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0122\u0120\uFF01\u0521\u0512\u0502\u0301\u0301\u0301\u0301\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0122\u0120\uFF03\uFEC2\uFEA1\uFE91\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0333\u0332\u0223\u0223\u0113\u0113\u0113\u0113\u0231\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF02\uFEE1\u0531\u0513\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0310\u0310\u0310\u0310\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\u0233\u0230\u0132\u0132\u0123\u0103\uFF04\uFE63\uFE23\uFDE2\u0512\uFDC1\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE81\uFE71\u0453\u0444\u0452\u0425\u0351\u0351\u0315\u0315\u0450\u0443\u0305\u0305\u0434\u0433\u0155\u0154\u0145\u0135\u0342\u0324\u0241\u0241\u0214\u0214\u0204\u0204\u0340\u0332\u0323\u0330\u0231\u0231\u0213\u0213\u0203\u0222\u0121\u0121\u0120\u0102\uFF04\uFE53\uFE13\uFDD1\u0421\u0421\u0412\u0412\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\uFE82\u0435\uFE61\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0433\u0342\u0342\u0255\u0245\u0154\u0154\u0153\u0144\u0324\u0341\u0214\u0214\u0340\u0304\u0332\u0323\u0331\u0313\u0330\u0303\u0122\u0122\u0122\u0122\u0120\u0102\uFF03\uFEA3\uFE62\uFE41\uFE31\u0531\u0513\uFE21\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\uFEC1\u0353\u0335\uFEB1\u0344\u0352\u0325\u0351\u0155\u0154\u0145\u0150\u0215\u0215\u0243\u0243\u0234\u0234\u0305\u0340\u0242\u0224\u0233\u0204\u0141\u0114\u0132\u0123\u0130\u0103\uFF05\uFDC4\uFD23\uFCC2\uFCA1\uFC91\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\u0574\u0547\u0565\u0556\u0573\u0537\u0564\uFDD1\u0536\u0472\u0472\u0427\u0427\u0546\u0570\u0407\u0407\u0426\u0426\u0554\u0553\u0460\u0460\u0535\u0544\u0371\u0371\u0371\u0371\u0177\u0176\u0167\u0175\u0157\u0166\u0155\u0145\u0317\u0317\u0463\u0462\uFD41\u0451\u0415\uFD31\u0361\u0361\u0316\u0316\u0306\u0306\u0450\u0405\u0152\u0125\u0143\u0134\uFCE1\uFCD1\u0341\u0314\u0304\u0332\u0323\u0330\u0142\u0124\u0133\u0140\u0231\u0213\u0203\u0222\u0121\u0112\u0120\u0102\uFF05\uFDF3\uFDA3\uFD53\uFD03\uFCC1\uFCB2\u0512\u0421\u0421\u0520\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0577\u0576\u0567\u0557\u0566\u0574\u0547\uFE01\u0565\u0556\u0473\u0473\u0437\u0437\u0464\u0464\u0554\u0545\u0553\u0535\u0372\u0372\u0372\u0372\u0327\u0327\u0327\u0327\u0446\u0446\u0470\u0470\u0175\u0155\u0217\u0217\u0371\u0307\u0363\u0336\u0306\uFDB1\u0144\u0152\uFD61\u0351\u0226\u0226\u0362\u0360\u0261\u0261\u0125\u0150\u0216\u0216\u0315\u0343\u0305\uFD11\u0342\u0324\u0134\u0133\u0341\u0314\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\uFF04\uFE73\uFE23\uFDD3\uFD92\uFD73\uFD31\uFD21\uFD12\u0531\u0513\u0522\u0421\u0421\u0412\u0412\u0520\u0502\u0400\u0400\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\uFE81\u0467\u0475\u0457\u0466\u0474\u0447\u0456\u0365\u0365\u0373\u0373\u0437\u0455\u0372\u0372\u0177\u0176\u0327\u0364\u0346\u0371\u0317\uFE31\u0363\u0336\u0170\u0107\u0354\u0345\u0344\uFDE1\u0262\u0262\u0226\u0226\u0160\u0150\u0216\u0216\u0361\u0306\u0353\u0335\u0352\u0325\u0251\u0215\u0243\u0234\u0305\u0340\u0242\u0242\u0224\u0224\u0241\u0241\u0133\u0114\u0132\u0123\u0204\u0230\u0103\u0103\uFF06\uF7C5\uF635\uF534\uF4A3\uF462\uF441\uF431\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFD01\uFBE4\uFB43\uFB03\uFAB2\uFA83\uFA43\uFA01\uF9F2\uF9D2\uF9B2\uF991\uF982\uF962\uF942\uF921\uF912\uF8F1\uF8E2\uF8C2\uF8A2\u061D\uF881\uF871\uF861\uF851\u06C3\u06C2\u062C\u06B5\uF841\u06C1\u061C\uF831\u060C\uF821\uF811\u06B3\u063B\uF801\u06B2\uF7F1\u064A\uF7E1\u0649\uF7D1\u052B\u052B\u05B1\u05B1\u051B\u051B\u06B0\u060B\u0669\u06A4\u06A3\u063A\u0695\u0659\u05A2\u05A2\u052A\u052A\uFCF4\uFC33\uFC72\u04FF\u04FE\u04FD\u04EE\u04FC\u04ED\u04FB\u04BF\u04EC\u04CD\uFC41\u03CE\u03CE\u03DD\u03DD\uFC51\u02DF\u01DE\u01DE\u01EF\u01CF\u01FA\u019E\uFBF1\u03EB\u03BE\u03F9\u039F\u03AE\u03DB\u03BD\u01AF\u01DC\u04F8\u048F\u04CC\uFB61\u04E8\uFB51\u037F\u037F\u03AD\u03AD\u04DA\u04CB\u04BC\u046F\u03F6\u03F6\u01EA\u01E9\u01F7\u01E7\u038E\u03F5\u03D9\u039D\u035F\u037E\u03CA\u03BB\u03F4\u034F\uFAC1\u033F\u02F3\u02F3\u03D8\u038D\u01AC\u016E\u02F2\u022F\uFA91\u02F0\u01E6\u01C9\u039C\u03E5\u02BA\u02BA\u03D7\u037D\u02E4\u02E4\u038C\u036D\u02E3\u02E3\u029B\u029B\u03B9\u03AA\u01F1\u011F\u010F\u010F\u02AB\u025E\u024E\u02C8\u02D6\u023E\u012E\u012E\u02E2\u02E0\u01E1\u011E\u020E\u02D5\u025D\u02C7\u027C\u02D4\u02B8\u028B\u024D\u02A9\u029A\u02C6\u016C\u01D3\u023D\u02B7\u01D2\u01D2\u012D\u01D1\u017B\u017B\u02C5\u025C\u0299\u02A7\u013C\u013C\u027A\u0279\u01B4\u01B4\u01D0\u010D\u01A8\u018A\u01C4\u014C\u01B6\u016B\u015B\u0198\u0189\u01C0\u014B\u01A6\u016A\u0197\u0188\u01A5\u015A\u0196\u0187\u0178\u0177\u0167\u05A1\u051A\uF6C1\u050A\uF6B1\u0539\uF6A1\uF691\u0592\u0529\uF681\u0583\u0538\uF671\uF661\uF651\u0491\u0491\u0419\u0419\u0590\u0509\u0584\u0548\u0527\uF641\u0482\u0482\u0428\u0428\u0481\u0481\u01A0\u0186\u0168\u0194\u0193\u0185\u0158\u0176\u0175\u0157\u0166\u0174\u0147\u0165\u0156\u0137\u0164\u0146\u0573\u0572\u0471\u0471\u0417\u0417\u0555\u0570\u0507\u0563\u0536\u0554\u0545\u0562\u0526\u0553\u0318\u0318\u0318\u0318\u0480\u0480\u0408\u0408\u0461\u0461\u0416\u0416\u0460\u0460\u0406\u0406\uF4B1\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0135\u0144\u0214\u0214\u0340\u0304\u0332\u0323\u0231\u0231\u0213\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF06\uFB65\uF9D5\uF8D4\uF834\uF7B4\uF733\uF6E3\uF693\uF653\uF612\uF5F2\uF5D1\uF5C2\uF5A1\u0522\u0521\u0512\u0520\u0502\u0311\u0311\u0311\u0311\u0410\u0410\u0401\u0401\u0300\u0300\u0300\u0300\uFD02\uFCE2\uFCC2\uFCA2\uFC81\uFC71\uFC61\uFC51\uFC41\uFC31\uFC21\uFC11\uFC01\uFBF1\uFBE1\uFBD2\u06BC\u066F\uFBB1\uFBA1\u065F\u06E7\u067E\u06CA\u06AC\u06BB\uFB91\u06F4\u064F\u06F3\u063F\u068D\u066E\u06F2\u062F\uFB81\u06F1\u061F\u06C9\u069C\u06E5\u06BA\u06AB\u065E\u06D7\u067D\u06E4\u064E\u06C8\u068C\u06E3\u06D6\u066D\u063E\u06B9\u069B\u06E2\u06AA\u062E\u06E1\u061E\uFB71\u06D5\u065D\u02FF\u02FE\u02EF\u02FD\u01EE\u01EE\u02DF\u02FC\u02CF\u02ED\u02DE\u02FB\u01BF\u01BF\u02EC\u02CE\u01DD\u01FA\u01AF\u01EB\u01BE\u01DC\u01CD\u01F9\u019F\u01AE\u01DB\u01BD\u01F8\u018F\u01CC\u01E9\u019E\u01F7\u017F\u01DA\u01AD\u01CB\u01F6\u01F6\u02EA\u02F0\u01E8\u018E\u01F5\u01D9\u019D\u01D8\u01E6\u010F\u01E0\u010E\uFA61\uFA51\u054D\uFA41\uFA31\uFA21\u053D\u052D\uFA11\u05D1\u05B7\u057B\u051D\uFA01\u055C\u05A8\u058A\u05C4\u054C\u05B6\u056B\uF9F1\u05C3\u053C\u05A7\u057A\u056A\uF9E1\u042C\u042C\u05C2\u05B5\u01C7\u017C\u01D4\u01B8\u018B\u01A9\u019A\u01C6\u016C\u01D3\u01D2\u01D0\u01C5\u010D\u0199\u01C0\u010C\u01B0\u055B\u05C1\u0598\u0589\u051C\u05B4\u054B\u05A6\u05B3\u0597\u043B\u043B\u0579\u0588\u05B2\u05A5\u042B\u042B\u055A\u05B1\u041B\u041B\u050B\u0596\u0569\u05A4\u054A\u0587\u0578\u05A3\u043A\u043A\u0495\u0459\u04A2\u042A\u04A1\u041A\uF851\u0486\u0468\u0494\u0449\u0493\u0439\uF841\u0485\u0458\u01A0\u010A\u0177\u0190\u0492\u0476\u0467\u0429\u0319\u0319\u0491\u0409\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0474\u0382\u0382\u0328\u0328\u0381\u0381\u0318\u0318\u0447\u0480\u0408\u0465\u0456\u0473\u0437\u0464\u0372\u0327\u0346\u0371\u0355\u0317\uF6F1\u0363\u0170\u0107\u0336\u0354\u0345\u0362\u0326\u0361\uF6A1\u0353\u0160\u0106\u0216\u0216\u0335\u0344\u0252\u0252\u0225\u0225\u0251\u0251\u0215\u0215\u0350\u0305\u0243\u0243\u0234\u0242\u0224\u0233\u0114\u0114\u0241\u0240\u0132\u0123\u0204\u0230\u0131\u0131\u0113\u0103\uFF05\uFC84\uF7F6\uF5C4\uF4F4\uF473\uF431\uF421\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\uFDD1\u05FA\uFDC1\uFDB1\u05F8\u05F7\u057F\u05F6\u056F\u03FF\u03FF\u03FF\u03FF\u05F5\u055F\u04F4\u04F4\u044F\u044F\u043F\u043F\u040F\u040F\u05F3\uFDA4\u032F\u032F\u032F\u032F\u01FE\u01EF\u01FD\u01DF\u01FC\u01CF\u01FB\u01BF\u01AF\u01F9\u019F\u018F\uFD22\uFCF2\u04EE\uFCD1\u04EB\u04DC\uFCC1\u04EA\u04CC\uFCB1\uFCA1\u04AC\uFC91\u04E5\u03DB\u03DB\u02EC\uFD01\u01ED\u01ED\u01CE\u01DD\u019E\u019E\u02AE\u029D\u01DE\u01BE\u01CD\u01BD\u01DA\u01AD\u01E7\u01CA\u019C\u01D7\u04F2\u04F0\u03F1\u03F1\u031F\u031F\uFC05\uFB04\uFA54\uF9D3\uF973\uF923\uF8E3\uF8A2\uF873\uF833\u04E9\u04E9\u05CB\u05BC\u05E8\u058E\u05D9\u057E\u05BB\u05D8\u058D\u05E6\u046E\u046E\u04C9\u04C9\u05BA\u05AB\u055E\u057D\u04E4\u04E4\u054E\u05C8\u048C\u048C\u04E3\u04E3\u04D6\u04D6\u056D\u05B9\uFA81\u041E\u044D\uFA71\u04B7\uFA61\u033E\u033E\u04E0\u040E\u04D5\u045D\u04C7\u047C\u04D4\u04B8\u019B\u01AA\u018B\u019A\u017B\u010D\u04A9\u04C6\u046C\u04D3\u04C5\u045C\u03D0\u03D0\u04A8\u048A\u0499\u04C4\u046B\u04A7\u03C3\u03C3\uF991\u03C1\u030C\uF981\u022E\u022E\u03E2\u03E1\u01B5\u0198\u0189\u0197\u033D\u03D2\u032D\u031D\u03B3\uF931\u02D1\u02D1\u0179\u0188\u034C\u03B6\u033C\u037A\u02C2\u02C2\u032C\u035B\u031C\u03C0\u03B4\u034B\u03A6\u036A\u023B\u023B\uF881\u02B2\u022B\u02B1\u01A5\u015A\u021B\u021B\u03B0\u030B\u0396\u0369\u03A4\u034A\u0387\u0378\u023A\u023A\u03A3\u0395\u02A2\u02A2\uF5F1\u061A\uF5E1\u0649\uF5D1\u0676\u052A\u052A\u05A1\u05A1\u06A0\u060A\u0693\u0639\u0685\u0658\u0592\u0592\u0529\u0529\u0667\u0690\u0591\u0591\u0519\u0519\u0609\u0684\u0648\u0657\u0683\u0638\u0666\u0682\u0528\u0528\u0674\u0647\u0581\u0581\u0518\u0518\u0508\u0508\u0680\u0665\u0573\u0573\u0537\u0537\u0656\u0664\u0572\u0572\u0527\u0527\u0646\u0655\u0570\u0570\u0471\u0471\u0471\u0471\u0159\u0186\u0168\u0177\u0194\u0175\u0417\uF541\uF531\uF521\u0426\u0461\u0416\uF511\u0435\uF501\u0452\u0425\u0315\u0315\u0451\u0450\u0107\u0163\u0136\u0154\u0145\u0162\u0160\u0106\u0153\u0144\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0314\u0314\u0440\u0404\u0332\u0332\u0323\u0323\u0231\u0231\u0213\u0213\u0330\u0303\u0222\u0222\u0121\u0112\u0120\u0102\uFF03\uFEC3\uFE83\uFE42\uFE22\uFE03\u04FF\u04FF\uFCD5\uFB65\uFA55\uF924\uF894\uF814\uF773\uF733\uF6E3\uF692\uF673\uF631\uF622\u0521\u0512\uF601\u0411\u0411\u0410\u0410\u0401\u0401\u0400\u0400\u03FE\u03EF\u03FD\u03DF\u03FC\u03CF\u03FB\u03BF\u02AF\u02AF\u03FA\u03F9\u029F\u029F\u028F\u028F\u03F8\u03F7\u027F\u027F\u02F6\u02F6\u026F\u026F\u02F5\u025F\u02F4\u024F\u02F3\u023F\u02F2\u022F\u021F\u021F\u03F1\u030F\uFDC1\uFD93\uFD53\uFD13\u01F0\uFDB2\u02EE\u02ED\u02DE\u02EC\u03CE\u03DD\u03EB\u03BE\u03DC\u03CD\u03EA\u03AE\u03DB\u03BD\u03CC\u03E9\u039E\u03DA\u03AD\u03CB\u03BC\u03E8\u038E\u03D9\u039D\u03E7\u037E\u03CA\uFBD1\uFBC1\uFBB2\u056E\uFB91\u059C\u05E5\u05AB\u055E\uFB81\u057D\u054E\u05C8\u058C\uFB71\u05E3\u05D6\u056D\u053E\u05B9\u059B\u05AA\u052E\u05E1\u051E\u05D5\u055D\u05C7\u057C\u05D4\u05B8\u058B\u01AC\u01BB\u01D8\u018D\u02E0\u020E\u01D0\u01D0\u01E6\u01C9\u01BA\u01D7\u01E4\u01E2\u054D\u05A9\u059A\u05C6\u056C\u05D3\u053D\u05D2\u052D\u05D1\u05B7\u057B\u051D\u05C5\u055C\u05A8\u058A\u0599\u05C4\u054C\u05B6\u056B\uFA61\u05C3\u053C\u05A7\u057A\u05C2\u052C\u05B5\u055B\u05C1\u010D\u01C0\u0598\u0589\u051C\u05B4\uF951\u05B3\uF941\u05A1\u044B\u044B\u05A6\u056A\u0597\u0579\uF931\u0509\u043B\u043B\u0488\u0488\u05B2\u05A5\u042B\u042B\u055A\u05B1\u051B\u0596\u0469\u0469\u044A\u044A\u010C\u01B0\u010B\u01A0\u010A\u0190\uF8A1\u0478\u04A3\u043A\u0495\u0459\u04A2\u042A\u041A\u0486\u0468\u0477\u0494\u0449\u0493\u0439\u01A4\u0187\u0485\u0458\u0492\u0476\u0467\u0429\u0491\u0419\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0482\u0428\u0481\u0474\u0447\u0418\uF791\u0465\u0456\u0471\uF781\u0337\u0337\u0473\u0472\u0327\u0327\u0180\u0108\u0170\u0107\u0364\u0346\u0355\u0317\u0363\u0336\u0354\u0345\u0362\u0326\u0361\u0316\uF6F1\u0353\u0335\u0344\u0160\u0106\u0352\u0325\u0351\uF6A1\u0215\u0215\u0343\u0334\u0150\u0105\u0242\u0224\u0233\u0241\u0214\u0214\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\u0120\u0102');
    this.k63_1 = arrayOfUByte$default(this, '\x82\xA2\xC1\xD1,\x1CL\x8C\t\t\t\t\t\t\t\t\xBE\xFE\xDE\xEE~^\x9D\x9Dm=\xAD\xCD');
    this.l63_1 = arrayOfUByte$default(this, '\xFC\xEC\xDC\xCC\xBC\xAC\x9C\x8C|l\\L<,\x1C\f');
    this.m63_1 = arrayOfShort$default(this, '\x00 @b\x00\x84\xB4\xDA\u0124\u016C\u01AA\u021A\u0288\u02EA\x00\u0466\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u0732\u0732\u0732\u0732\u0732\u0732\u0732\u0732');
    this.n63_1 = arrayOfUByte$default(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x01\x02\x03\x04\x06\b\n\r\x04\x05\x06\x07\b\t\x0B\r');
    this.o63_1 = arrayOfUByte$default(this, '\x00\x11\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x10\x00\x11\x12\x03\x13\x04\x05\x10\x00\x11\x12\x10\x00\x11\x12\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x00\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10');
    var tmp_13 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_13.p63_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\f\f\f\f\f\f\x10\x14\x18\x1C (08@LZ\x02\x02\x02\x02\x02\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x12\x16\x1A &.6>FL$\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\b\n\f\x10\x14\x18\x1C"*26L\x9E\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\n\f\x10\x12\x16\x1C"(.66\xC0\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\n\f\x10\x14\x18\x1E&.8DTf\x1A\x00'))];
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.q63_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\b\b\b\b\b\b\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00'))];
    var tmp_15 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_15.r63_1 = [new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte$default(this, '\f\f\f\x04\x04\x04\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00', 40))];
    var tmp_16 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_16.s63_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x06\x05\x05\x05\x06\x05\x05\x05\x06\x05\x07\x03\x0B\n\x00\x00\x07\x07\x07\x00\x06\x06\x06\x03\b\b\x05\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\b\t\x06\f\x06\t\t\t\x06\t\f\x06\x0F\x12\x00\x00\x06\x0F\f\x00\x06\f\t\x06\x06\x12\t\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\t\t\x06\f\t\t\t\t\t\t\f\x06\x12\x12\x00\x00\f\f\f\x00\f\t\t\x06\x0F\f\t\x00'))];
    var tmp_17 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_17.t63_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(76), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(32))];
    var tmp_18 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_18.u63_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(60), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(4)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(7)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(19))];
    var tmp_19 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_19.v63_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(0), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(3)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(16), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(8)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(32), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(12)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(40), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(7))];
    var tmp_20 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_20.w63_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(2)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(10))];
    var tmp_21 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_21.x63_1 = new Float32Array([0.0, -1.0, -2.519842, -4.326749, -6.349604, -8.54988, -10.902724, -13.390518, -16.0, -18.720755, -21.544348, -24.463781, -27.473143, -30.56735, -33.741993, -36.99318, 0.0, 1.0, 2.519842, 4.326749, 6.349604, 8.54988, 10.902724, 13.390518, 16.0, 18.720755, 21.544348, 24.463781, 27.473143, 30.56735, 33.741993, 36.99318, 40.317474, 43.71179, 47.173344, 50.69963, 54.288353, 57.93741, 61.644863, 65.40894, 69.22798, 73.10044, 77.024895, 81.0, 85.02449, 89.09719, 93.21697, 97.3828, 101.593666, 105.84863, 110.146805, 114.48732, 118.869385, 123.292206, 127.755066, 132.25725, 136.79808, 141.3769, 145.99312, 150.64612, 155.33533, 160.0602, 164.8202, 169.61482, 174.44357, 179.30598, 184.20157, 189.12991, 194.09058, 199.08315, 204.10721, 209.16238, 214.24829, 219.36456, 224.51085, 229.68678, 234.89206, 240.12633, 245.38928, 250.6806, 256.0, 261.34717, 266.72183, 272.12372, 277.55255, 283.00806, 288.48996, 293.99805, 299.53207, 305.09177, 310.6769, 316.28726, 321.92258, 327.5827, 333.26736, 338.97638, 344.70956, 350.46664, 356.24747, 362.05188, 367.8796, 373.73053, 379.60443, 385.50113, 391.4205, 397.3623, 403.32642, 409.31268, 415.3209, 421.3509, 427.4026, 433.47574, 439.57028, 445.68597, 451.82275, 457.98044, 464.15887, 470.35797, 476.57755, 482.81744, 489.0776, 495.35788, 501.65808, 507.97815, 514.31793, 520.6773, 527.0562, 533.4544, 539.8719, 546.3085, 552.76404, 559.2386, 565.7319, 572.2439, 578.7744, 585.3235, 591.89087, 598.47656, 605.08044, 611.70233, 618.3422, 625.0, 631.67554, 638.3688, 645.0796]);
  }
}
class L12_subband_alloc_tStruct {
  constructor(tab_offset, code_tab_width, band_count) {
    this.y63_1 = tab_offset;
    this.z63_1 = code_tab_width;
    this.a64_1 = band_count;
  }
  toString() {
    return 'L12_subband_alloc_tStruct(tab_offset=' + new UByte(this.y63_1) + ', code_tab_width=' + new UByte(this.z63_1) + ', band_count=' + new UByte(this.a64_1) + ')';
  }
  hashCode() {
    var result = UByte__hashCode_impl_mmczcb(this.y63_1);
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.z63_1) | 0;
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.a64_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof L12_subband_alloc_tStruct))
      return false;
    var tmp0_other_with_cast = other instanceof L12_subband_alloc_tStruct ? other : THROW_CCE();
    if (!(this.y63_1 === tmp0_other_with_cast.y63_1))
      return false;
    if (!(this.z63_1 === tmp0_other_with_cast.z63_1))
      return false;
    if (!(this.a64_1 === tmp0_other_with_cast.a64_1))
      return false;
    return true;
  }
}
class Mp3Dec {
  static b64(mdct_overlap, qmf_state, reserv, free_format_bytes_array, header, reserv_buf) {
    var $this = createThis(this);
    $this.c5y_1 = mdct_overlap;
    $this.d5y_1 = qmf_state;
    $this.e5y_1 = reserv;
    $this.f5y_1 = free_format_bytes_array;
    $this.g5y_1 = header;
    $this.h5y_1 = reserv_buf;
    return $this;
  }
  static i5y() {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(2), null);
    while (tmp < 2) {
      tmp_0[tmp] = new Float32Array(288);
      tmp = tmp + 1 | 0;
    }
    return this.b64(tmp_0, new Float32Array(960), 0, new Int32Array(1), _UByteArrayInt___init__impl__xif7bu_1(4), _UByteArrayInt___init__impl__xif7bu_1(511));
  }
}
class Bs {
  constructor(buf, pos, limit) {
    buf = buf === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : buf;
    pos = pos === VOID ? 0 : pos;
    limit = limit === VOID ? 0 : limit;
    this.c64_1 = buf;
    this.d64_1 = pos;
    this.e64_1 = limit;
  }
}
class Mp3Scratch {
  static m64(bs, maindata, gr_info, grbuf, scf, syn, ist_pos) {
    var $this = createThis(this);
    $this.f64_1 = bs;
    $this.g64_1 = maindata;
    $this.h64_1 = gr_info;
    $this.i64_1 = grbuf;
    $this.j64_1 = scf;
    $this.k64_1 = syn;
    $this.l64_1 = ist_pos;
    return $this;
  }
  static n64() {
    var tmp = new Bs();
    var tmp_0 = new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(2815));
    var tmp_1 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(4), null);
    while (tmp_1 < 4) {
      tmp_2[tmp_1] = new GrInfo();
      tmp_1 = tmp_1 + 1 | 0;
    }
    var tmp_3 = new ArrayPtr(tmp_2, 0);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.Mp3Scratch.<init>.<anonymous>' call
    var CSIZE = 576;
    var data = new Float32Array(imul(2, CSIZE));
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(2), null);
    while (tmp_4 < 2) {
      var tmp_6 = tmp_4;
      tmp_5[tmp_6] = new FloatArrayPtr(data, imul(CSIZE, tmp_6));
      tmp_4 = tmp_4 + 1 | 0;
    }
    var tmp_7 = tmp_5;
    var tmp_8 = new FloatArrayPtr(new Float32Array(40));
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.Mp3Scratch.<init>.<anonymous>' call
    var CSIZE_0 = 64;
    var data_0 = new Float32Array(imul(33, CSIZE_0));
    var tmp_9 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_10 = fillArrayVal(Array(33), null);
    while (tmp_9 < 33) {
      var tmp_11 = tmp_9;
      tmp_10[tmp_11] = new FloatArrayPtr(data_0, imul(CSIZE_0, tmp_11));
      tmp_9 = tmp_9 + 1 | 0;
    }
    var tmp_12 = tmp_10;
    var tmp_13 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(2), null);
    while (tmp_13 < 2) {
      var tmp_15 = tmp_13;
      var tmp$ret$11 = _UByteArrayInt___init__impl__xif7bu_1(39);
      tmp_14[tmp_15] = new UByteArrayInt(tmp$ret$11);
      tmp_13 = tmp_13 + 1 | 0;
    }
    return this.m64(tmp, tmp_0, tmp_3, tmp_7, tmp_8, tmp_12, tmp_14);
  }
}
class Mp3FrameInfo {
  constructor(frame_bytes, frame_offset, channels, hz, layer, bitrate_kbps) {
    frame_bytes = frame_bytes === VOID ? 0 : frame_bytes;
    frame_offset = frame_offset === VOID ? 0 : frame_offset;
    channels = channels === VOID ? 0 : channels;
    hz = hz === VOID ? 0 : hz;
    layer = layer === VOID ? 0 : layer;
    bitrate_kbps = bitrate_kbps === VOID ? 0 : bitrate_kbps;
    this.j5z_1 = frame_bytes;
    this.k5z_1 = frame_offset;
    this.l5z_1 = channels;
    this.m5z_1 = hz;
    this.n5z_1 = layer;
    this.o5z_1 = bitrate_kbps;
  }
  s1() {
    return this;
  }
}
class ArrayPtr {
  constructor(array, pos) {
    this.o64_1 = array;
    this.p64_1 = pos;
  }
  s1() {
    return this.o64_1[this.p64_1];
  }
  e1(index) {
    return this.o64_1[this.p64_1 + index | 0];
  }
  c4() {
    return new ArrayPtr(this.o64_1, this.p64_1 + 1 | 0);
  }
  q64(other) {
    return new ArrayPtr(this.o64_1, this.p64_1 + other | 0);
  }
}
class UByteArrayIntPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.r64_1 = array;
    this.s64_1 = pos;
  }
  s1() {
    return UByteArrayInt__get_impl_px6q8a(this.r64_1, this.s64_1);
  }
  e1(index) {
    return UByteArrayInt__get_impl_px6q8a(this.r64_1, this.s64_1 + index | 0);
  }
  x2o(index, value) {
    UByteArrayInt__set_impl_gn4532(this.r64_1, this.s64_1 + index | 0, value);
  }
  c4() {
    return new UByteArrayIntPtr(this.r64_1, this.s64_1 + 1 | 0);
  }
  q64(other) {
    return new UByteArrayIntPtr(this.r64_1, this.s64_1 + other | 0);
  }
  t64(other) {
    return this.s64_1 - other.s64_1 | 0;
  }
  u64(value, from, to) {
    var tmp = _UByteArrayInt___get_bytes__impl__pj0ilc(this.r64_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    fill(tmp, tmp$ret$0, this.s64_1 + from | 0, this.s64_1 + to | 0);
  }
}
class FloatArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.v64_1 = array;
    this.w64_1 = pos;
  }
  x64(value) {
    this.v64_1[this.w64_1] = value;
  }
  s1() {
    return this.v64_1[this.w64_1];
  }
  e1(index) {
    return this.v64_1[this.w64_1 + index | 0];
  }
  y64(index, value) {
    this.v64_1[this.w64_1 + index | 0] = value;
  }
  c4() {
    return new FloatArrayPtr(this.v64_1, this.w64_1 + 1 | 0);
  }
  q64(other) {
    return new FloatArrayPtr(this.v64_1, this.w64_1 + other | 0);
  }
  z64(other) {
    return this.w64_1 - other.w64_1 | 0;
  }
  a65(value, from, to) {
    fill_0(this.v64_1, value, this.w64_1 + from | 0, this.w64_1 + to | 0);
  }
}
class ShortArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.b65_1 = array;
    this.c65_1 = pos;
  }
  d65(index, value) {
    this.b65_1[this.c65_1 + index | 0] = value;
  }
  q64(other) {
    return new ShortArrayPtr(this.b65_1, this.c65_1 + other | 0);
  }
}
class GrInfo {
  constructor(sfbtab, part_23_length, big_values, scalefac_compress, global_gain, block_type, mixed_block_flag, n_long_sfb, n_short_sfb, table_select, region_count, subblock_gain, preflag, scalefac_scale, count1_table, scfsi) {
    sfbtab = sfbtab === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : sfbtab;
    part_23_length = part_23_length === VOID ? 0 : part_23_length;
    big_values = big_values === VOID ? 0 : big_values;
    scalefac_compress = scalefac_compress === VOID ? 0 : scalefac_compress;
    global_gain = global_gain === VOID ? 0 : global_gain;
    block_type = block_type === VOID ? 0 : block_type;
    mixed_block_flag = mixed_block_flag === VOID ? 0 : mixed_block_flag;
    n_long_sfb = n_long_sfb === VOID ? 0 : n_long_sfb;
    n_short_sfb = n_short_sfb === VOID ? 0 : n_short_sfb;
    table_select = table_select === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : table_select;
    region_count = region_count === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : region_count;
    subblock_gain = subblock_gain === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : subblock_gain;
    preflag = preflag === VOID ? 0 : preflag;
    scalefac_scale = scalefac_scale === VOID ? 0 : scalefac_scale;
    count1_table = count1_table === VOID ? 0 : count1_table;
    scfsi = scfsi === VOID ? 0 : scfsi;
    this.e65_1 = sfbtab;
    this.f65_1 = part_23_length;
    this.g65_1 = big_values;
    this.h65_1 = scalefac_compress;
    this.i65_1 = global_gain;
    this.j65_1 = block_type;
    this.k65_1 = mixed_block_flag;
    this.l65_1 = n_long_sfb;
    this.m65_1 = n_short_sfb;
    this.n65_1 = table_select;
    this.o65_1 = region_count;
    this.p65_1 = subblock_gain;
    this.q65_1 = preflag;
    this.r65_1 = scalefac_scale;
    this.s65_1 = count1_table;
    this.t65_1 = scfsi;
  }
}
class ScaleInfo {
  constructor(scf, total_bands, stereo_bands, bitalloc, scfcod) {
    scf = scf === VOID ? new Float32Array(192) : scf;
    total_bands = total_bands === VOID ? 0 : total_bands;
    stereo_bands = stereo_bands === VOID ? 0 : stereo_bands;
    bitalloc = bitalloc === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : bitalloc;
    scfcod = scfcod === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : scfcod;
    this.u65_1 = scf;
    this.v65_1 = total_bands;
    this.w65_1 = stereo_bands;
    this.x65_1 = bitalloc;
    this.y65_1 = scfcod;
  }
}
class WAV extends AudioFormat {
  constructor() {
    Companion_getInstance_11();
    super(['wav']);
  }
  k5v(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh_1.bind(VOID, this, data, props), $completion);
  }
  p5v(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamInternal__hls877_0.bind(VOID, this, data, props), $completion);
  }
  y66(data, handle, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parse__tgo4f5.bind(VOID, this, data, handle), $completion);
  }
  z66(data, handler, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_riff__qieez3.bind(VOID, this, data, handler), $completion);
  }
}
class Companion_7 extends WAV {
  constructor() {
    Companion_instance_8 = null;
    super();
    Companion_instance_8 = this;
  }
}
class Chunk {
  constructor(type, data) {
    this.n66_1 = type;
    this.o66_1 = data;
  }
  nl() {
    return this.n66_1;
  }
  ol() {
    return this.o66_1;
  }
  toString() {
    return 'Chunk(type=' + this.n66_1 + ', data=' + this.o66_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.n66_1);
    result = imul(result, 31) + hashCode(this.o66_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Chunk))
      return false;
    var tmp0_other_with_cast = other instanceof Chunk ? other : THROW_CCE();
    if (!(this.n66_1 === tmp0_other_with_cast.n66_1))
      return false;
    if (!equals(this.o66_1, tmp0_other_with_cast.o66_1))
      return false;
    return true;
  }
}
class ProcessedChunk {
  constructor(type, data, extra) {
    this.a67_1 = type;
    this.b67_1 = data;
    this.c67_1 = extra;
  }
  toString() {
    return 'ProcessedChunk(type=' + this.a67_1 + ', data=' + this.b67_1.toString() + ', extra=' + toString(this.c67_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a67_1);
    result = imul(result, 31) + hashCode(this.b67_1) | 0;
    result = imul(result, 31) + hashCode(this.c67_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessedChunk))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessedChunk ? other : THROW_CCE();
    if (!(this.a67_1 === tmp0_other_with_cast.a67_1))
      return false;
    if (!equals(this.b67_1, tmp0_other_with_cast.b67_1))
      return false;
    if (!equals(this.c67_1, tmp0_other_with_cast.c67_1))
      return false;
    return true;
  }
}
class WavAudioStream extends AudioStream {
  constructor(fmt, buffer, bufferLength, data, props) {
    super(fmt.u66_1, fmt.t66_1);
    this.f66_1 = fmt;
    this.g66_1 = buffer;
    this.h66_1 = bufferLength;
    this.i66_1 = data;
    this.j66_1 = props;
    this.k66_1 = this.f66_1.d67();
    this.l66_1 = false;
  }
  p62() {
    return this.l66_1;
  }
  q62(position, $completion) {
    this.l66_1 = false;
    var tmp = this.g66_1;
    // Inline function 'kotlin.Long.times' call
    var this_0 = this.h62(position);
    var other = this.k66_1;
    tmp.g1v_1 = this_0.z3(toLong(other));
  }
  r62(out, offset, length, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_0.bind(VOID, this, out, offset, length), $completion);
  }
  s62($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_clone__nh2r5j.bind(VOID, this), $completion);
  }
}
class Fmt {
  constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample) {
    formatTag = formatTag === VOID ? -1 : formatTag;
    channels = channels === VOID ? 2 : channels;
    samplesPerSec = samplesPerSec === VOID ? 44100 : samplesPerSec;
    avgBytesPerSec = avgBytesPerSec === VOID ? new Long(0, 0) : avgBytesPerSec;
    blockAlign = blockAlign === VOID ? 0 : blockAlign;
    bitsPerSample = bitsPerSample === VOID ? 0 : bitsPerSample;
    this.s66_1 = formatTag;
    this.t66_1 = channels;
    this.u66_1 = samplesPerSec;
    this.v66_1 = avgBytesPerSec;
    this.w66_1 = blockAlign;
    this.x66_1 = bitsPerSample;
  }
  d67() {
    return this.x66_1 / 8 | 0;
  }
  toString() {
    return 'Fmt(formatTag=' + this.s66_1 + ', channels=' + this.t66_1 + ', samplesPerSec=' + this.u66_1 + ', avgBytesPerSec=' + this.v66_1.toString() + ', blockAlign=' + this.w66_1 + ', bitsPerSample=' + this.x66_1 + ')';
  }
  hashCode() {
    var result = this.s66_1;
    result = imul(result, 31) + this.t66_1 | 0;
    result = imul(result, 31) + this.u66_1 | 0;
    result = imul(result, 31) + this.v66_1.hashCode() | 0;
    result = imul(result, 31) + this.w66_1 | 0;
    result = imul(result, 31) + this.x66_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fmt))
      return false;
    var tmp0_other_with_cast = other instanceof Fmt ? other : THROW_CCE();
    if (!(this.s66_1 === tmp0_other_with_cast.s66_1))
      return false;
    if (!(this.t66_1 === tmp0_other_with_cast.t66_1))
      return false;
    if (!(this.u66_1 === tmp0_other_with_cast.u66_1))
      return false;
    if (!this.v66_1.equals(tmp0_other_with_cast.v66_1))
      return false;
    if (!(this.w66_1 === tmp0_other_with_cast.w66_1))
      return false;
    if (!(this.x66_1 === tmp0_other_with_cast.x66_1))
      return false;
    return true;
  }
}
class WAV$parse$slambda {
  constructor($fmt, $dataSize, $handle) {
    this.p66_1 = $fmt;
    this.q66_1 = $dataSize;
    this.r66_1 = $handle;
  }
  e67($this$riff, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$riff), $completion);
  }
  de(p1, $completion) {
    return this.e67(p1 instanceof Chunk ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_8 {}
class AudioSamplesDeque {
  constructor(channels) {
    this.i62_1 = channels;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.i62_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = new ShortArrayDeque();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.j62_1 = tmp_2;
  }
  w15() {
    var tmp34_safe_receiver = getOrNull_0(this.j62_1, 0);
    var tmp0_elvis_lhs = tmp34_safe_receiver == null ? null : tmp34_safe_receiver.w15();
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  f67() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var this_0 = this.j62_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block;
      }
      // Inline function 'korlibs.audio.sound.AudioSamplesDeque.<get-availableReadMax>.<anonymous>' call
      var maxValue = this_0[0].w15();
      var inductionVariable = 1;
      var last = get_lastIndex(this_0);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.audio.sound.AudioSamplesDeque.<get-availableReadMax>.<anonymous>' call
          var v = this_0[i].w15();
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
         while (!(i === last));
      tmp$ret$1 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  g67(channel) {
    return _AudioSample___init__impl__s54gd5(this.j62_1[channel].x2n());
  }
  h67(channel, sample) {
    this.j62_1[channel].y2n(_AudioSample___get_short__impl__uk8ygu(sample));
  }
  i67(samples, offset, len) {
    var inductionVariable = 0;
    var last = this.i62_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.j67(channel, samples.f5u(channel % samples.l5s_1 | 0), offset, len);
      }
       while (inductionVariable < last);
  }
  j67(channel, data, offset, len) {
    this.j62_1[channel].w2n(AudioSampleArray__asShortArray_impl_iyd0md(data), offset, len);
  }
  k67(data, offset, len, channels) {
    switch (channels) {
      case 1:
        var inductionVariable = 0;
        var last = this.i62_1;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.j62_1[n].w2n(AudioSampleArray__asShortArray_impl_iyd0md(data), offset, len);
          }
           while (inductionVariable < last);
        break;
      case 2:
        var inductionVariable_0 = 0;
        var last_0 = len / 2 | 0;
        if (inductionVariable_0 < last_0)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.h67(0, AudioSampleArray__get_impl_w0l0xc(data, imul(n_0, 2) + 0 | 0));
          }
           while (inductionVariable_0 < last_0);
        var inductionVariable_1 = 0;
        var last_1 = len / 2 | 0;
        if (inductionVariable_1 < last_1)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            this.h67(1, AudioSampleArray__get_impl_w0l0xc(data, imul(n_1, 2) + 1 | 0));
          }
           while (inductionVariable_1 < last_1);
        break;
      default:
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < channels)
          do {
            var c = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var inductionVariable_3 = 0;
            var last_2 = len / channels | 0;
            if (inductionVariable_3 < last_2)
              do {
                var n_2 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                this.h67(c, AudioSampleArray__get_impl_w0l0xc(data, imul(n_2, channels) + c | 0));
              }
               while (inductionVariable_3 < last_2);
          }
           while (inductionVariable_2 < channels);
        break;
    }
  }
  o62(data, offset, len, channels, $super) {
    len = len === VOID ? _AudioSampleArray___get_size__impl__8l8tm8(data) - offset | 0 : len;
    channels = channels === VOID ? this.i62_1 : channels;
    var tmp;
    if ($super === VOID) {
      this.k67(data, offset, len, channels);
      tmp = Unit_instance;
    } else {
      tmp = $super.k67.call(this, new AudioSampleArray(data), offset, len, channels);
    }
    return tmp;
  }
  k62(out, offset, len) {
    // Inline function 'kotlin.math.min' call
    var b = this.w15();
    var rlen = Math.min(len, b);
    var inductionVariable = 0;
    var last = out.l5s_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.j62_1[channel % this.i62_1 | 0].v2n(AudioSampleArray__asShortArray_impl_iyd0md(out.f5u(channel)), offset, rlen);
      }
       while (inductionVariable < last);
    return rlen;
  }
  l67(out, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? out.m5s_1 - offset | 0 : len;
    return $super === VOID ? this.k62(out, offset, len) : $super.k62.call(this, out, offset, len);
  }
  m67(out, offset, len) {
    // Inline function 'kotlin.math.min' call
    var b = this.w15();
    var rlen = Math.min(len, b);
    var channels = this.i62_1;
    var inductionVariable = 0;
    var last = out.l5t_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inChannel = channel % channels | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < rlen)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.g5u(channel, offset + n | 0, this.g67(inChannel));
          }
           while (inductionVariable_0 < rlen);
      }
       while (inductionVariable < last);
    return rlen;
  }
  n67(out, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? out.m5t_1 - offset | 0 : len;
    return $super === VOID ? this.m67(out, offset, len) : $super.m67.call(this, out, offset, len);
  }
  k3() {
    var inductionVariable = 0;
    var last = this.j62_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.j62_1[c].k3();
      }
       while (inductionVariable <= last);
  }
  toString() {
    return 'AudioSamplesDeque(channels=' + this.i62_1 + ', availableRead=' + this.w15() + ')';
  }
}
class Companion_9 {}
class createSound$slambda {
  constructor($stream) {
    this.o67_1 = $stream;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_11 = this;
    var tmp = this;
    // Inline function 'korlibs.audio.sound.playbackTimes' call
    var tmp_0 = _PlaybackTimes___init__impl__rt6rw2(1);
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$2 = toDuration(0, DurationUnit_SECONDS_getInstance());
    tmp.p67_1 = new PlaybackParameters(tmp_0, tmp$ret$2);
  }
}
class PlaybackParameters {
  constructor(times, startTime, bufferTime, volume, pitch, panning, position, onCancel, onFinish) {
    Companion_getInstance_14();
    var tmp;
    if (times === VOID) {
      // Inline function 'korlibs.audio.sound.playbackTimes' call
      tmp = _PlaybackTimes___init__impl__rt6rw2(1);
    } else {
      tmp = times;
    }
    times = tmp;
    var tmp_0;
    if (startTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp_0 = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_0 = startTime;
    }
    startTime = tmp_0;
    var tmp_1;
    if (bufferTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      tmp_1 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_1 = bufferTime;
    }
    bufferTime = tmp_1;
    volume = volume === VOID ? 1.0 : volume;
    pitch = pitch === VOID ? 1.0 : pitch;
    panning = panning === VOID ? 0.0 : panning;
    position = position === VOID ? Companion_getInstance_2().m2l_1 : position;
    onCancel = onCancel === VOID ? null : onCancel;
    onFinish = onFinish === VOID ? null : onFinish;
    this.q67_1 = times;
    this.r67_1 = startTime;
    this.s67_1 = bufferTime;
    this.t67_1 = volume;
    this.u67_1 = pitch;
    this.v67_1 = panning;
    this.w67_1 = position;
    this.x67_1 = onCancel;
    this.y67_1 = onFinish;
  }
  q5t() {
    return this.t67_1;
  }
  x5t() {
    return this.u67_1;
  }
  s5t() {
    return this.v67_1;
  }
  h1s() {
    return this.w67_1;
  }
  toString() {
    return 'PlaybackParameters(times=' + PlaybackTimes__toString_impl_l4chjq(this.q67_1) + ', startTime=' + Duration__toString_impl_8d916b(this.r67_1) + ', bufferTime=' + Duration__toString_impl_8d916b(this.s67_1) + ', volume=' + this.t67_1 + ', pitch=' + this.u67_1 + ', panning=' + this.v67_1 + ', position=' + this.w67_1.toString() + ', onCancel=' + toString_0(this.x67_1) + ', onFinish=' + toString_0(this.y67_1) + ')';
  }
  hashCode() {
    var result = PlaybackTimes__hashCode_impl_mtf95(this.q67_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.r67_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.s67_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t67_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u67_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v67_1) | 0;
    result = imul(result, 31) + this.w67_1.hashCode() | 0;
    result = imul(result, 31) + (this.x67_1 == null ? 0 : hashCode(this.x67_1)) | 0;
    result = imul(result, 31) + (this.y67_1 == null ? 0 : hashCode(this.y67_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaybackParameters))
      return false;
    var tmp0_other_with_cast = other instanceof PlaybackParameters ? other : THROW_CCE();
    if (!(this.q67_1 === tmp0_other_with_cast.q67_1))
      return false;
    if (!equals(this.r67_1, tmp0_other_with_cast.r67_1))
      return false;
    if (!equals(this.s67_1, tmp0_other_with_cast.s67_1))
      return false;
    if (!equals(this.t67_1, tmp0_other_with_cast.t67_1))
      return false;
    if (!equals(this.u67_1, tmp0_other_with_cast.u67_1))
      return false;
    if (!equals(this.v67_1, tmp0_other_with_cast.v67_1))
      return false;
    if (!this.w67_1.equals(tmp0_other_with_cast.w67_1))
      return false;
    if (!equals(this.x67_1, tmp0_other_with_cast.x67_1))
      return false;
    if (!equals(this.y67_1, tmp0_other_with_cast.y67_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_12 = this;
    this.z67_1 = _PlaybackTimes___init__impl__rt6rw2(0);
    this.a68_1 = _PlaybackTimes___init__impl__rt6rw2(1);
    this.b68_1 = _PlaybackTimes___init__impl__rt6rw2(-1);
  }
}
class PlaybackTimes {
  constructor(count) {
    Companion_getInstance_15();
    this.c68_1 = count;
  }
  toString() {
    return PlaybackTimes__toString_impl_l4chjq(this.c68_1);
  }
  hashCode() {
    return PlaybackTimes__hashCode_impl_mtf95(this.c68_1);
  }
  equals(other) {
    return PlaybackTimes__equals_impl_suah7n(this.c68_1, other);
  }
}
class SoundPlay {}
function play(params, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.zc();
  return this.m68(tmp$ret$0, params);
}
class Sound {
  constructor(creationCoroutineContext) {
    this.d68_1 = new Mixin();
    this.e68_1 = creationCoroutineContext;
    this.f68_1 = this.e68_1;
    this.g68_1 = 'UnknownNativeSound';
    this.h68_1 = 1.0;
    this.i68_1 = 0.0;
    this.j68_1 = 1.0;
    this.k68_1 = Companion_getInstance_2().m2l_1;
    var tmp = this;
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    tmp.l68_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
  }
  yz(_set____db54di) {
    this.d68_1.yz(_set____db54di);
  }
  zz() {
    return this.d68_1.zz();
  }
  s3() {
    return this.g68_1;
  }
  p5t(_set____db54di) {
    this.h68_1 = _set____db54di;
  }
  q5t() {
    return this.h68_1;
  }
  r5t(_set____db54di) {
    this.i68_1 = _set____db54di;
  }
  s5t() {
    return this.i68_1;
  }
  w5t(_set____db54di) {
    this.j68_1 = _set____db54di;
  }
  x5t() {
    return this.j68_1;
  }
  h1s() {
    return this.k68_1;
  }
  m68(coroutineContext, params) {
    throw NotImplementedError.be();
  }
  toString() {
    return "NativeSound('" + this.s3() + "')";
  }
}
class SoundChannel {
  constructor(sound, $box) {
    boxApply(this, $box);
    this.o68_1 = new Mixin();
    this.p68_1 = sound;
    this.q68_1 = Companion_getInstance_0().s1x();
    this.r68_1 = 1.0;
    this.s68_1 = 1.0;
    this.t68_1 = 0.0;
    this.u68_1 = Companion_getInstance_2().m2l_1;
  }
  yz(_set____db54di) {
    this.o68_1.yz(_set____db54di);
  }
  zz() {
    return this.o68_1.zz();
  }
  p5t(_set____db54di) {
    this.r68_1 = _set____db54di;
  }
  q5t() {
    return this.r68_1;
  }
  w5t(_set____db54di) {
    this.s68_1 = _set____db54di;
  }
  x5t() {
    return this.s68_1;
  }
  r5t(_set____db54di) {
    this.t68_1 = _set____db54di;
  }
  s5t() {
    return this.t68_1;
  }
  h1s() {
    return this.u68_1;
  }
}
class SoundAudioData$play$4 extends SoundChannel {
  constructor($nas, this$0, $pos, $box) {
    if ($box === VOID)
      $box = {};
    $box.r69_1 = $nas;
    $box.s69_1 = this$0;
    $box.t69_1 = $pos;
    super(this$0, $box);
    var tmp = this;
    var tmp_0;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_0 = $nas._v;
    }
    tmp.o69_1 = volume$factory(tmp_0);
    var tmp_1 = this;
    var tmp_2;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_2 = $nas._v;
    }
    tmp_1.p69_1 = pitch$factory(tmp_2);
    var tmp_3 = this;
    var tmp_4;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_4 = $nas._v;
    }
    tmp_3.q69_1 = panning$factory(tmp_4);
  }
  p5t(_set____db54di) {
    var this_0 = this.o69_1;
    volume$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  q5t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o69_1;
    volume$factory_1();
    return this_0.get();
  }
  w5t(_set____db54di) {
    var this_0 = this.p69_1;
    pitch$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  x5t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p69_1;
    pitch$factory_1();
    return this_0.get();
  }
  r5t(_set____db54di) {
    var this_0 = this.q69_1;
    panning$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  s5t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q69_1;
    panning$factory_1();
    return this_0.get();
  }
}
class SoundAudioData extends Sound {
  constructor(coroutineContext, audioData, soundProvider, name) {
    var tmp;
    if (name === VOID) {
      var tmp0_elvis_lhs = audioData.j5s_1;
      tmp = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
    } else {
      tmp = name;
    }
    name = tmp;
    super(coroutineContext);
    this.e69_1 = audioData;
    this.f69_1 = soundProvider;
    this.g69_1 = name;
  }
  s3() {
    return this.g69_1;
  }
  m68(coroutineContext, params) {
    var pos = {_v: 0};
    var times = {_v: new PlaybackTimes(params.q67_1)};
    var nas = {_v: null};
    var tmp = this.f69_1;
    var tmp_0 = this.e69_1.k5s();
    nas._v = tmp.o5u(tmp_0, this.e69_1.h5s_1, SoundAudioData$play$lambda(times, pos, this, nas));
    var tmp_1;
    if (nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_1 = nas._v;
    }
    copySoundPropsFromCombined(tmp_1, params, this);
    var tmp_2;
    if (nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_2 = nas._v;
    }
    tmp_2.u5t();
    var tmp_3 = SoundAudioData$play$lambda_0(nas);
    onCancel(coroutineContext, tmp_3, SoundAudioData$play$lambda_1(nas));
    return new SoundAudioData$play$4(nas, this, pos);
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    tmp.v6a_1 = ConcurrentPool.j2u(VOID, VOID, SoundAudioStream$Companion$ID_POOL$lambda);
  }
}
class SoundAudioStream$play$slambda {
  constructor(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId) {
    this.j6a_1 = this$0;
    this.k6a_1 = $newStream;
    this.l6a_1 = $params;
    this.m6a_1 = $playing;
    this.n6a_1 = $times;
    this.o6a_1 = $nas;
    this.p6a_1 = $currentPositionRequest;
    this.q6a_1 = $dequeLock;
    this.r6a_1 = $deque;
    this.s6a_1 = $BUFFER_SAMPLES;
    this.t6a_1 = $flushing;
    this.u6a_1 = $channelId;
  }
  k1q($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundAudioStream$play$1 extends SoundChannel {
  constructor($nas, this$0, $currentPositionRequest, $newStream, $playing, $job, $box) {
    if ($box === VOID)
      $box = {};
    $box.g6b_1 = $nas;
    $box.h6b_1 = this$0;
    $box.i6b_1 = $currentPositionRequest;
    $box.j6b_1 = $newStream;
    $box.k6b_1 = $playing;
    $box.l6b_1 = $job;
    super(this$0.i6a_1, $box);
    this.d6b_1 = volume$factory_2($nas);
    this.e6b_1 = pitch$factory_2($nas);
    this.f6b_1 = panning$factory_2($nas);
  }
  p5t(_set____db54di) {
    var this_0 = this.d6b_1;
    volume$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  q5t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d6b_1;
    volume$factory_4();
    return this_0.get();
  }
  w5t(_set____db54di) {
    var this_0 = this.e6b_1;
    pitch$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  x5t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e6b_1;
    pitch$factory_4();
    return this_0.get();
  }
  r5t(_set____db54di) {
    var this_0 = this.f6b_1;
    panning$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  s5t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f6b_1;
    panning$factory_4();
    return this_0.get();
  }
}
class SoundAudioStream extends Sound {
  constructor(coroutineContext, stream, soundProvider, closeStream, name, onComplete) {
    Companion_getInstance_16();
    closeStream = closeStream === VOID ? false : closeStream;
    var tmp;
    if (name === VOID) {
      var tmp0_elvis_lhs = stream.d62_1;
      tmp = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
    } else {
      tmp = name;
    }
    name = tmp;
    onComplete = onComplete === VOID ? null : onComplete;
    super(coroutineContext);
    this.d6a_1 = stream;
    this.e6a_1 = soundProvider;
    this.f6a_1 = closeStream;
    this.g6a_1 = name;
    this.h6a_1 = onComplete;
    this.i6a_1 = this;
  }
  s3() {
    return this.g6a_1;
  }
  m6b() {
    return this.d6a_1.c62_1;
  }
  m68(coroutineContext, params) {
    var dequeLock = new Lock();
    var deque = new AudioSamplesDeque(this.m6b());
    var playing = {_v: true};
    var flushing = {_v: false};
    var newStream = {_v: null};
    var channelId = Companion_getInstance_16().v6a_1.z2t();
    var dispatcherName = 'SoundChannel-SoundAudioStream-' + channelId;
    var times = {_v: new PlaybackTimes(params.q67_1)};
    var BUFFER_SAMPLES = nextMultipleOf(numberToInt(this.d6a_1.b62_1 * get_seconds(params.s67_1)), Companion_instance.s5s_1);
    var tmp = this.e6a_1;
    var tmp_0 = this.m6b();
    var nas = tmp.o5u(tmp_0, this.d6a_1.b62_1, SoundAudioStream$play$lambda(dequeLock, flushing, deque, BUFFER_SAMPLES));
    copySoundPropsFromCombined(nas, params, this);
    var currentPositionRequest = {_v: null};
    var tmp_1 = CoroutineScope_0(coroutineContext);
    var job = launch(tmp_1, coroutineContext, VOID, SoundAudioStream$play$slambda_0(this, newStream, params, playing, times, nas, currentPositionRequest, dequeLock, deque, BUFFER_SAMPLES, flushing, channelId));
    return new SoundAudioStream$play$1(nas, this, currentPositionRequest, newStream, playing, job);
  }
}
//endregion
function get_defaultAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  // Inline function 'kotlin.getValue' call
  var this_0 = defaultAudioFormats$delegate;
  defaultAudioFormats$factory();
  return this_0.s1();
}
var defaultAudioFormats$delegate;
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
function invalidate($this) {
  $this.h5v_1 = null;
  return $this;
}
function *_generator_tryReadInfo__rowfdh($this, data, props, $completion) {
  var _iterator__ex2g4s = $this.g5v_1.b1();
  $l$loop: while (_iterator__ex2g4s.c1()) {
    var format = _iterator__ex2g4s.d1();
    try {
      var tmp = format.k5v(data.e1w(), props, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var tmp0_elvis_lhs = tmp;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      return tmp_0;
    } catch ($p) {
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          printStackTrace(e_0);
        } else {
          throw $p;
        }
      }
    }
  }
  return null;
}
function *_generator_decodeStreamInternal__hls877($this, data, props, $completion) {
  var _iterator__ex2g4s = $this.g5v_1.b1();
  $l$loop_0: while (_iterator__ex2g4s.c1()) {
    var format = _iterator__ex2g4s.d1();
    try {
      var tmp = format.k5v(data.e1w(), Companion_getInstance_4().m5v_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      if (tmp == null)
        continue $l$loop_0;
      var tmp_0 = format.n5v(data.e1w(), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var tmp0_elvis_lhs = tmp_0;
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      return tmp_1;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  return null;
}
function standardAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  return Companion_instance_0.e5v([Companion_getInstance_11(), Companion_getInstance_8()]);
}
function *_generator_decodeStream__ydjika($this, data, props, $completion) {
  var tmp;
  if (!(props.b5w_1 == null)) {
    var tmp_0 = withContext(props.b5w_1, AudioFormat$decodeStream$slambda_0($this, data, props), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = $this.p5v(data, props, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_decodeStreamOrError__s0emn1($this, data, props, $completion) {
  var tmp = $this.n5v(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var tmp_1 = $this.toString();
    var tmp_2 = readBytesUpTo(data.e1w(), 8, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var message = "Can't decode audio stream [" + tmp_1 + '] ' + toHexString(tmp_2);
    throw IllegalStateException.h5(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function AudioFormat$decodeStream$slambda_0(this$0, $data, $props) {
  var i = new AudioFormat$decodeStream$slambda(this$0, $data, $props);
  var l = function ($this$withContext, $completion) {
    return i.k1q($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function invalidAudioFormat(message) {
  message = message === VOID ? 'invalid audio format' : message;
  _init_properties_AudioFormat_kt__9os7np();
  throw InvalidAudioFormatException.i5w(message);
}
function defaultAudioFormats$delegate$lambda() {
  _init_properties_AudioFormat_kt__9os7np();
  return standardAudioFormats();
}
function defaultAudioFormats$factory() {
  return getPropertyCallableRef('defaultAudioFormats', 0, KProperty0, function () {
    return get_defaultAudioFormats();
  }, null);
}
var properties_initialized_AudioFormat_kt_2wpbb7;
function _init_properties_AudioFormat_kt__9os7np() {
  if (!properties_initialized_AudioFormat_kt_2wpbb7) {
    properties_initialized_AudioFormat_kt_2wpbb7 = true;
    defaultAudioFormats$delegate = lazy(defaultAudioFormats$delegate$lambda);
  }
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
var ChannelMode_STEREO_instance;
var ChannelMode_JOINT_STEREO_instance;
var ChannelMode_DUAL_CHANNEL_instance;
var ChannelMode_SINGLE_CHANNEL_instance;
var Companion_instance_3;
function Companion_getInstance_6() {
  ChannelMode_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_2();
  return Companion_instance_3;
}
function values() {
  return [ChannelMode_STEREO_getInstance(), ChannelMode_JOINT_STEREO_getInstance(), ChannelMode_DUAL_CHANNEL_getInstance(), ChannelMode_SINGLE_CHANNEL_getInstance()];
}
var ChannelMode_entriesInitialized;
function ChannelMode_initEntries() {
  if (ChannelMode_entriesInitialized)
    return Unit_instance;
  ChannelMode_entriesInitialized = true;
  ChannelMode_STEREO_instance = new ChannelMode('STEREO', 0, 0, 2);
  ChannelMode_JOINT_STEREO_instance = new ChannelMode('JOINT_STEREO', 1, 1, 1);
  ChannelMode_DUAL_CHANNEL_instance = new ChannelMode('DUAL_CHANNEL', 2, 2, 2);
  ChannelMode_SINGLE_CHANNEL_instance = new ChannelMode('SINGLE_CHANNEL', 3, 3, 1);
  Companion_getInstance_6();
}
function framesize($this, layer, bitrate, sample_rate, padding_bit) {
  if (sample_rate === 0) {
    // Inline function 'kotlin.error' call
    var message = 'division by 0';
    throw IllegalStateException.h5(toString(message));
  }
  var tmp;
  if (layer === 1) {
    tmp = imul((imul(imul(12, bitrate), 1000) / sample_rate | 0) + padding_bit | 0, 4);
  } else {
    tmp = (imul(imul(144, bitrate), 1000) / sample_rate | 0) + padding_bit | 0;
  }
  return tmp;
}
function ChannelMode_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_STEREO_instance;
}
function ChannelMode_JOINT_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_JOINT_STEREO_instance;
}
function ChannelMode_DUAL_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_DUAL_CHANNEL_instance;
}
function ChannelMode_SINGLE_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_SINGLE_CHANNEL_instance;
}
function *_generator_getSeekingTable__ywx4sa($this, $completion) {
  var times = DoubleArrayList.g2p();
  var filePositions = DoubleArrayList.g2p();
  var tmp = _getDuration($this, false, MP3Base$Parser$getSeekingTable$lambda(times, filePositions), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  tmp.qj_1;
  return new SeekingTable(times, filePositions);
}
function *_generator__getDuration__467r4t($this, use_cbr_estimate, emit, $completion) {
  $this.w5w_1.g1v_1 = new Long(0, 0);
  var fd = $this.w5w_1.e1w();
  var tmp = fd.l1u($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var len = tmp;
  var durationMicroseconds = 0.0;
  var tmp_0 = readStream(fd, 100, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = skipID3v2Tag($this, tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var offset = tmp_1;
  var pos = offset;
  var info = null;
  var nframes = 0;
  var block2 = _UByteArrayInt___init__impl__xif7bu(new Int8Array(10));
  var fdbase = fd.f1v_1;
  var fdsync = toSyncOrNull(fdbase);
  var nreads = 0;
  var nskips = 0;
  var nasync = 0;
  try {
    $l$loop: while (pos.x1(len) < 0) {
      var tmp_2;
      if (!(fdsync == null)) {
        tmp_2 = fdsync.v1t(pos, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10);
      } else {
        nasync = nasync + 1 | 0;
        fd.g1v_1 = pos;
        var tmp_3 = readBytesUpTo_0(fd, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        tmp_2 = tmp_3;
      }
      var block2Size = tmp_2;
      nreads = nreads + 1 | 0;
      if (block2Size < 10)
        break $l$loop;
      // Inline function 'kotlin.Long.plus' call
      pos = pos.y3(toLong(block2Size));
      if (UByteArrayInt__get_impl_px6q8a(block2, 0) === 255 && !((UByteArrayInt__get_impl_px6q8a(block2, 1) & 224) === 0)) {
        info = Companion_getInstance_7().e5x(block2);
        if (emit == null)
          null;
        else
          emit(pos, durationMicroseconds, info);
        nframes = nframes + 1 | 0;
        $this.y5w_1 = info;
        if (info.u5w_1 === 0) {
          // Inline function 'korlibs.time.microseconds' call
          var this_0 = durationMicroseconds;
          var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
          return new Duration(tmp$ret$1);
        }
        // Inline function 'kotlin.Long.plus' call
        var this_1 = pos;
        var other = info.u5w_1 - 10 | 0;
        pos = this_1.y3(toLong(other));
        var tmp_4 = durationMicroseconds;
        // Inline function 'kotlin.Long.div' call
        var this_2 = numberToLong(info.v5w_1).z3(new Long(1000000, 0));
        var other_0 = info.s5w_1;
        durationMicroseconds = tmp_4 + this_2.a4(toLong(other_0)).n4();
      } else if (readString(openSync(_UByteArrayInt___get_bytes__impl__pj0ilc(block2)), 3) === 'TAG') {
        // Inline function 'kotlin.Long.plus' call
        pos = pos.y3(toLong(118));
      } else {
        // Inline function 'kotlin.Long.minus' call
        pos = pos.y1(toLong(9));
        nskips = nskips + 1 | 0;
      }
      if (!(info == null) && use_cbr_estimate) {
        // Inline function 'korlibs.time.microseconds' call
        var tmp_5 = estimateDuration($this, info.r5w_1, info.t5w_1.n5w_1, offset.j2(), $completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        var this_3 = tmp_5;
        var tmp$ret$6 = toDuration_0(this_3, DurationUnit_MICROSECONDS_getInstance());
        return new Duration(tmp$ret$6);
      }
    }
  }finally {
  }
  // Inline function 'korlibs.time.microseconds' call
  var this_4 = durationMicroseconds;
  var tmp$ret$7 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
  return new Duration(tmp$ret$7);
}
function _getDuration($this, use_cbr_estimate, emit, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__getDuration__467r4t.bind(VOID, $this, use_cbr_estimate, emit), $completion);
}
function _getDuration$default($this, use_cbr_estimate, emit, $completion, $super) {
  emit = emit === VOID ? null : emit;
  return _getDuration($this, use_cbr_estimate, emit, $completion);
}
function estimateDuration($this, bitrate, channels, offset, $completion) {
  var kbps = imul(bitrate, 1000) / 8 | 0;
  // Inline function 'kotlin.Long.minus' call
  var dataSize = $this.x5w_1.y1(toLong(offset));
  // Inline function 'kotlin.Long.div' call
  // Inline function 'kotlin.Long.times' call
  var other = 2 / channels | 0;
  return dataSize.z3(toLong(other)).z3(new Long(1000000, 0)).a4(toLong(kbps));
}
function *_generator_skipID3v2Tag__vewobn($this, block, $completion) {
  var b = block.e1w();
  var tmp = readString_0(b, 3, Charsets_instance.lx(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp === 'ID3') {
    var tmp_0 = readBytesExact(b, 7, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var bb = tmp_0;
    var id3v2_major_version = getU8(bb, 0);
    var id3v2_minor_version = getU8(bb, 1);
    var id3v2_flags = getU8(bb, 2);
    var z0 = getU8(bb, 3);
    var z1 = getU8(bb, 4);
    var z2 = getU8(bb, 5);
    var z3 = getU8(bb, 6);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_unsynchronisation = !(((id3v2_flags >>> 7 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_extended_header = !(((id3v2_flags >>> 6 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_experimental_ind = !(((id3v2_flags >>> 5 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_footer_present = !(((id3v2_flags >>> 4 | 0) & 1) === 0);
    if ((z0 & 128) === 0 && (z1 & 128) === 0 && (z2 & 128) === 0 && (z3 & 128) === 0) {
      var header_size = 10;
      var tag_size = ((imul(z0 & 127, 2097152) + imul(z1 & 127, 16384) | 0) + imul(z2 & 127, 128) | 0) + (z3 & 127) | 0;
      var footer_size = flag_footer_present ? 10 : 0;
      return toLong((header_size + tag_size | 0) + footer_size | 0);
    }
  }
  return new Long(0, 0);
}
function skipID3v2Tag($this, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_skipID3v2Tag__vewobn.bind(VOID, $this, block), $completion);
}
var Companion_instance_4;
function Companion_getInstance_7() {
  if (Companion_instance_4 === VOID)
    new Companion_3();
  return Companion_instance_4;
}
function MP3Base$Parser$getSeekingTable$lambda($times, $filePositions) {
  return function (filePos, totalMicro, info) {
    $times.t11(totalMicro);
    $filePositions.t11(filePos.n4());
    return Unit_instance;
  };
}
function *_generator_tryReadInfo__rowfdh_0($this, data, props, $completion) {
  try {
    var tmp = readBytesExact(data, 4, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var header = tmp;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = header.slice();
    var tmp$ret$2 = _UByteArray___init__impl__ip4y9n(tmp$ret$1);
    var this_0 = UByteArray__get_impl_t5f3hv(tmp$ret$2, 0);
    var h0 = _UByte___get_data__impl__jof9qr(this_0) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = header.slice();
    var tmp$ret$6 = _UByteArray___init__impl__ip4y9n(tmp$ret$5);
    var this_1 = UByteArray__get_impl_t5f3hv(tmp$ret$6, 1);
    var h1 = _UByte___get_data__impl__jof9qr(this_1) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = header.slice();
    var tmp$ret$10 = _UByteArray___init__impl__ip4y9n(tmp$ret$9);
    var this_2 = UByteArray__get_impl_t5f3hv(tmp$ret$10, 2);
    var h2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
    var isId3 = readStringz(header, 0, 3) === 'ID3';
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226)) {
      // Inline function 'korlibs.memory.extract2' call
      tmp_2 = !(((h1 >>> 1 | 0) & 3) === 0);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      // Inline function 'korlibs.memory.extract4' call
      tmp_1 = !(((h2 >>> 4 | 0) & 15) === 15);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'korlibs.memory.extract2' call
      tmp_0 = !(((h2 >>> 2 | 0) & 3) === 3);
    } else {
      tmp_0 = false;
    }
    var isSync = tmp_0;
    if (!isId3 && !isSync)
      return null;
    var tmp_3 = data.l1u($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var parser = new Parser(data, tmp_3);
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.kj();
    // Inline function 'korlibs.audio.format.MP3Base.tryReadInfo.<anonymous>' call
    var tmp_4;
    switch (props.x5v_1) {
      case null:
        var tmp_5 = parser.g5x($completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        tmp_4 = tmp_5.qj_1;
        break;
      case true:
        var tmp_6 = parser.g5x($completion);
        if (tmp_6 === get_COROUTINE_SUSPENDED())
          tmp_6 = yield tmp_6;
        tmp_4 = tmp_6.qj_1;
        break;
      default:
        var tmp_7 = parser.h5x($completion);
        if (tmp_7 === get_COROUTINE_SUSPENDED())
          tmp_7 = yield tmp_7;
        tmp_4 = tmp_7.qj_1;
        break;
    }
    var result = new Duration(tmp_4);
    var _destruct__k2r9zo = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    var duration = _destruct__k2r9zo.nl().qj_1;
    var decodingTime = _destruct__k2r9zo.nr();
    var tmp3_safe_receiver = parser.y5w_1;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.t5w_1;
    var tmp0_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.n5w_1;
    return new Info(duration, tmp0_elvis_lhs == null ? 2 : tmp0_elvis_lhs, decodingTime);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      return null;
    } else {
      throw $p;
    }
  }
}
var Companion_instance_5;
function Companion_getInstance_8() {
  if (Companion_instance_5 === VOID)
    new Companion_4();
  return Companion_instance_5;
}
var Minimp3AudioFormat_instance;
function Minimp3AudioFormat_getInstance() {
  if (Minimp3AudioFormat_instance === VOID)
    new Minimp3AudioFormat();
  return Minimp3AudioFormat_instance;
}
function *_generator_seek__qhx6y8($this, position, $completion) {
  $this.r61_1 = false;
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$0 = toDuration(0.0, DurationUnit_SECONDS_getInstance());
  if (equals(position, tmp$ret$0)) {
    $this.w61_1.g1v_1 = new Long(0, 0);
    $this.t61_1 = new Long(0, 0);
  } else {
    if ($this.v61_1._v == null) {
      var tmp0_elvis_lhs = $this.x61_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp_0;
        var tmp_1 = $this.w61_1.m1u($completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        if (tmp_1) {
          var tmp_2 = $this.w61_1.l1u($completion);
          if (tmp_2 === get_COROUTINE_SUSPENDED())
            tmp_2 = yield tmp_2;
          var tmp_3 = (new Parser($this.w61_1, tmp_2)).n5x($completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
          tmp_0 = tmp_3;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      $this.v61_1._v = tmp;
    }
    if (!($this.v61_1._v == null)) {
      var offset = ensureNotNull($this.v61_1._v).m5x(position);
      $this.w61_1.g1v_1 = offset;
      $this.t61_1 = $this.h62(position);
    } else {
      println("Couldn't create mp3SeekingTable");
    }
  }
  $this.u61_1.r5y().p2u();
  return Unit_instance;
}
function *_generator_read__qih2oe($this, out, offset, length, $completion) {
  var noMoreSamples = false;
  $l$loop: while (ensureNotNull($this.u61_1.r5y().v5y_1).w15() < length) {
    var tmp = createDecoderStream$readMoreSamples($this.u61_1, $this.w61_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!tmp) {
      noMoreSamples = true;
      break $l$loop;
    }
  }
  // Inline function 'kotlin.also' call
  var tmp_0;
  if (noMoreSamples && ensureNotNull($this.u61_1.r5y().v5y_1).w15() === 0) {
    $this.r61_1 = true;
    tmp_0 = 0;
  } else {
    tmp_0 = ensureNotNull($this.u61_1.r5y().v5y_1).k62(out, offset, length);
  }
  var this_0 = tmp_0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.audio.format.<no name provided>.read.<anonymous>' call
  var tmp_1 = $this;
  // Inline function 'kotlin.Long.plus' call
  tmp_1.t61_1 = $this.t61_1.y3(toLong(this_0));
  return this_0;
}
function *_generator_createDecoderStream__oszsb8($this, data, props, table, $completion) {
  var dataStartPosition = data.g1v_1;
  var decoder = $this.k61();
  decoder.r5y().p2u();
  var tmp;
  if (props.x5v_1 === true) {
    var tmp_0;
    if (table == null) {
      var tmp_1;
      var tmp_2 = data.m1u($completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      if (tmp_2) {
        var tmp_3 = data.l1u($completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var tmp_4 = (new Parser(data, tmp_3)).n5x($completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        tmp_1 = tmp_4;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = table;
    }
    tmp = tmp_0;
  } else {
    tmp = null;
  }
  var mp3SeekingTable = {_v: tmp};
  var tmp_5 = createDecoderStream$readMoreSamples(decoder, data, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return new BaseMinimp3AudioFormat$createDecoderStream$2(decoder, mp3SeekingTable, data, table, $this, dataStartPosition, props);
}
function createDecoderStream($this, data, props, table, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createDecoderStream__oszsb8.bind(VOID, $this, data, props, table), $completion);
}
var Companion_instance_6;
function Companion_getInstance_9() {
  if (Companion_instance_6 === VOID)
    new Companion_5();
  return Companion_instance_6;
}
function *_generator_createDecoderStream$readMoreSamples__md5fam(decoder, $data, $completion) {
  $l$loop: while (true) {
    var tmp;
    if (decoder.r5y().u5y_1.w15() < decoder.r5y().t5y_1.length) {
      var tmp_0 = $data.c1w($completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_1 = decoder.r5y().u5y_1;
      var tmp_2 = readBytesUpTo($data, 4096, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1.g2n(tmp_2);
    }
    var result = decoder.r5y().l62(decoder);
    if (decoder.r5y().w5y_1 === 0 || decoder.r5y().y5y_1 === 0)
      continue $l$loop;
    return result;
  }
}
function createDecoderStream$readMoreSamples(decoder, $data, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createDecoderStream$readMoreSamples__md5fam.bind(VOID, decoder, $data), $completion);
}
function arrayOfUByte($this, values, size) {
  return _UByteArrayInt___init__impl__xif7bu_0(size, MiniMp3Program$Companion$arrayOfUByte$lambda(values));
}
function arrayOfUByte$default($this, values, size, $super) {
  size = size === VOID ? values.length : size;
  return arrayOfUByte($this, values, size);
}
function arrayOfShort($this, values, size) {
  var tmp = 0;
  var tmp_0 = new Int16Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    // Inline function 'kotlin.code' call
    // Inline function 'kotlin.text.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_2;
    if (0 <= tmp_1 ? tmp_1 <= (charSequenceLength(values) - 1 | 0) : false) {
      tmp_2 = charSequenceGet(values, tmp_1);
    } else {
      // Inline function 'korlibs.audio.format.Companion.arrayOfShort.<anonymous>' call
      tmp_2 = _Char___init__impl__6a9atx(0);
    }
    var this_0 = tmp_2;
    var tmp$ret$2 = Char__toInt_impl_vasixd(this_0);
    tmp_0[tmp_1] = toShort(tmp$ret$2);
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function arrayOfShort$default($this, values, size, $super) {
  size = size === VOID ? values.length : size;
  return arrayOfShort($this, values, size);
}
function MiniMp3Program$Companion$arrayOfUByte$lambda($values) {
  return function (it) {
    // Inline function 'kotlin.code' call
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = $values;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= it ? it <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, it);
    } else {
      // Inline function 'korlibs.audio.format.Companion.arrayOfUByte.<anonymous>.<anonymous>' call
      tmp = _Char___init__impl__6a9atx(0);
    }
    var this_1 = tmp;
    return Char__toInt_impl_vasixd(this_1);
  };
}
var Companion_instance_7;
function Companion_getInstance_10() {
  if (Companion_instance_7 === VOID)
    new Companion_6();
  return Companion_instance_7;
}
function toInt_0(_this__u8e3s4, $this) {
  return _this__u8e3s4 ? 1 : 0;
}
function *_generator_read__qih2oe_0($this, out, offset, length, $completion) {
  var tmp = readBytesUpTo($this.g66_1, imul(imul(length, $this.k66_1), $this.c62_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var bytes = tmp;
  var tmp_0 = $this;
  var tmp_1 = $this.g66_1.f1w($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  tmp_0.l66_1 = tmp_1;
  var availableSamples = (bytes.length / $this.k66_1 | 0) / $this.c62_1 | 0;
  var inductionVariable = 0;
  var last = $this.c62_1;
  if (inductionVariable < last)
    do {
      var channel = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      switch ($this.k66_1) {
        case 1:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_11();
          var channels = $this.c62_1;
          var bytesPerSample = $this.k66_1;
          var increment = imul(channels, bytesPerSample);
          var index = imul(channel, bytesPerSample);
          var outc = out.f5u(channel);
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < availableSamples)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp_2 = offset + n | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it = index;
              var tmp$ret$0 = _AudioSample___init__impl__s54gd5(toShortClamped(imul(getU8(bytes, it) - 128 | 0, 255)));
              AudioSampleArray__set_impl_tqgfwk(outc, tmp_2, tmp$ret$0);
              index = index + increment | 0;
            }
             while (inductionVariable_0 < availableSamples);
          break;
        case 2:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_11();
          var channels_0 = $this.c62_1;
          var bytesPerSample_0 = $this.k66_1;
          var increment_0 = imul(channels_0, bytesPerSample_0);
          var index_0 = imul(channel, bytesPerSample_0);
          var outc_0 = out.f5u(channel);
          var inductionVariable_1 = 0;
          if (inductionVariable_1 < availableSamples)
            do {
              var n_0 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var tmp_3 = offset + n_0 | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it_0 = index_0;
              var tmp$ret$1 = _AudioSample___init__impl__s54gd5(toShort(getS16LE(bytes, it_0)));
              AudioSampleArray__set_impl_tqgfwk(outc_0, tmp_3, tmp$ret$1);
              index_0 = index_0 + increment_0 | 0;
            }
             while (inductionVariable_1 < availableSamples);
          break;
        case 3:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_11();
          var channels_1 = $this.c62_1;
          var bytesPerSample_1 = $this.k66_1;
          var increment_1 = imul(channels_1, bytesPerSample_1);
          var index_1 = imul(channel, bytesPerSample_1);
          var outc_1 = out.f5u(channel);
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < availableSamples)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var tmp_4 = offset + n_1 | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it_1 = index_1;
              var tmp$ret$2 = _AudioSample___init__impl__s54gd5(toShort(getS24LE(bytes, it_1) >>> 8 | 0));
              AudioSampleArray__set_impl_tqgfwk(outc_1, tmp_4, tmp$ret$2);
              index_1 = index_1 + increment_1 | 0;
            }
             while (inductionVariable_2 < availableSamples);
          break;
        default:
          invalidOp('Unsupported bytesPerSample=' + $this.k66_1);
          break;
      }
    }
     while (inductionVariable < last);
  return availableSamples;
}
function *_generator_clone__nh2r5j($this, $completion) {
  var tmp = (new WAV()).p5v($this.i66_1.e1w(), $this.j66_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return ensureNotNull(tmp);
}
function *_generator_invoke__zhh2q8($this, $this$riff, $completion) {
  var type = $this$riff.nl();
  var d2 = $this$riff.ol();
  var d = d2.e1w();
  var cdata = Unit_instance;
  switch (type) {
    case 'fmt ':
      var tmp = $this.p66_1;
      var tmp_0 = readS16LE(d, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp.s66_1 = tmp_0;
      var tmp_1 = $this.p66_1;
      var tmp_2 = readS16LE(d, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1.t66_1 = tmp_2;
      var tmp_3 = $this.p66_1;
      var tmp_4 = readS32LE(d, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp_3.u66_1 = tmp_4;
      var tmp_5 = $this.p66_1;
      var tmp_6 = readU32LE(d, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      tmp_5.v66_1 = tmp_6;
      var tmp_7 = $this.p66_1;
      var tmp_8 = readS16LE(d, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      tmp_7.w66_1 = tmp_8;
      var tmp_9 = $this.p66_1;
      var tmp_10 = readS16LE(d, $completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
      tmp_9.x66_1 = tmp_10;
      cdata = $this.p66_1;
      break;
    case 'data':
      var tmp_11 = $this.q66_1._v;
      var tmp_12 = d.l1u($completion);
      if (tmp_12 === get_COROUTINE_SUSPENDED())
        tmp_12 = yield tmp_12;
      $this.q66_1._v = tmp_11.y3(tmp_12);
      cdata = d;
      break;
    default:
      break;
  }
  $this.r66_1(new ProcessedChunk($this$riff.n66_1, $this$riff.o66_1, cdata));
  return Unit_instance;
}
var Companion_instance_8;
function Companion_getInstance_11() {
  if (Companion_instance_8 === VOID)
    new Companion_7();
  return Companion_instance_8;
}
function *_generator_tryReadInfo__rowfdh_1($this, data, props, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.y66(data, WAV$tryReadInfo$lambda, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
    }
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_decodeStreamInternal__hls877_0($this, data, props, $completion) {
  var fmt = {_v: new Fmt()};
  var buffer = {_v: toAsync(MemorySyncStream())};
  var tmp = $this.y66(data, WAV$decodeStreamInternal$lambda(fmt, buffer), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = fmt._v;
  var tmp_1 = buffer._v;
  var tmp_2 = buffer._v.l1u($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return new WavAudioStream(tmp_0, tmp_1, tmp_2, data, props);
}
function *_generator_parse__tgo4f5($this, data, handle, $completion) {
  var fmt = new Fmt();
  var dataSize = {_v: new Long(0, 0)};
  var tmp = $this.z66(data, WAV$parse$slambda_0(fmt, dataSize, handle), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (fmt.s66_1 < 0) {
    invalidOp("Couldn't find RIFF 'fmt ' chunk");
  }
  // Inline function 'korlibs.time.microseconds' call
  // Inline function 'kotlin.Long.times' call
  // Inline function 'kotlin.Long.times' call
  var this_0 = dataSize._v.z3(toLong(1000)).z3(toLong(1000)).a4(fmt.v66_1);
  var tmp$ret$2 = toDuration_0(this_0, DurationUnit_MICROSECONDS_getInstance());
  return new Info(tmp$ret$2, fmt.t66_1);
}
function *_generator_riff__qieez3($this, data, handler, $completion) {
  var s2 = data.e1w();
  var tmp = s2.d1w($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp.x1(new Long(12, 0)) < 0) {
    // Inline function 'kotlin.error' call
    var message = 'Not enough data for a RIFF file';
    throw IllegalStateException.h5(toString(message));
  }
  var tmp_0 = readString_0(s2, 4, VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var magic = tmp_0;
  var tmp_1 = readS32LE(s2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var length = tmp_1;
  var tmp_2 = readString_0(s2, 4, VOID, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var magic2 = tmp_2;
  if (!(magic === 'RIFF')) {
    invalidAudioFormat("Not a RIFF file but '" + magic + "'");
  }
  if (!(magic2 === 'WAVE')) {
    invalidAudioFormat('Not a RIFF + WAVE file');
  }
  var tmp_3 = readStream(s2, length - 4 | 0, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var s = tmp_3;
  $l$loop_1: while (true) {
    var tmp_4 = s.f1w($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    if (!!tmp_4) {
      break $l$loop_1;
    }
    var tmp_5 = s.d1w($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    if (tmp_5.x1(new Long(8, 0)) < 0)
      break $l$loop_1;
    var tmp_6 = readString_0(s, 4, VOID, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var type = tmp_6;
    var tmp_7 = readS32LE(s, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    var size = tmp_7;
    var tmp_8 = s.d1w($completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    if (tmp_8.x1(toLong(size)) < 0)
      break $l$loop_1;
    var tmp_9 = readStream(s, size, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    var d = tmp_9;
    var tmp_10 = handler(new Chunk(type, d), $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
  }
  return Unit_instance;
}
function WAV$tryReadInfo$lambda(it) {
  return Unit_instance;
}
function WAV$decodeStreamInternal$lambda($fmt, $buffer) {
  return function (it) {
    var extra = it.c67_1;
    var tmp;
    if (extra instanceof Fmt) {
      $fmt._v = extra;
      tmp = Unit_instance;
    }
    var tmp_0;
    if (it.a67_1 === 'data') {
      $buffer._v = it.b67_1;
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function WAV$parse$slambda_0($fmt, $dataSize, $handle) {
  var i = new WAV$parse$slambda($fmt, $dataSize, $handle);
  var l = function ($this$riff, $completion) {
    return i.e67($this$riff, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_9;
function Companion_getInstance_12() {
  return Companion_instance_9;
}
var DEFAULT_MAX_SAMPLES;
var Companion_instance_10;
function Companion_getInstance_13() {
  return Companion_instance_10;
}
function *_generator_toData__gg6t99(_this__u8e3s4, maxSamples, $completion) {
  maxSamples = maxSamples === VOID ? DEFAULT_MAX_SAMPLES : maxSamples;
  var out = new AudioSamplesDeque(_this__u8e3s4.c62_1);
  // Inline function 'kotlin.math.min' call
  var tmp$ret$0 = Math.min(maxSamples, 65536);
  var buffer = new AudioSamples(_this__u8e3s4.c62_1, tmp$ret$0);
  try {
    $l$loop_0: while (!_this__u8e3s4.p62()) {
      // Inline function 'kotlin.math.min' call
      var a = maxSamples - out.w15() | 0;
      var b = buffer.m5s_1;
      var tmp$ret$1 = Math.min(a, b);
      var tmp = _this__u8e3s4.r62(buffer, 0, tmp$ret$1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var read = tmp;
      if (read <= 0)
        break $l$loop_0;
      // Inline function 'kotlin.math.min' call
      var b_0 = maxSamples - out.w15() | 0;
      var mread = Math.min(read, b_0);
      out.i67(buffer, 0, mread);
      if (out.w15() >= maxSamples)
        break $l$loop_0;
    }
  }finally {
    _this__u8e3s4.n6();
  }
  var maxOutSamples = out.f67();
  // Inline function 'kotlin.apply' call
  var this_0 = new AudioSamples(_this__u8e3s4.c62_1, maxOutSamples);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.audio.sound.toData.<anonymous>' call
  out.l67(this_0);
  return new AudioData(_this__u8e3s4.b62_1, this_0);
}
function toData(_this__u8e3s4, maxSamples, $completion) {
  maxSamples = maxSamples === VOID ? DEFAULT_MAX_SAMPLES : maxSamples;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_toData__gg6t99.bind(VOID, _this__u8e3s4, maxSamples), $completion);
}
function get_audioFormats(_this__u8e3s4) {
  _init_properties_NativeSoundProviderExt_kt__owf0qw();
  // Inline function 'kotlin.getValue' call
  var this_0 = audioFormats$delegate;
  audioFormats$factory();
  return this_0.s1();
}
var audioFormats$delegate;
function *_generator_createSound__kkt3xd(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().l5v_1 : props;
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = createSound_0(_this__u8e3s4, tmp, streaming, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function createSound(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().l5v_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd.bind(VOID, _this__u8e3s4, file, streaming, props), $completion);
}
function createSound_0(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().l5v_1 : props;
  return createSound_1(_this__u8e3s4, file.d26(), file.j26(), streaming, props, $completion);
}
function *_generator_createSound__kkt3xd_0(_this__u8e3s4, vfs, path, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().l5v_1 : props;
  var tmp;
  if (streaming) {
    var vfsFile = vfs.z27(path);
    var tmp_0;
    if (props.y5v_1) {
      var tmp_1 = vfsFile.n28($completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = openAsync(tmp_1);
    } else {
      var tmp_2 = vfsFile.l28(VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
    }
    var stream = tmp_0;
    var tmp0_elvis_lhs = props.z5v_1;
    var tmp_3 = (tmp0_elvis_lhs == null ? get_audioFormats(_this__u8e3s4) : tmp0_elvis_lhs).q5v(stream, props, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp_4 = get_baseName(vfsFile);
    var tmp_5 = createStreamingSound(_this__u8e3s4, tmp_3, VOID, tmp_4, createSound$slambda_0(stream), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    tmp = tmp_5;
  } else {
    var tmp_6 = vfs.z27(path).j28($completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var tmp_7 = createSound_2(_this__u8e3s4, tmp_6, streaming, props, get_baseName(vfs.hi(path)), $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    tmp = tmp_7;
  }
  return tmp;
}
function createSound_1(_this__u8e3s4, vfs, path, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().l5v_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd_0.bind(VOID, _this__u8e3s4, vfs, path, streaming, props), $completion);
}
function createStreamingSound(_this__u8e3s4, stream, closeStream, name, onComplete, $completion) {
  closeStream = closeStream === VOID ? false : closeStream;
  name = name === VOID ? 'Unknown' : name;
  onComplete = onComplete === VOID ? null : onComplete;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.zc();
  return new SoundAudioStream(tmp$ret$0, stream, _this__u8e3s4, closeStream, name, onComplete);
}
function *_generator_createSound__kkt3xd_1(_this__u8e3s4, data, streaming, props, name, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().l5v_1 : props;
  name = name === VOID ? 'Unknown' : name;
  var tmp0_elvis_lhs = props.z5v_1;
  var format = tmp0_elvis_lhs == null ? get_audioFormats(_this__u8e3s4) : tmp0_elvis_lhs;
  var tmp = format.q5v(openAsync(data), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var stream = tmp;
  var tmp_0;
  if (streaming) {
    var tmp_1 = createStreamingSound(_this__u8e3s4, stream, true, name, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    var tmp_2 = toData(stream, VOID, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = createNonStreamingSound(_this__u8e3s4, tmp_2, name, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  }
  return tmp_0;
}
function createSound_2(_this__u8e3s4, data, streaming, props, name, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().l5v_1 : props;
  name = name === VOID ? 'Unknown' : name;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd_1.bind(VOID, _this__u8e3s4, data, streaming, props, name), $completion);
}
function createNonStreamingSound(_this__u8e3s4, data, name, $completion) {
  name = name === VOID ? 'Unknown' : name;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp = $completion.zc();
  var tmp0_elvis_lhs = data.j5s_1;
  return new SoundAudioData(tmp, data, _this__u8e3s4, tmp0_elvis_lhs == null ? name : tmp0_elvis_lhs);
}
function audioFormats$delegate$lambda() {
  _init_properties_NativeSoundProviderExt_kt__owf0qw();
  return get_defaultAudioFormats();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.o67_1.w1r($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function createSound$slambda_0($stream) {
  var i = new createSound$slambda($stream);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function audioFormats$factory() {
  return getPropertyCallableRef('audioFormats', 1, KProperty1, function (receiver) {
    return get_audioFormats(receiver);
  }, null);
}
var properties_initialized_NativeSoundProviderExt_kt_zegpk6;
function _init_properties_NativeSoundProviderExt_kt__owf0qw() {
  if (!properties_initialized_NativeSoundProviderExt_kt_zegpk6) {
    properties_initialized_NativeSoundProviderExt_kt_zegpk6 = true;
    audioFormats$delegate = lazy(audioFormats$delegate$lambda);
  }
}
var Companion_instance_11;
function Companion_getInstance_14() {
  if (Companion_instance_11 === VOID)
    new Companion_10();
  return Companion_instance_11;
}
function _PlaybackTimes___init__impl__rt6rw2(count) {
  return count;
}
function _PlaybackTimes___get_count__impl__ll6dcs($this) {
  return $this;
}
var Companion_instance_12;
function Companion_getInstance_15() {
  if (Companion_instance_12 === VOID)
    new Companion_11();
  return Companion_instance_12;
}
function _PlaybackTimes___get_hasMore__impl__ei8boc($this) {
  return !($this === Companion_getInstance_15().z67_1);
}
function _PlaybackTimes___get_oneLess__impl__ea0jl8($this) {
  return $this === Companion_getInstance_15().b68_1 ? Companion_getInstance_15().b68_1 : _PlaybackTimes___init__impl__rt6rw2(_PlaybackTimes___get_count__impl__ll6dcs($this) - 1 | 0);
}
function PlaybackTimes__toString_impl_l4chjq($this) {
  return _PlaybackTimes___get_count__impl__ll6dcs($this) >= 0 ? '' + _PlaybackTimes___get_count__impl__ll6dcs($this) + ' times' : 'Infinite times';
}
function PlaybackTimes__hashCode_impl_mtf95($this) {
  return $this;
}
function PlaybackTimes__equals_impl_suah7n($this, other) {
  if (!(other instanceof PlaybackTimes))
    return false;
  if (!($this === (other instanceof PlaybackTimes ? other.c68_1 : THROW_CCE())))
    return false;
  return true;
}
function readSound(_this__u8e3s4, props, streaming, $completion) {
  props = props === VOID ? Companion_getInstance_4().l5v_1 : props;
  streaming = streaming === VOID ? false : streaming;
  return createSound(get_nativeSoundProvider(), _this__u8e3s4, streaming, props, $completion);
}
function copySoundPropsFromCombined(_this__u8e3s4, l, r) {
  _this__u8e3s4.p5t(l.q5t() * r.q5t());
  _this__u8e3s4.w5t(l.x5t() * r.x5t());
  _this__u8e3s4.r5t(r.s5t());
}
function SoundAudioData$play$lambda($times, $pos, this$0, $nas) {
  return function (buffer) {
    var tmp;
    if ($times._v.equals(new PlaybackTimes(Companion_getInstance_15().z67_1))) {
      return Unit_instance;
    }
    var inductionVariable = 0;
    var last = buffer.m5t_1;
    var tmp_0;
    if (inductionVariable < last) {
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $pos._v;
        $pos._v = _unary__edvuaz + 1 | 0;
        var audioDataPos = _unary__edvuaz;
        if (audioDataPos >= this$0.e69_1.o5s() || $times._v.equals(new PlaybackTimes(Companion_getInstance_15().z67_1))) {
          $pos._v = 0;
          audioDataPos = 0;
          $times._v = new PlaybackTimes(_PlaybackTimes___get_oneLess__impl__ea0jl8($times._v.c68_1));
          if ($times._v.equals(new PlaybackTimes(Companion_getInstance_15().z67_1))) {
            var tmp_1;
            if ($nas._v == null) {
              throwUninitializedPropertyAccessException('nas');
            } else {
              tmp_1 = $nas._v;
            }
            tmp_1.v5t();
            break $l$loop;
          }
        }
        var inductionVariable_0 = 0;
        var last_0 = buffer.l5t_1;
        if (inductionVariable_0 < last_0)
          do {
            var ch = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var sample = audioDataPos < this$0.e69_1.o5s() ? this$0.e69_1.p5s(ch, audioDataPos) : Companion_getInstance_1().o5t_1;
            buffer.g5u(ch, n, sample);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function SoundAudioData$play$lambda_0($nas) {
  return function () {
    var tmp;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = $nas._v;
    }
    return tmp.f5t_1;
  };
}
function SoundAudioData$play$lambda_1($nas) {
  return function (it) {
    var tmp;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = $nas._v;
    }
    tmp.v5t();
    return Unit_instance;
  };
}
function volume$factory($b0) {
  return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
    return $b0.c5t_1;
  }, function (value) {
    $b0.c5t_1 = value;
    return Unit_instance;
  });
}
function pitch$factory($b0) {
  return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
    return $b0.x5t();
  }, function (value) {
    return $b0.w5t(value);
  });
}
function panning$factory($b0) {
  return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
    return $b0.d5t_1;
  }, function (value) {
    $b0.d5t_1 = value;
    return Unit_instance;
  });
}
function volume$factory_0() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.q5t();
  }, function (receiver, value) {
    return receiver.p5t(value);
  });
}
function volume$factory_1() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.q5t();
  }, function (receiver, value) {
    return receiver.p5t(value);
  });
}
function pitch$factory_0() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.x5t();
  }, function (receiver, value) {
    return receiver.w5t(value);
  });
}
function pitch$factory_1() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.x5t();
  }, function (receiver, value) {
    return receiver.w5t(value);
  });
}
function panning$factory_0() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.s5t();
  }, function (receiver, value) {
    return receiver.r5t(value);
  });
}
function panning$factory_1() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.s5t();
  }, function (receiver, value) {
    return receiver.r5t(value);
  });
}
function SoundAudioStream$Companion$ID_POOL$lambda(it) {
  return it;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = $this.j6a_1.d6a_1.s62($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var stream = tmp;
  $this.k6a_1._v = stream;
  var tmp_0 = stream.q62($this.l6a_1.r67_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.m6a_1._v = true;
  try {
    var temp = new AudioSamples(stream.c62_1, 2048);
    var started = false;
    while (_PlaybackTimes___get_hasMore__impl__ei8boc($this.n6a_1._v.c68_1)) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$1 = toDuration(0, DurationUnit_SECONDS_getInstance());
      var tmp_1 = stream.q62(tmp$ret$1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      $l$loop: while (true) {
        while ($this.o6a_1.a5t_1) {
          // Inline function 'korlibs.time.milliseconds' call
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$3 = toDuration(2, DurationUnit_MILLISECONDS_getInstance());
          var tmp_2 = delay(tmp$ret$3, $completion);
          if (tmp_2 === get_COROUTINE_SUSPENDED())
            tmp_2 = yield tmp_2;
        }
        if (!($this.p6a_1._v == null)) {
          // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
          var this_0 = $this.q6a_1;
          $l$block: {
            // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
            this_0.i1y();
            try {
              $this.r6a_1.k3();
              break $l$block;
            }finally {
              this_0.k1y();
            }
          }
          var tmp_3 = stream.q62(ensureNotNull($this.p6a_1._v).qj_1, $completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
          $this.p6a_1._v = null;
        }
        var tmp_4 = stream.r62(temp, 0, temp.m5s_1, $completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        var read = tmp_4;
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var this_1 = $this.q6a_1;
        $l$block_0: {
          // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
          this_1.i1y();
          try {
            $this.r6a_1.i67(temp, 0, read);
            break $l$block_0;
          }finally {
            this_1.k1y();
          }
        }
        if (stream.p62() || $this.r6a_1.w15() >= $this.s6a_1) {
          if (!started) {
            started = true;
            $this.o6a_1.u5t();
          } else if ($this.r6a_1.w15() >= imul($this.s6a_1, 2)) {
            while ($this.r6a_1.w15() >= $this.s6a_1) {
              // Inline function 'korlibs.time.milliseconds' call
              // Inline function 'kotlin.time.Companion.milliseconds' call
              Companion_getInstance();
              var tmp$ret$9 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
              var tmp_5 = delay(tmp$ret$9, $completion);
              if (tmp_5 === get_COROUTINE_SUSPENDED())
                tmp_5 = yield tmp_5;
            }
          }
        }
        var tmp_6 = yield_0($completion);
        if (tmp_6 === get_COROUTINE_SUSPENDED())
          tmp_6 = yield tmp_6;
        if (stream.p62())
          break $l$loop;
      }
      var tmp_7 = yield_0($completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
      $this.n6a_1._v = new PlaybackTimes(_PlaybackTimes___get_oneLess__impl__ea0jl8($this.n6a_1._v.c68_1));
    }
    $this.t6a_1._v = true;
    var n = 0;
    $l$loop_0: while (true) {
      var tmp_8;
      if ($this.o6a_1.f5t_1 && $this.r6a_1.w15() > 0) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp_8 = _unary__edvuaz < 8;
      } else {
        tmp_8 = false;
      }
      if (!tmp_8) {
        break $l$loop_0;
      }
      var tmp_9 = delay_0(new Long(10, 0), $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
    }
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      var tmp42_safe_receiver = $this.l6a_1.x67_1;
      if (tmp42_safe_receiver == null)
        null;
      else
        tmp42_safe_receiver();
    } else {
      throw $p;
    }
  }
  finally {
    $this.o6a_1.v5t();
    if ($this.j6a_1.f6a_1) {
      stream.n6();
    }
    $this.m6a_1._v = false;
    Companion_getInstance_16().v6a_1.a2u($this.u6a_1);
    var tmp43_safe_receiver = $this.l6a_1.y67_1;
    if (tmp43_safe_receiver == null)
      null;
    else
      tmp43_safe_receiver();
    var tmp44_safe_receiver = $this.j6a_1.h6a_1;
    if (tmp44_safe_receiver == null)
      null;
    else {
      var tmp_10 = tmp44_safe_receiver($completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
    }
  }
  return Unit_instance;
}
var Companion_instance_13;
function Companion_getInstance_16() {
  if (Companion_instance_13 === VOID)
    new Companion_12();
  return Companion_instance_13;
}
function SoundAudioStream$play$lambda($dequeLock, $flushing, $deque, $BUFFER_SAMPLES) {
  return function (it) {
    AudioSampleArray__fill$default_impl_gh9lh0(it.n5t_1, Companion_getInstance_1().o5t_1);
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = $dequeLock;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.i1y();
      try {
        if ($flushing._v || $deque.w15() >= $BUFFER_SAMPLES) {
          $deque.n67(it);
        }
        break $l$block;
      }finally {
        this_0.k1y();
      }
    }
    return Unit_instance;
  };
}
function SoundAudioStream$play$slambda_0(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId) {
  var i = new SoundAudioStream$play$slambda(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId);
  var l = function ($this$launch, $completion) {
    return i.k1q($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function volume$factory_2($b0) {
  return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
    return $b0.c5t_1;
  }, function (value) {
    $b0.c5t_1 = value;
    return Unit_instance;
  });
}
function pitch$factory_2($b0) {
  return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
    return $b0.x5t();
  }, function (value) {
    return $b0.w5t(value);
  });
}
function panning$factory_2($b0) {
  return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
    return $b0.d5t_1;
  }, function (value) {
    $b0.d5t_1 = value;
    return Unit_instance;
  });
}
function volume$factory_3() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.q5t();
  }, function (receiver, value) {
    return receiver.p5t(value);
  });
}
function volume$factory_4() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.q5t();
  }, function (receiver, value) {
    return receiver.p5t(value);
  });
}
function pitch$factory_3() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.x5t();
  }, function (receiver, value) {
    return receiver.w5t(value);
  });
}
function pitch$factory_4() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.x5t();
  }, function (receiver, value) {
    return receiver.w5t(value);
  });
}
function panning$factory_3() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.s5t();
  }, function (receiver, value) {
    return receiver.r5t(value);
  });
}
function panning$factory_4() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.s5t();
  }, function (receiver, value) {
    return receiver.r5t(value);
  });
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AudioFormat, 'AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(AudioFormats, 'AudioFormats', AudioFormats, VOID, VOID, [2, 4]);
initMetadataForClass(Info, 'Info', Info);
initMetadataForLambda(AudioFormat$decodeStream$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(AudioDecodingProps, 'AudioDecodingProps', AudioDecodingProps);
initMetadataForClass(InvalidAudioFormatException, 'InvalidAudioFormatException');
initMetadataForClass(MP3Base, 'MP3Base', MP3Base, VOID, VOID, [2, 4]);
initMetadataForClass(MP3, 'MP3', MP3, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_1, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(ChannelMode, 'ChannelMode');
initMetadataForClass(Mp3Info, 'Mp3Info');
initMetadataForCompanion(Companion_3, VOID, VOID, [1]);
initMetadataForClass(SeekingTable, 'SeekingTable');
initMetadataForClass(Parser, 'Parser', VOID, VOID, VOID, [0, 2, 3, 1]);
initMetadataForClass(MP3Decoder, 'MP3Decoder', MP3Decoder, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_4, VOID, VOID, [2, 4]);
initMetadataForClass(MiniMp3Program, 'MiniMp3Program', MiniMp3Program);
initMetadataForClass(Minimp3Decoder, 'Minimp3Decoder', Minimp3Decoder, VOID, [MiniMp3Program, AutoCloseable]);
initMetadataForClass(BaseMinimp3AudioFormat, 'BaseMinimp3AudioFormat', VOID, VOID, VOID, [2, 3, 4]);
initMetadataForObject(Minimp3AudioFormat, 'Minimp3AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(BaseMp3DecoderInfo, 'BaseMp3DecoderInfo', BaseMp3DecoderInfo);
initMetadataForCompanion(Companion_5);
initMetadataForClass(AudioStream, 'AudioStream', VOID, VOID, [AutoCloseable], [1, 3, 0]);
initMetadataForClass(BaseMinimp3AudioFormat$createDecoderStream$2, VOID, VOID, VOID, VOID, [1, 3, 0]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(L12_subband_alloc_tStruct, 'L12_subband_alloc_tStruct');
initMetadataForClass(Mp3Dec, 'Mp3Dec', Mp3Dec.i5y);
initMetadataForClass(Bs, 'Bs', Bs);
initMetadataForClass(Mp3Scratch, 'Mp3Scratch', Mp3Scratch.n64);
initMetadataForClass(Mp3FrameInfo, 'Mp3FrameInfo', Mp3FrameInfo);
initMetadataForClass(ArrayPtr, 'ArrayPtr');
initMetadataForClass(UByteArrayIntPtr, 'UByteArrayIntPtr');
initMetadataForClass(FloatArrayPtr, 'FloatArrayPtr');
initMetadataForClass(ShortArrayPtr, 'ShortArrayPtr');
initMetadataForClass(GrInfo, 'GrInfo', GrInfo);
initMetadataForClass(ScaleInfo, 'ScaleInfo', ScaleInfo);
initMetadataForClass(WAV, 'WAV', WAV, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_7, VOID, VOID, [2, 4]);
initMetadataForClass(Chunk, 'Chunk');
initMetadataForClass(ProcessedChunk, 'ProcessedChunk');
initMetadataForClass(WavAudioStream, 'WavAudioStream', VOID, VOID, VOID, [1, 3, 0]);
initMetadataForClass(Fmt, 'Fmt', Fmt);
initMetadataForLambda(WAV$parse$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(AudioSamplesDeque, 'AudioSamplesDeque');
initMetadataForCompanion(Companion_9);
initMetadataForLambda(createSound$slambda, VOID, VOID, [0]);
initMetadataForCompanion(Companion_10);
initMetadataForClass(PlaybackParameters, 'PlaybackParameters', PlaybackParameters, VOID, [ReadonlySoundProps]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(PlaybackTimes, 'PlaybackTimes');
initMetadataForInterface(SoundPlay, 'SoundPlay', VOID, VOID, VOID, [1, 2, 3]);
protoOf(Sound).n68 = play;
initMetadataForClass(Sound, 'Sound', VOID, VOID, [SoundProps, SoundPlay], [1, 0, 2, 3]);
initMetadataForClass(SoundChannel, 'SoundChannel', VOID, VOID, [SoundProps]);
initMetadataForClass(SoundAudioData$play$4);
initMetadataForClass(SoundAudioData, 'SoundAudioData', VOID, VOID, VOID, [1, 2, 0, 3]);
initMetadataForCompanion(Companion_12);
initMetadataForLambda(SoundAudioStream$play$slambda, VOID, VOID, [1]);
initMetadataForClass(SoundAudioStream$play$1);
initMetadataForClass(SoundAudioStream, 'SoundAudioStream', VOID, VOID, VOID, [1, 0, 2, 3]);
//endregion
//region block: init
Companion_instance_0 = new Companion();
Companion_instance_9 = new Companion_8();
DEFAULT_MAX_SAMPLES = 39690000;
Companion_instance_10 = new Companion_9();
//endregion
//region block: exports
export {
  readSound as readSoundcwkqnndcldwa,
  PlaybackParameters as PlaybackParametersw3tmyruspy4s,
};
//endregion
